/*eslint quote-props: ["error", "always"]*/

const en: Record<string, string> = {
  "1XX_information": "1XX Information",
  "1_user": "One user",
  "1_website": "One production website",
  "2XX_success": "2XX Success",
  "3XX_redirect": "3XX Redirect",
  "3_dev": "Three live development environments",
  "4XX_client_error": "4XX Client error",
  "5XX_server_error": "5XX Server error",
  "5_gb_storage": "5 GB of storage",
  "Organizations.security.mfa.setup.actions.cancel": "Cancel",
  "Organizations.security.mfa.setup.actions.save": "Verify & Save",
  WCAG: "WCAG",
  accept: "Accept",
  "access.admin": "Admin",
  "access.alert":
    "For the changes to apply to SSH access, you need to redeploy each environment.",
  "access.all": "All permissions",
  "access.already_exists":
    "<b>{user}</b> has already been added to this <b>{project}</b>",
  "access.apply_all": "Apply to all",
  "access.billing": "Manage billing",
  "access.environment.description":
    " Add a new user to your environment and assign their permission level.",
  "access.environment.permissions": "Environment permissions",
  "access.environment.permissions.env": "Environment",
  "access.environment.permissions.env_types": "Environment types",
  "access.environment.permissions.type": "Permission type",
  "access.environment.show.less": "Show less",
  "access.environment.show.more": "Show all +{numbers}",
  "access.environment_types.description":
    "Roles are set per environment type. e.g. when you set the role of a user as viewer on a development environment type, they will inherit that role on all other development environment types.",
  "access.environment_types.permissions": "Environment type roles",
  "access.help.text.a": "Learn more about Project and User permissions in our",
  "access.help.text.b": "documentation",
  "access.members": "Manage users",
  "access.options.admin": "Admin",
  "access.options.contributor": "Contributor",
  "access.options.development": "Development",
  "access.options.no-access": "No access",
  "access.options.no_access": "No access",
  "access.options.production": "Production",
  "access.options.select_permission": "Select role",
  "access.options.staging": "Staging",
  "access.options.viewer": "Viewer",
  "access.owner": "Admin (Owner)",
  "access.plans": "Manage plans",
  "access.project.description":
    "Add a new user to your project and assign their permission levels for each environment.",
  "access.project.permissions": "Project roles",
  "access.project_admin": "Project admin",
  "access.projects:create": "Create projects",
  "access.projects:list": "List projects",
  "access.removeUserModalBody": "Yes, remove user access to this project for",
  "access.removeUserModalTitle": "Are you sure you want to remove this user?",
  "access.team.bulk.fulfilled.description":
    "Project added to {count} {count, plural, one{team} other{teams}}.",
  "access.team.bulk.fulfilled.title": "Access updated",
  "access.team.delete.modal.description":
    "Are you sure you want to remove the team <b>{teamname}</b> from the project <b>{projectname}</b>?",
  "access.team.delete.modal.notification.description":
    "<b>{projectname}</b> removed from <b>{teamname}</b>",
  "access.team.delete.modal.notification.title": "Project removed from team",
  "access.title": "Access",
  access_your_application_container: "Access your application container using",
  access_your_worker_container: "Access your worker container using",
  "account.connect": "connect {accountName}",
  "account.connected": "{accountName} is connected",
  "account_details.add_billing_user": "Add user",
  "account_details.add_payment_method": "Add payment method",
  "account_details.backup_method": "Back up method",
  "account_details.billing_access_description":
    "Manage who can view or edit billing details for this billing profile.",
  "account_details.billing_address": "Billing address",
  "account_details.billing_details": "Billing details",
  "account_details.billing_users": "Billing access",
  "account_details.contact": "Contact",
  "account_details.currency": "Currency",
  "account_details.default": "Default",
  "account_details.details": "Details",
  "account_details.edit": "Edit",
  "account_details.email": "Email",
  "account_details.error_loading":
    "Failed to load account details. Please try again.",
  "account_details.frequency": "Frequency",
  "account_details.invite_user": "Invite user",
  "account_details.monthly": "Monthly",
  "account_details.name": "Name",
  "account_details.no_billing_users": "No billing users found.",
  "account_details.no_billing_users_description":
    "Billing users can manage invoices and payments for this billing profile.",
  "account_details.no_billing_users_title": "No billing users yet",
  "account_details.no_payment_methods": "No payment methods found.",
  "account_details.no_payment_methods_description":
    "Add a card or bank account to pay invoices and keep your services running.",
  "account_details.no_payment_methods_title": "No payment method yet",
  "account_details.payment_method": "Payment method",
  "account_details.payment_methods": "Payment methods",
  "account_details.permission_create_organizations": "Create organizations",
  "account_details.permission_manage": "Manage Billing",
  "account_details.permission_view": "View Billing",
  "account_details.permissions": "Permissions",
  "account_details.update": "Update",
  "account_overview.error_loading_account":
    "Failed to load billing account. Please try again.",
  account_settings: "account settings",
  account_type: "Account type",
  "account_type.container.header":
    "Choose an account type to decide which previously entered information is retained.",
  "account_type.selection.description":
    "Your selection determines which information is needed for billing.",
  "account_type.selection.title": "Select an account type",
  "account_type.used_for.company":
    "(Used for <strong>Company</strong> or <strong>Public sector</strong> selection)",
  "account_type.used_for.individual":
    "(Used for <strong>Individual</strong> selection)",
  "account_type.warning.company_removed":
    "* This account type doesn't use company information. Your <strong>Company name</strong> will be removed if you continue.",
  "account_type.warning.individual_removed":
    "* This account type doesn't use individual information. Your <strong>Full name</strong> will be removed if you continue.",
  accounts_settings: "accounts settings",
  "actions.description":
    "Create a byte-level copy of {environmentName} cluster with all of its code, data and services.",
  activate_button: "Reactivate environment",
  activate_environment: "Activate environment",
  activated_environment: "activated environment",
  active: "active",
  "activities.empty": "No activity",
  "activities.empty.all": "You have no recent activities",
  "activities.empty.pending": "You have no pending activities",
  "activities.empty.running": "You have no running activities",
  "activities.empty.staged": "You have no staged activities",
  "activities.headers.pending": "Pending",
  "activities.headers.recent": "Past",
  "activities.headers.running": "Running",
  "activities.headers.staged": "Staged ",
  "activities.headers.staged.description":
    " You must trigger a deployment for these changes to be applied",
  "activities.more": "Show more",
  "activities.staged.failed.tooltip": "Last activity failed. Check the log.",
  "activities.staged.tooltip":
    "This change will be applied when you trigger a deployment",
  "activities.staged.warning.tooltip":
    "Last activity completed with warnings. Check the log.",
  "activities.tabs.all": "All",
  "activities.tabs.recent": "Recent",
  "activities.update_filters":
    "Update your filters to show other activity types.",
  activity: "Activity",
  "activity.cancel_button": "Cancel",
  // Replaces the build-hook note for agent runs: a task container has no build
  // hook, and stopping one is neither immediate nor free. Measured on CON-1624:
  // 21-44 seconds from the cancel to the activity reaching `cancelled`, with the
  // agent still working — and sometimes finishing — throughout.
  //
  // Wording signed off on DP-775 by product and docs; change it there, not here.
  // The approved sentence opened with "Cancellation received.", which is dropped
  // because this note renders BEFORE the confirm button, not after it.
  "activity.cancel_modal.agent_note":
    "The agent may take up to a minute to stop and use additional compute during that time.",
  "activity.cancel_modal.cancel": "No, not now",
  "activity.cancel_modal.cancel_operation": "Yes, cancel activity",
  "activity.cancel_modal.error.description":
    "This operation can not be cancelled as the build hook has already completed.",
  "activity.cancel_modal.error.header": "This operation can not be cancelled",
  "activity.cancel_modal.error.learn_more": "Learn more",
  "activity.cancel_modal.error.okay": "Okay",
  "activity.cancel_modal.header": "Cancel activity",
  "activity.cancel_modal.note":
    "Note: If the build hook has completed, this operation can not be cancelled",
  "activity.cancel_operation_modal.description":
    "Are you sure you want to cancel the activity: <name>{activityName}</name> on <target>{branch}</target>?",
  "activity.cancellable_tooltip":
    "This activity can only be cancelled while running the building hook",
  "activity.downscale.title":
    "<strong>Downscale: </strong> 1 instance removed from {service}",
  "activity.loading": "Loading...",
  "activity.log_button": "View log",
  "activity.no.scaling": "<strong>No scaling: </strong>",
  "activity.no_description": "No description",
  "activity.not_cancellable_tooltip":
    "This type of activity cannot be cancelled",
  "activity.reschedule": "Reschedule",
  "activity.restore_button": "Restore",
  "activity.scaling": "<strong>Scaling:  </strong>",
  "activity.scheduled_for": "Scheduled for",
  "activity.showMore": "Show more",
  "activity.show_failed_activities_only": "Show only failed",
  "activity.sticker.paused.environment":
    "The environment is paused. <ctaLink>Resume environment</ctaLink> or learn more in our<infoLink>docs</infoLink>.",
  "activity.suspend.suspended": "suspended",
  "activity.upscale.title":
    "<strong>Upscale: </strong> 1 instance added to {service}",
  activity_log: "Activity log",
  activity_template_on: "on",
  add: "Add",
  "add.n.instances": "Add 1 instance",
  "add.n.instances.when.down": "When average {metric} is ≤",
  "add.n.instances.when.up": "When average {metric} is ≥",
  "add.to.project": "Add to project",
  "add_billing_users.billing_profile": "Billing profile",
  "add_billing_users.cancel": "Cancel",
  "add_billing_users.clear_all": "Clear all",
  "add_billing_users.email_placeholder":
    "Enter one or more email addresses, separated by commas.",
  "add_billing_users.invite": "Invite",
  "add_billing_users.note":
    "Note: Adding users with billing-only access {bold} and won't increase your monthly cost.",
  "add_billing_users.note_free": "is free",
  "add_billing_users.permission_assign_products":
    "Assign products to billing profile",
  "add_billing_users.permission_manage": "Manage billing",
  "add_billing_users.permission_view": "View billing",
  "add_billing_users.permissions": "Permissions",
  "add_billing_users.subtitle":
    "Grant team members (like your Finance team) access to billing info for the {profileName} billing profile.",
  "add_billing_users.title": "Invite billing members",
  "add_billing_users.users_count":
    "{count, plural, one {# user} other {# users}}",
  add_certificate: "Add certificate",
  add_custom_domain: "add domain",
  add_domain: "add",
  add_environment_type: "add environment type",
  add_environment_variable: "Add environment variable",
  add_integration_to_project:
    "Connect a Git service, health checks, or webhooks to your project",
  add_login: "add login",
  add_member: "add member",
  add_members: "add members",
  add_new_access: "add new access",
  "add_on.continous_profile_retain_message":
    "Retain 30 days of continuous profiling data.",
  "add_on.continous_profiling_add_on": "Continuous profiling add-on",
  "add_on.continous_profiling_enable_description":
    "Upgrade to retain continuous profiling data for 30 days.",
  "add_on.continous_profiling_enabled.description.advanced":
    "You're now retaining 30 days of continuous profiling data. This add-on will appear in your current month’s projection within the next hour.",
  "add_on.continous_profiling_enabled.description.standard":
    "You've downgraded from Advanced to Standard. You're now only retaining 15 minutes of continuous profiling data. This change will be reflected in your current month’s projection within the next hour.",
  "add_on.continous_profiling_enabled.title.advanced":
    "Advanced continuous profiling enabled",
  "add_on.continous_profiling_enabled.title.standard":
    "Downgraded to Standard Continuous Profiling",
  add_on_invite_modal_note:
    "Users are automatically assigned all organization permissions. To customize permissions, you need to",
  "add_on_invite_modal_note.with_addon":
    "You can only assign permissions that you have been granted.",
  add_ons: "add-ons",
  add_ons_description: "can be added to your project as needed.",
  add_project: "add project",
  add_projects: "Add projects",
  add_route: "add route",
  add_ssh_key: "Add SSH key",
  add_sshkey: "add ssh key",
  add_team: "add team",
  add_user: "add user",
  add_user_agreement:
    "I understand that adding user licenses will result in additional charges applied to the project's monthly bill.",
  add_user_organization:
    "Enter one or more email addresses to invite users to your organization. Separate multiple addresses with commas.",
  add_users: "Add users",
  add_variable: "Add variable",
  added: "added",
  added_domain: "added domain",
  added_environment_variable: "added environment variable",
  added_project_variable: "added project variable",
  added_route: "added route",
  address: "Address line 1",
  address2: "Address line 2",
  admin_change: "Ask your project admin to make a change",
  admin_tag: "Admin",
  "agent_report.empty": "No report was produced for this task.",
  "agent_report.error": "The agent run failed",
  "agent_report.load_error": "The report could not be loaded.",
  "agent_report.loading": "Loading report…",
  "agent_report.waiting": "Report will appear when the task completes…",
  "ai_consent.cta": "Generate config",
  "ai_consent.description":
    "Upsun uses a YAML configuration file to build and deploy your apps and services. You can use our AI tool to generate a starter configuration that you can build on, or you can write your configuration manually by following our <link>documentation</link>.",
  "ai_consent.documentation_url":
    "https://developer.upsun.com/docs/get-started#get-started-quickly",
  "ai_consent.loading": "Just a moment, we're getting started",
  "ai_consent.notice":
    "By clicking below, you consent to let Upsun send a sanitized repository digest to OpenAI for analysis to generate a starter configuration. No code is modified, stored, or used for training.",
  "ai_consent.title": "Configure your apps for Upsun",
  all: "All",
  all_data_lost_warning:
    "ALL DATA IN THIS ENVIRONMENT WILL BE IRREVOCABLY LOST",
  all_free_trial_include: "all free trials include",
  all_hosts: "All hosts",
  all_include: "Our plans include",
  all_operations: "Operations",
  all_plans: "All plans",
  all_projects: "All projects",
  all_systems_operational: "all systems operational",
  all_type: "Show all",
  allocation: "Allocation",
  already_have_account: "already have an account?",
  "announcements.back": "Back",
  "announcements.gotit": "Got it!",
  "announcements.markallread": "Mark all as read",
  "announcements.requestfeature": "Request a feature",
  "announcements.unread": "unread",
  "announcements.viewall": "View all",
  "announcements.whatsnew": "What's new",
  api_token: "API Token",
  "api_token.delete": "Delete",
  api_token_add_success: "API Token {tokenName} has been successfully created.",
  api_token_create: "Create API Token",
  api_token_create_help_text:
    "An API token can be exchanged for an OAuth 2 access token, which can then be used to authenticate requests.",
  api_token_delete_warning:
    "Are you sure you want to delete API Token {tokenName}? This action can not be undone.",
  api_token_exists: "An API Token with this name already exists.",
  api_token_help_text:
    "Use API Tokens to access {appName} from other CI services or automation tools.",
  api_token_info_text:
    "To learn more about configuring your API tokens, view our {cta}.",
  api_tokens: "API Tokens",
  app: "App",
  app_applications_file_path: ".platform/applications.yaml",
  app_config_file: ".platform.app.yaml",
  app_environment_variable_name: "$PLATFORM_VARIABLES",
  app_manager: "App manager",
  app_name: "Platform.sh",
  app_routes_file_path: ".platform/routes.yaml",
  app_service_file_path: ".platform/service.yaml",
  app_services_file_path: ".platform/services.yaml",
  application_webworker: "Application / worker",
  applications: "Application/s",
  apply: "Apply",
  apps: "Apps",
  apps_services: "Apps & Services",
  april: "April",
  are_you_sure_disconnect_provider:
    "Are you sure you want to disconnect your <b>{provider}</b> account?",
  attempt_create_backup: "attempted to create a backup",
  august: "August",
  "auth.401.mfa":
    "For security purposes, you will be redirected to set up MFA.",
  "auth.401.org_sso":
    "For security purposes, you will be redirected to set up SSO.",
  "auth.401.recent_auth":
    "For security purposes, you will be redirected to verify your password.",
  "auth.401.title": "Re-authentication required",
  "auth.401.title.org_sso": "SSO required",
  "auth.401.title.recent_auth": "Re-authentication required",
  "auth.brandmerger.login_notice":
    "Log in with your Platform.sh credentials to access your account now on Upsun.",
  "auth.left_panel.description":
    "Do more with {appName}. Quickly build, run, and scale all your applications—on a single platform.",
  "auth.left_panel.disclaimer":
    "*Limited to USD $100 resource usage/resource limitation, or equivalent in AUD, CAD, EUR, GBP, depending on the billing currency applicable to your account",
  "auth.left_panel.items":
    "<item>Composable infrastructure</item><item>Preview environments (including all your data) in seconds</item><item>Built-in security and observability</item><item>On any major cloud provider</item><item>Stack agnostic: Python, Node.js, PHP, and 70+ more</item>",
  "auth.left_panel.title":
    "A highly flexible PaaS to develop diverse applications",
  "automatic_org.loading": "// Upsun engine initializing",
  automatically_provisioned:
    "Automatically provisioned services (e.g., MySQL, Postgres, Redis, Elastic Search)",
  autoscaling: "Autoscaling",
  "autoscaling.configure": "Configure",
  "autoscaling.configure.label.application": "Application",
  "autoscaling.configure.label.service": "Service",
  "autoscaling.configure.label.worker": "Worker",
  "autoscaling.cooldown.description":
    "Scaling will not be triggered until cool-down period is complete, even if threshold durations are met.",
  "autoscaling.enable": "Enable",
  "autoscaling.generic.error.message":
    "An error appeared while saving your changes. Please check the values and try again.",
  "autoscaling.instances.badge.dialog.description":
    "This application will scale based on the average percentage of usage against the allocated resources.",
  "autoscaling.instances.badge.dialog.title": "Horizontal autoscaling enabled",
  "autoscaling.instances.description":
    "Ensure a baseline capacity and prevent runaway scaling.",
  "autoscaling.permission.request":
    "Ask your project admin to update the autoscaling configurations on this environment.",
  "autoscaling.triggers.description":
    "A scaling activity will be triggered when any of the enabled thresholds are breached for the set duration.",
  "autoscaling.triggers.title": "Triggers",
  autoscaling_not_available: "Autoscaling is not available",
  autoscaling_not_for_services: "Autoscaling is not available for services",
  autoscaling_not_for_workers: "Autoscaling is not available for workers",
  average: "Average",
  back: "Back",
  "back.access": " to Access",
  "back.billing_details": " to Billing details",
  "back.bitbucket": " to Bitbucket",
  "back.bitbucket_server": " to Bitbucket Server",
  "back.domains": "to Domains",
  "back.environment": " to Environment",
  "back.github": " to GitHub",
  "back.gitlab": " to GitLab",
  "back.health.email": " to Email",
  "back.health.pagerduty": " to Pagerduty",
  "back.health.slack": " to Slack",
  "back.health.webhook": " to Webhook",
  "back.httplog": "to HTTP Log",
  "back.integrations": " to Integrations",
  "back.invoices": " to Invoices",
  "back.newrelic": "to NewRelic",
  "back.plans": " to Plans",
  "back.profiling": "to Profiling",
  "back.project": " to Project",
  "back.project_settings": " to Project settings",
  "back.projects": " to Projects",
  "back.script": " to script",
  "back.security": " to security",
  "back.splunk": "to Splunk",
  "back.sumologic": "to Sumo Logic",
  "back.syslog": "to Syslog",
  "back.teams": "to Teams",
  "back.tickets": " to Tickets",
  "back.vouchers": "to vouchers",
  "back.webhook": " to custom Webhook",
  back_to: "Back to",
  back_to_console: "Back to console",
  back_to_integrations: "Back to Integrations",
  back_to_projects: "Back to projects",
  back_to_users: "Back to users",
  backup: "Backup",
  "backup.button": "Backup",
  "backup.delete_button": "Delete",
  "backup.restore.modal.title": "Restore from backup",
  "backup.restore_button": "Restore",
  "backup.title": "Backup",
  "backup_schedule.agreement":
    "I understand that changes made will be applied to all environments of this type, and reducing the number of backups could delete older backups.",
  "backup_schedule.btn.remove": "Remove",
  "backup_schedule.btn.revert": "Revert to default",
  "backup_schedule.column.backups.label": "#Backups",
  "backup_schedule.column.every.label": "Take backups every",
  "backup_schedule.column.interval.label": "Backup interval",
  "backup_schedule.column.maximum": "Maximum {maxBackups}",
  "backup_schedule.column.placeholder": "#",
  "backup_schedule.column.stored.label": "Total backups stored",
  "backup_schedule.column.up_to.label": "and store up to a total of",
  "backup_schedule.column.up_to.placeholder": "Select",
  "backup_schedule.description":
    "Customize multiple backups by environment type to suit your needs. Backup schedule intervals must be configured in clean multiples (2,4,6) rather than (2,5,7). Please note that the size, frequency and retention policy you set will impact your backup storage costs. Learn more in our <link>Documentation</link>.",
  "backup_schedule.environment_type.label": "Environment type",
  "backup_schedule.max_manual_backups.label": "Maximum manual backups",
  "backup_schedule.max_manual_backups.tooltip.description":
    "Set the number manual backups that can be stored before new manual backups will overwrite the oldest.",
  "backup_schedule.max_manual_backups.tooltip.title": "Maximum manual backups",
  "backup_schedule.note":
    "Note: Customizing your backup schedule will impact your monthly project cost. <link>View pricing page</link>",
  "backup_schedule.notify.description":
    "The backup schedule for {environmentType} environments was successfully updated.",
  "backup_schedule.notify.title": "Backup schedule has been updated",
  "backup_schedule.row.name": "Schedule {number}",
  "backup_schedule.row.name.dialog.description":
    "Backup intervals must be multiples of one another. E.g., if set at every 2 hrs, the next interval would be 4 or 6 hrs.",
  "backup_schedule.row.name.dialog.example.description.1":
    "2 hrs, 4 hrs, 8 hrs",
  "backup_schedule.row.name.dialog.example.description.2":
    "1 day, 1 wk (7 days), 2 wks (14 days)",
  "backup_schedule.row.name.dialog.example.title": "Example:",
  "backup_schedule.row.name.dialog.invalid.example.description.1":
    "2 hrs, 5 hrs, 8 hrs",
  "backup_schedule.row.name.dialog.invalid.example.description.2":
    "3 days, 10 days, 2 wks (14 days)",
  "backup_schedule.row.name.dialog.invalid.example.title": "Invalid example:",
  "backup_schedule.row.name.dialog.title": "Backup scheduling",
  "backup_schedule.row.name.error":
    "Intervals must be a multiple of one another",
  "backup_schedule.title": "Manage backup schedule",
  backup_scheduling: "backup scheduling",
  backups: "Backups",
  "backups.cost.perGB": "Cost per GB (in {currency})",
  "backups.daily.duration": "Daily backups stored for 1 week",
  "backups.delete.modal.description.automated":
    "Are you sure you want to delete the automated backup <strong>{id}</strong> with expiration of <strong>{date}</strong>?",
  "backups.delete.modal.description.manual":
    "Are you sure you want to delete the manual backup <strong>{id}</strong>",
  "backups.delete.modal.learn": "Learn more",
  "backups.delete.modal.note.automated":
    "Note: This action can not be undone and could affect your backup retention schedule. <a>{learnMore}</a>",
  "backups.delete.modal.note.manual": "Note: This action can not be undone.",
  "backups.delete.modal.title.automated": "Delete automated backup",
  "backups.delete.modal.title.manual": "Delete manual backup",
  "backups.dropdown.Advanced.label": "Advanced",
  "backups.dropdown.Advanced.plan":
    "21 automated and 4 manual backups. {br}Each daily backup is stored for 1 week. {br}Each weekly backup is stored for 1 month. {br}Each monthly backup is stored for 1 year.",
  "backups.dropdown.Basic.plan":
    "Automated backups are stored for 2 days. You can store up to 2 manual backups at any time.",
  "backups.dropdown.Premium.label": "Premium",
  "backups.dropdown.Premium.plan":
    "44 automated backups and 4 manual backups. {br}Each 6-hourly backup is stored for 1 day. {br}Each daily backup is stored for 1 month. {br}Each monthly backup is stored for 1 year.",
  "backups.enterprise.only": "Enterprise only",
  "backups.frequency": "Backup frequency",
  "backups.modal.reached.max.note":
    "Note: This backup will replace your oldest manual backup.",
  "backups.monthly.duration": "Monthly backups stored for 1 year",
  "backups.panel.header": "Backups cost breakdown",
  "backups.panel.info":
    "{estimation} per GB of storage on your production environment. Development environments remain on the Default plan.",
  "backups.restore.modal.action": "Yes, restore",
  "backups.restore.modal.title": "Restore from backup",
  "backups.restore.modal1":
    "Are you sure you want to restore the backup {br}<strong>{id}</strong> created <strong>{created_at}</strong> with commit ID <strong>{commit_id}</strong>?",
  "backups.restore.modal2":
    "This will delete and then overwrite all data from all running services and files of the {environment} environment.",
  "backups.restore.modal3": "Note: this action can not be undone.",
  "backups.six.hourly.duration": "4 daily backups stored for 1 day",
  "backups.storage": "Storage on Master (in GB)",
  "backups.storage.duration": "Backup storage duration",
  "backups.type.automated": "Automated Backups",
  "backups.type.manual": "Manual Backups",
  "backups.weekly.duration": "Weekly backups stored for 1 month",
  bandwidth: "Bandwidth",
  bandwidth_mb_sec: "bandwidth MB/sec",
  bank_account: "Bank account",
  bank_account_number: "IBAN",
  bank_account_payments: "Bank account payments",
  "banner.dunning.deleted_days.ask":
    "Your projects are suspended and will be deleted in {num} days if we cannot process your payment. Ask your organization owner to update your billing details.",
  "banner.dunning.deleted_days.update":
    "Your projects are suspended and will be deleted in {num} days if we cannot process your payment. Please update your billing details.",
  "banner.dunning.deleted_tomorrow.ask":
    "Your projects are suspended and will be deleted tomorrow if we cannot process your payment. Ask your organization owner to update your billing details.",
  "banner.dunning.deleted_tomorrow.update":
    "Your projects are suspended and will be deleted tomorrow if we cannot process your payment. Please update your billing details.",
  "banner.dunning.deleted_within_day.ask":
    "Your projects are suspended and will be deleted within the day if we cannot process your payment. Ask your organization owner to update your billing details.",
  "banner.dunning.deleted_within_day.update":
    "Your projects are suspended and will be deleted within the day if we cannot process your payment. Please update your billing details.",
  "banner.dunning.suspended.ask":
    "Your organization has been suspended. Ask your organization owner to update billing details to unlock your {appName} account.",
  "banner.dunning.suspended.update":
    "Your organization has been suspended. Update billing details to unlock your {appName} account.",
  "banner.dunning.suspended_days.ask":
    "Payment failed - ask your organization owner to update your payment method to keep your projects from being suspended in {num} days.",
  "banner.dunning.suspended_days.update":
    "Payment failed - update your payment method to keep your projects from being suspended in {num} days.",
  "banner.dunning.suspended_tomorrow.ask":
    "Payment failed - ask your organization owner to update your payment method to keep your projects from being suspended tomorrow.",
  "banner.dunning.suspended_tomorrow.update":
    "Payment failed - update your payment method to keep your projects from being suspended tomorrow.",
  "banner.dunning.suspended_within_day.ask":
    "Payment failed - ask your organization owner to update your payment method to keep your projects from being suspended within the day.",
  "banner.dunning.suspended_within_day.update":
    "Payment failed - update your payment method to keep your projects from being suspended within the day.",
  "banner.payment_failed":
    "Payment method failed. Update your <a>billing details</a> to keep your projects running.",
  "banner.payment_missing":
    "Payment method missing. Add your <a>billing details</a> to keep your projects running.",
  "banner.reactivate": "Reactivate trial",
  "banner.reactivate.description":
    "I would like to speak to the sales team about extending my trial, please.",
  "banner.reactivate.subject": "Trial extension request",
  "banner.subscribe": "Subscribe",
  "banner.trial.create_project_page":
    "<billingIcon></billingIcon> Make the most of your free trial by creating a new project! ({daysRemaining} {daysRemaining, plural, one{day} other{days}} remaining) <learnMore>Learn more</learnMore>",
  "banner.trial.state_1":
    "Enjoy your free trial. <linkBilling>Upgrade</linkBilling> your plan at any time when you’re ready to go live!",
  "banner.trial.state_2":
    "Your free trial is ending soon. <linkBilling>Upgrade</linkBilling> your plan to keep your projects running!",
  "banner.trial.state_3":
    "Your free trial has expired, please add your <linkBilling>billing details</linkBilling> to keep your projects running.",
  "banner.trial.state_4":
    "Payment method missing. Add your <linkBilling>billing details</linkBilling> to keep your projects running.",
  "banner.trial_limit":
    "Enjoy your trial! To unlock more projects and resources, please consider subscribing to {app_name}.",
  "banner.trial_limit.no_billing_permission":
    "Enjoy your trial! To unlock more projects and resources, contact your organization owner to subscribe to {app_name}.",
  "banner.update_code_description":
    "Always keep the source code of all your applications and their dependencies up to date",
  "banner.update_code_title": "Automated code updates",
  basic_settings: "basic settings",
  basic_ssh: "basic SSH.",
  "before.adding.more": "after scaling before adding more instances.",
  "before.removing.more": "after scaling before removing more instances.",
  big_dev_desc:
    "Select the size for your development environment application containers",
  big_dev_title: "Environments application size",
  billing: "billing",
  "billing.add_a_payment_method": "Add a payment method",
  "billing.backup_payment_method": "Backup payment method",
  "billing.commitments": "",
  "billing.commitments.allocation.h1": "H1: {range}",
  "billing.commitments.allocation.h2": "H2: {range}",
  "billing.commitments.allocation.partially_used": "Partially used",
  "billing.commitments.allocation.q1": "Q1: {range}",
  "billing.commitments.allocation.q2": "Q2: {range}",
  "billing.commitments.allocation.q3": "Q3: {range}",
  "billing.commitments.allocation.q4": "Q4: {range}",
  "billing.commitments.allocation.used": "Used",
  "billing.commitments.allocation_breakdown.bi_annually":
    "Allocation breakdown (bi-annually)",
  "billing.commitments.allocation_breakdown.monthly": "Monthly allocation",
  "billing.commitments.allocation_breakdown.quarterly":
    "Allocation breakdown (quarterly)",
  "billing.commitments.allocation_breakdown.yearly":
    "Allocation breakdown (yearly)",
  "billing.commitments.bi_annually": "Bi-annually",
  "billing.commitments.bi_annually_commitment": "Bi-annual commitment",
  "billing.commitments.bi_annually_commitment.description":
    "A breakdown of the committed spend and discounts that can be expected on bi-annual invoices.",
  "billing.commitments.bi_annually_discount": "Bi-annual discount",
  "billing.commitments.commitment_details": "Commitment details",
  "billing.commitments.commitment_details.description":
    "Details shown are determined by the commitment structure agreed upon in the contract.",
  "billing.commitments.commitment_period": "Commitment period",
  "billing.commitments.commitment_period.description":
    "The duration in which the commitment must be reached.",
  "billing.commitments.commitment_value": "Commitment value",
  "billing.commitments.contract_ending": "Contract ending",
  "billing.commitments.contract_starting": "Contract starting",
  "billing.commitments.contract_total": "Contract total",
  "billing.commitments.contract_total.description":
    "A total of the committed spend and discounts for the entire duration of the contract.",
  "billing.commitments.credit_usage_to_date": "Credit usage to date",
  "billing.commitments.current_commitments": "Current commitments",
  "billing.commitments.current_commitments.description":
    "The commitments are based on contracts that are currently active.",
  "billing.commitments.discount_type": "Discount type",
  "billing.commitments.empty.intro":
    "Discounts and commitment details from your active contracts with {appName} will appear here.{br}To set up a commitment, contact your account manager.",
  "billing.commitments.empty.title": "No active commitments",
  "billing.commitments.explanation":
    "Earn the full value of your discount on your organizations spend by reaching your commitment. To change your commitment or discount structure contact your account manager. If you have questions regarding your invoice, you can reach out to the finance team.",
  "billing.commitments.monthly": "Monthly",
  "billing.commitments.monthly_commitment": "Monthly commitment",
  "billing.commitments.monthly_commitment.description":
    "A breakdown of the committed spend and discounts that can be expected on monthly invoices.",
  "billing.commitments.monthly_discount": "Monthly discount",
  "billing.commitments.net_commitment": "Net commitment",
  "billing.commitments.quarterly": "Quarterly",
  "billing.commitments.quarterly_commitment": "Quarterly commitment",
  "billing.commitments.quarterly_commitment.description":
    "A breakdown of the committed spend and discounts that can be expected on quarterly invoices.",
  "billing.commitments.quarterly_discount": "Quarterly discount",
  "billing.commitments.status.active": "Active",
  "billing.commitments.status.deactivated": "Deactivated",
  "billing.commitments.status.expired": "Expired",
  "billing.commitments.status.inactive": "Inactive",
  "billing.commitments.total_commitment_value": "Total commitment value",
  "billing.commitments.total_contract_duration": "Total contract duration",
  "billing.commitments.total_discount": "Total discount",
  "billing.commitments.total_net_commitment": "Total Net commitment",
  "billing.commitments.usage_error":
    "We couldn't load the latest usage details for this commitment. Some figures may be incomplete.",
  "billing.commitments.value_commitment": "{value} Commitment",
  "billing.commitments.value_commitment_per_x_months":
    "{value} commitment per {months} months",
  "billing.commitments.value_discount": "{value} discount",
  "billing.commitments.value_months":
    "{value} {value, plural, one {month} other {months}}",
  "billing.commitments.value_per_month": "{value} per month",
  "billing.commitments.value_per_month_commitment":
    "{value} per month commitment",
  "billing.commitments.value_per_quarter_commitment":
    "{value} per quarter commitment",
  "billing.commitments.value_per_six_months_commitment":
    "{value} per 6 months commitment",
  "billing.commitments.value_per_year_commitment":
    "{value} per year commitment",
  "billing.commitments.view_details": "View details",
  "billing.commitments.yearly": "Yearly",
  "billing.commitments.yearly_commitment": "Yearly commitment",
  "billing.commitments.yearly_commitment.description":
    "A breakdown of the committed spend and discounts that can be expected on yearly invoices.",
  "billing.commitments.yearly_discount": "Yearly discount",
  "billing.details": "details",
  "billing.details.add_funds_message":
    "To add more funds, contact your account manager.",
  "billing.details.amount": "Amount",
  "billing.details.back.to.past.invoices": "Back to past invoices",
  "billing.details.back.to.upcoming.invoice": "Back to upcoming invoice",
  "billing.details.current_funds_remaining": "Current funds remaining",
  "billing.details.date": "Date",
  "billing.details.description": "Description",
  "billing.details.errors.email": "An email is required",
  "billing.details.errors.inputs": "Fill all required inputs",
  "billing.details.errors.name": "A name is required",
  "billing.details.errors.name_line": "A billing address is required",
  "billing.details.estimated.payment": "Estimated payment",
  "billing.details.message.card": "Click update credit card to edit",
  "billing.details.message.sepa": "Click update bank accounts to edit",
  "billing.details.note.country":
    "<Link>Create a support ticket</Link> to change your country",
  "billing.details.order_id": "Order ID",
  "billing.details.past.invoice": "Past invoice",
  "billing.details.past.invoices": "Past invoices",
  "billing.details.payment_method.note":
    "Add your address before adding your payment method",
  "billing.details.prepaid_funds_depleted_message":
    "Your prepaid funds are depleted. Contact your account manager to add more.",
  "billing.details.prepaid_funds_message":
    "Prepaid funds are used automatically each month. When they're depleted, the payment method entered will be charged. To add more funds, contact your account manager.",
  "billing.details.prepaid_funds_remaining": "Prepaid funds remaining",
  "billing.details.prepaid_transaction_history": "Prepaid transaction history",
  "billing.details.projected_costs_exceed_prepaid_message":
    "Projected costs exceed the remaining prepaid funds. Contact your account manager to add more.",
  "billing.details.projected_total_this_month": "Projected total this month",
  "billing.details.upcoming.invoice": "Upcoming invoice",
  "billing.details.upcoming.invoice.description":
    "Your upcoming invoice is an estimate based on your current usage and add-ons for one month. \n To learn more about our pricing, see our {pricingPage}.",
  "billing.documenttitle": "Billing",
  "billing.excludes_tax": "(excludes tax)",
  "billing.insufficient_funds": "Insufficient funds",
  "billing.insufficient_funds.note":
    "Projected costs exceed the remaining prepaid funds. The backup payment method will be used to cover the remaining balance.",
  "billing.invoice.account": "Account",
  "billing.invoice.duration": "Duration",
  "billing.invoice.estimated_total": "Estimated total",
  "billing.invoice.id": "Invoice id",
  "billing.invoice.invoice_number": "Invoice number",
  "billing.invoice.organization": "Organization",
  "billing.invoice.organization_with_name": "Organization: {name}",
  "billing.invoice.project_discount": "discount",
  "billing.invoice.project_green_discount_description":
    "3% of CPU, memory, and build resources",
  "billing.invoice.project_subtotal": "{projectName} subtotal",
  "billing.invoice.project_total": "{projectName} total",
  "billing.invoice.projects": "Projects",
  "billing.invoice.support": "Support",
  "billing.invoice.total": "Total",
  "billing.invoices.list.empty.description":
    "Find monthly invoices for any projects that you own here after you create a project.",
  "billing.invoices.list.empty.title": "You have no invoices",
  "billing.invoices.list.previous.title": "Previous",
  "billing.invoices.list.recurring.title": "Recurring {appName} subscription",
  "billing.navigation_modal.cancel": "Cancel",
  "billing.navigation_modal.description":
    "This organization's billing can be located under the user menu to the right. Permissions for billing are now managed separately from the organization. If you have lost any billing related access, please contact your organization owner.",
  "billing.navigation_modal.proceed": "Proceed to billing",
  "billing.navigation_modal.title": "Billing for this organization has moved",
  "billing.no_payment_details": "No payment details",
  "billing.paid_by_invoice": "Paid by invoice",
  "billing.plan.description.tier.elite":
    "Elite organization tiers include 45-minute urgent SLA.",
  "billing.plan.description.tier.enterprise":
    "Enterprise organization tiers include 1-hour urgent SLA. Upgrade to Elite for 45-minute urgent SLA.",
  "billing.plan.description.tier.professional":
    "To add a support SLA, upgrade your organization tier to Enterprise or Elite.",
  "billing.plan.link.tier.elite": "Upgrade organization tier",
  "billing.plan.link.tier.professional": "Learn more",
  "billing.plan.list.empty.description":
    "Find plan information here for any projects that you own.",
  "billing.plan.list.empty.title": "You have no project plans",
  "billing.plan.support": "{type} support",
  "billing.prepaid_funds_remaining": "Prepaid funds remaining",
  "billing.prices_exclude_tax": "The prices shown do not include taxes.",
  "billing.subscribe.description":
    "Save up to $19 every month on your first user license and first project fee with <Link>First Project Incentive</Link>.*",
  "billing.subscribe.title": "Upgrade from trial",
  "billing.tax.has": "I have a {taxLabel}",
  "billing.tax.header": "Tax identification",
  "billing.tax.no_tax_number.confirm":
    "I confirm that this business does not have a {taxLabel}, and I understand this setting cannot be changed later.",
  "billing.tax.none": "I do not have a {taxLabel}",
  "billing.terms_conditions": "*<link>Terms and conditions apply</link>",
  billing_address: "Billing address line 1",
  billing_address2: "Billing address line 2",
  "billing_alerts_modal.delete": "Delete alert",
  "billing_alerts_modal.description":
    "Create an alert to monitor the <strong>projected monthly cost</strong> for {organizationName}. Users with the <code>Manage billing</code> permission will receive an email when your organization's costs reach the threshold specified below.",
  "billing_alerts_modal.error": "You must input a value to create an alert.",
  "billing_alerts_modal.label": "Monthly threshold",
  "billing_alerts_modal.note":
    "Please note: The projected monthly cost is an estimate.",
  "billing_alerts_modal.notification.delete.description":
    "A billing alert has been removed from this organization.",
  "billing_alerts_modal.notification.delete.title": "Billing alert deleted",
  "billing_alerts_modal.notification.success.description":
    "Billing alert is set at {alertThreshold} for this organization",
  "billing_alerts_modal.notification.success.title":
    "New billing alert created",
  "billing_alerts_modal.submit": "Create alert",
  "billing_alerts_modal.title": "Set billing alert",
  billing_contact_email: "Billing contact email",
  billing_details: "Billing details",
  billing_details_added: "Billing details added",
  billing_details_added_a:
    "Thanks for adding your billing details to your account. You'll receive an invoice based on your projects' actual usage at the end of each month.",
  billing_details_added_b:
    "You can manage your billing details through your accounts billing settings.",
  billing_email: "Billing email",
  "billing_entities.accounts.addons": "Add-ons",
  "billing_entities.accounts.admins": "Admins",
  "billing_entities.accounts.current_invoice": "Current invoice",
  "billing_entities.accounts.description":
    "The billing account is the legal entity responsible for billing. It owns and manages billing profiles, which handle payment methods and invoices.",
  "billing_entities.accounts.empty": "No billing accounts found.",
  "billing_entities.accounts.empty.description":
    "Billing accounts let you manage billing profiles and payment methods.",
  "billing_entities.accounts.empty.header":
    "You haven’t set up a billing account yet",
  "billing_entities.accounts.header": "Billing accounts",
  "billing_entities.accounts.loading": "Loading accounts...",
  "billing_entities.accounts.organizations": "Organizations",
  "billing_entities.accounts.projects": "Projects",
  "billing_entities.add_entity": "Add billing account",
  "billing_entities.customer_type.company": "Company",
  "billing_entities.customer_type.government": "Government",
  "billing_entities.customer_type.individual": "Individual",
  "billing_entities.empty_state":
    'No billing entities found. Click "Add legal entity" to get started.',
  "billing_entities.error": "Error loading billing entities: {error}",
  "billing_entities.loading": "Loading billing entities...",
  "billing_entities.pricing_model.fixed": "Fixed",
  "billing_entities.pricing_model.payg": "Pay as you go",
  "billing_entities.profiles.add_button": "Add billing details",
  "billing_entities.profiles.empty_description":
    "Add your address and billing information to enable invoicing.",
  "billing_entities.profiles.empty_title":
    "You haven't added billing details yet",
  "billing_entities.tax_exempt": " (Tax exempt)",
  "billing_entities.tax_number": "EIN {taxNumber}",
  "billing_entities.view": "View",
  "billing_entity_overview.add_billing_account": "Add Billing Account",
  "billing_entity_overview.billing_accounts": "Billing accounts",
  "billing_entity_overview.column_account": "Account",
  "billing_entity_overview.column_admins": "Admins",
  "billing_entity_overview.column_current_invoice": "Current invoice",
  "billing_entity_overview.column_organizations": "Organizations",
  "billing_entity_overview.column_projects": "Projects",
  "billing_entity_overview.error_loading_accounts":
    "Failed to load billing accounts. Please try again.",
  "billing_entity_overview.no_accounts": "No billing accounts found.",
  billing_information: "billing information",
  billing_new_project:
    "All new projects are set to our smallest Development plan.",
  "billing_sidebar.add_billing_account": "Add billing account",
  "billing_sidebar.add_billing_profile": "Add billing profile",
  "billing_sidebar.add_new_account": "Add new account",
  "billing_sidebar.add_new_billing_account": "Add new billing account",
  "billing_sidebar.add_new_profile": "Add new profile",
  "billing_sidebar.billing_account": "Billing account",
  "billing_sidebar.billing_account_dialog.description":
    "The billing account is the legal entity responsible for billing. It owns and manages billing profiles, which handle payment methods and invoices.",
  "billing_sidebar.billing_account_dialog.title": "Billing account",
  "billing_sidebar.billing_accounts": "Billing accounts",
  "billing_sidebar.billing_details": "Billing details",
  "billing_sidebar.billing_profile": "Billing profile",
  "billing_sidebar.billing_profile_dialog.description":
    "Billing profiles control how charges are grouped, invoiced, and paid. Manage payment methods, invoices, and how charges are grouped and billed.",
  "billing_sidebar.billing_profile_dialog.title": "Billing profile",
  "billing_sidebar.billing_profiles": "Billing profiles",
  "billing_sidebar.billing_users": "Billing users",
  "billing_sidebar.contact_support": "Contact support",
  "billing_sidebar.contracts": "Contracts",
  "billing_sidebar.cost": "Cost & usage",
  "billing_sidebar.discounts_commitments": "Discounts & commitments",
  "billing_sidebar.edit_account_details": "Edit account details",
  "billing_sidebar.error_loading_accounts":
    "Failed to load billing accounts. Please try again.",
  "billing_sidebar.error_loading_entities":
    "Failed to load billing entities. Please try again.",
  "billing_sidebar.error_loading_profiles":
    "Failed to load billing profiles. Please try again.",
  "billing_sidebar.invoices": "Invoices",
  "billing_sidebar.legal_entity": "Legal entity",
  "billing_sidebar.organizations": "Organizations",
  "billing_sidebar.select_account": "Select account",
  "billing_sidebar.select_entity": "Select entity",
  "billing_sidebar.vouchers": "Vouchers",
  billing_summary_info:
    "To change your plan, or add more storage, users or environments, you can upgrade at any time through your project account settings.",
  billing_system_explanation:
    "Billing is based on actual usage at the end of each month. Prices displayed include VAT when applicable.",
  "billing_team.edit": "Edit",
  "billing_team.email": "Email",
  "billing_team.error_loading":
    "Failed to load billing users. Please try again.",
  "billing_team.name": "Name",
  "billing_team.no_users": "No billing users found.",
  "billing_team.permission_manage": "Manage Billing",
  "billing_team.permission_view": "View Billing",
  "billing_team.permissions": "Permissions",
  "billing_team.status_active": "Active",
  "billing_team.title": "Billing users",
  "billingsystem.cost.addon.support.description":
    "Upgrade to receive faster response times for your support tickets. This upgrade will apply to new tickets, while any existing tickets will remain under your current support level.",
  "billingsystem.cost.addon.support.modal.current": " (Current)",
  "billingsystem.cost.addon.support.title": "Support add-on",
  "billingsystem.cost.addon.support.update.error":
    "Failed to update support level. Please try again.",
  "billingsystem.cost.addon.support.update.success":
    "{supportLevel} organization support enabled",
  "billingsystem.cost.addons": "Add-ons",
  "billingsystem.cost.addons.empty": "There is no add-on cost and usage data.",
  "billingsystem.cost.breakdown": "Cost breakdown",
  "billingsystem.cost.discounts": "Invoice discounts",
  "billingsystem.cost.edit": "Edit",
  "billingsystem.cost.error.loading": "Error loading cost",
  "billingsystem.cost.organization.projects.empty":
    "This organization has no project. <cta>Create a project to get started.</cta>",
  "billingsystem.cost.organization.projects.title":
    "Projects billed under this organization",
  "billingsystem.cost.organization.users.empty":
    "This organization has no paid users.",
  "billingsystem.cost.organization.users.licenses": "User licenses",
  "billingsystem.cost.organization.users.management": "User management",
  "billingsystem.cost.organization.users.title": "Organization users",
  "billingsystem.cost.organization.users.viewers": "Viewers",
  "billingsystem.cost.organizations": "Organizations",
  "billingsystem.cost.organizations.addons":
    "{count, plural, one{# add-on} other{# add-ons}}",
  "billingsystem.cost.organizations.empty":
    "There is no organization cost and usage data.",
  "billingsystem.cost.organizations.projects":
    "{count, plural, one{# project} other {# projects}}",
  "billingsystem.cost.organizations.users":
    "{count, plural, one{# user} other{# users}}",
  "billingsystem.cost.profile.alert.create": "Set alert",
  "billingsystem.cost.profile.alert.created": "Alert created successfully",
  "billingsystem.cost.profile.alert.deleted":
    "A billing alert has been removed from this billing profile.",
  "billingsystem.cost.profile.alert.modal.create": "Create alert",
  "billingsystem.cost.profile.alert.modal.delete": "Delete alert",
  "billingsystem.cost.profile.alert.modal.description":
    "Alert all billing team members when the estimated monthly cost for {account} reaches the threshold specified below.",
  "billingsystem.cost.profile.alert.modal.note":
    "Please note: The projected monthly cost is an estimate.",
  "billingsystem.cost.profile.alert.modal.threshold.label": "Monthly threshold",
  "billingsystem.cost.profile.alert.modal.title":
    "Set billing alert for {account}",
  "billingsystem.cost.profile.alert.set": "Alert set for {amount}",
  "billingsystem.cost.profile.alert.updated": "Alert updated successfully",
  "billingsystem.cost.profiletotal": "This month’s projected total",
  "billingsystem.cost.profiletotal.dialog.description":
    "Based on the usage to-date and estimating the rest of the month using the daily average.",
  "billingsystem.cost.profiletotal.dialog.title":
    "This month’s projected total",
  "billingsystem.cost.project.addon_count":
    "{count, plural, =0 {No add-ons} one {# add-on} other {# add-ons}}",
  "billingsystem.cost.projected": "Projected total",
  "billingsystem.cost.projects": "to cost and usage",
  "billingsystem.cost.projects.alert.active": "Alert is active",
  "billingsystem.cost.projects.alert.created": "Alert created successfully",
  "billingsystem.cost.projects.alert.deleted":
    "A billing alert has been removed from this project.",
  "billingsystem.cost.projects.alert.inactive": "No alert set",
  "billingsystem.cost.projects.alert.modal.create": "Create alert",
  "billingsystem.cost.projects.alert.modal.delete": "Delete alert",
  "billingsystem.cost.projects.alert.modal.description":
    "Create an alert to monitor the projected monthly cost for {account}.  Users with the <t>Manage billing</t> permission will receive an email when your profile’s projected total costs reach the threshold specified below.",
  "billingsystem.cost.projects.alert.modal.note":
    "Please note: The projected monthly cost is an estimate.",
  "billingsystem.cost.projects.alert.modal.threshold.label":
    "Monthly threshold",
  "billingsystem.cost.projects.alert.modal.threshold.unit": "cents",
  "billingsystem.cost.projects.alert.modal.title":
    "Set billing alert for {account}",
  "billingsystem.cost.projects.alert.updated": "Alert updated successfully",
  "billingsystem.cost.projects.dialog.description":
    "Projects listed here are associated with this billing profile - independent of the billing associated with the project's organization.",
  "billingsystem.cost.projects.dialog.title": "Project-level billing",
  "billingsystem.cost.projects.empty":
    "There is no project cost and usage data.",
  "billingsystem.cost.summary": "Summary",
  "billingsystem.cost.table.current_spend": "Current spend",
  "billingsystem.cost.table.quantity": "Quantity",
  "billingsystem.cost.table.type": "Type",
  "billingsystem.cost.table.unit_price": "Unit price",
  "billingsystem.cost.title": "Cost & Usage",
  "billingsystem.cost.view": "View",
  "billingsystem.included": "Included: ",
  "billingsystem.orgId": "Org ID: ",
  "billingsystem.project.billing": "billing",
  "billingsystem.project.current_value": "Current value",
  "billingsystem.project.metric": "Metric",
  "billingsystem.project.other": "Other",
  "billingsystem.project.plan.fee": "Project fee",
  "billingsystem.project.resources": "Resources",
  "billingsystem.project.this_months_projection": "This month's projection",
  "billingsystem.project.usage": "Usage",
  "billingsystem.wizard.billing.description":
    "A specific payment method, currency, and address. Use it to group and map your organizations or projects to different invoicing setups.",
  "billingsystem.wizard.billing.form.address1": "Billing address line 1",
  "billingsystem.wizard.billing.form.address1.placeholder": "Address line 1",
  "billingsystem.wizard.billing.form.address2": "Billing address line 2",
  "billingsystem.wizard.billing.form.address2.placeholder": "Address line 2",
  "billingsystem.wizard.billing.form.city": "City",
  "billingsystem.wizard.billing.form.city.placeholder": "City",
  "billingsystem.wizard.billing.form.email": "Billing contact email",
  "billingsystem.wizard.billing.form.email.placeholder": "Email",
  "billingsystem.wizard.billing.form.organization_type.dialog":
    "Determines which types of organizations can be billed under this profile. This setting cannot be changed later. Fixed is only for billing existing fixed organizations.",
  "billingsystem.wizard.billing.form.profilename": "Billing profile name",
  "billingsystem.wizard.billing.form.profilename.description":
    "Enter name as it should appear on the invoice.",
  "billingsystem.wizard.billing.form.profilename.dialog":
    "The billing profile name helps you identify this billing profile across invoices and billing settings, and recognize which charges are billed together.",
  "billingsystem.wizard.billing.form.profilename.placeholder": "Name",
  "billingsystem.wizard.billing.form.state": "State",
  "billingsystem.wizard.billing.form.state.placeholder": "State",
  "billingsystem.wizard.billing.form.zip": "Zip code",
  "billingsystem.wizard.billing.form.zip.placeholder": "Zip code",
  "billingsystem.wizard.billing.onnext": "Save and continue",
  "billingsystem.wizard.billing.title": "Billing profile",
  "billingsystem.wizard.billing_account_creation.toast.error.description":
    "Please review your information and try again. If the issue persists, contact support.",
  "billingsystem.wizard.billing_account_creation.toast.error.title":
    "Couldn’t create billing account",
  "billingsystem.wizard.billing_account_creation.toast.success.description":
    "You can now create a billing profile to manage billing for organizations and projects.",
  "billingsystem.wizard.billing_account_creation.toast.success.title":
    "Billing account created!",
  "billingsystem.wizard.billing_profile_assign.toast.error.description":
    "{billingProfileName} billing profile could not be added to {organizationName}. Please try again. If the issue persists, contact support.",
  "billingsystem.wizard.billing_profile_assign.toast.error.title":
    "Couldn’t add billing profile",
  "billingsystem.wizard.billing_profile_assign.toast.success.description":
    "{billingProfileName} billing profile was added to {organizationName}",
  "billingsystem.wizard.billing_profile_assign.toast.success.title":
    "Billing profile added!",
  "billingsystem.wizard.billing_profile_creation.toast.error.description":
    "Please review your information and try again. If the issue persists, contact support.",
  "billingsystem.wizard.billing_profile_creation.toast.error.title":
    "Couldn’t create billing profile",
  "billingsystem.wizard.billing_profile_creation.toast.success.description":
    "You can now add a payment method and assign an organization to this profile.",
  "billingsystem.wizard.billing_profile_creation.toast.success.title":
    "Billing profile created!",
  "billingsystem.wizard.legal.description":
    "The billing account represents the legal entity responsible for billing. It owns and manages billing profiles, which handle payment methods and invoices.",
  "billingsystem.wizard.legal.form.company.companyname": "Company name",
  "billingsystem.wizard.legal.form.company.companyname.placeholder":
    "Company name",
  "billingsystem.wizard.legal.form.company.exempt":
    "This billing account qualifies for tax exemption. <br></br> <small>(We’ll follow up with an email about submitting requirements.)</small>",
  "billingsystem.wizard.legal.form.company.legalname": "Legal name",
  "billingsystem.wizard.legal.form.company.legalname.placeholder": "Legal name",
  "billingsystem.wizard.legal.form.company.tin":
    "Taxpayer Identification Number (TIN)",
  "billingsystem.wizard.legal.form.company.tin.placeholder": "Tax ID",
  "billingsystem.wizard.legal.onnext": "Save and continue",
  "billingsystem.wizard.legal.title": "Billing account",
  "billingsystem.wizard.link_organizations.billing_profile":
    "Billing profile: {name}",
  "billingsystem.wizard.link_organizations.description":
    "Select which organizations to bill to <b>{profile}</b>. You can skip this step and link each organization later from its settings.",
  "billingsystem.wizard.link_organizations.error":
    "We couldn't link your organizations. Please try again.",
  "billingsystem.wizard.link_organizations.skip": "Skip",
  "billingsystem.wizard.link_organizations.submit": "Link organizations",
  "billingsystem.wizard.link_organizations.title":
    "Link organizations to this profile",
  "billingsystem.wizard.link_organizations.unlinked": "Unlinked organizations",
  "billingsystem.wizard.overview.onnext": "Continue to billing",
  "billingsystem.wizard.overview.title": "Upgrade from trial",
  "billingsystem.wizard.payment.onnext": "Add payment method",
  "billingsystem.wizard.payment_method_add.toast.error.description":
    "Please review your payment details and try again. If the issue persists, contact support.",
  "billingsystem.wizard.payment_method_add.toast.error.title":
    "Couldn't add payment method",
  "billingsystem.wizard.payment_method_add.toast.success.description":
    "Your payment method has been added successfully.",
  "billingsystem.wizard.payment_method_add.toast.success.title":
    "Payment method added!",
  "billingsystem.wizard.select.billingprofile":
    "Choose the billing profile for this organization.",
  "billingsystem.wizard.select.description":
    "We need to associate a billing account to this organization.<br></br>Select an existing account, or create one from scratch.",
  "billingsystem.wizard.select.form.billingaccount": "Billing account",
  "billingsystem.wizard.select.form.billingaccount.create":
    "Add new billing account",
  "billingsystem.wizard.select.form.billingaccount.placeholder":
    "Select billing account",
  "billingsystem.wizard.select.form.billingaccount.placeholder.empty":
    "No billing accounts available",
  "billingsystem.wizard.select.form.billingentity": "Legal entity",
  "billingsystem.wizard.select.form.billingentity.create":
    "Create new legal entity",
  "billingsystem.wizard.select.form.billingentity.placeholder":
    "Select legal entity",
  "billingsystem.wizard.select.form.billingentity.placeholder.empty":
    "No billing entities available",
  "billingsystem.wizard.select.form.billingprofile": "Billing profile",
  "billingsystem.wizard.select.form.billingprofile.create":
    "Add new billing profile",
  "billingsystem.wizard.select.form.billingprofile.group.compatible":
    "{type} profiles",
  "billingsystem.wizard.select.form.billingprofile.group.incompatible":
    "{type} profiles (Incompatible with this org)",
  "billingsystem.wizard.select.form.billingprofile.placeholder":
    "Select billing profile",
  "billingsystem.wizard.select.form.billingprofile.placeholder.empty":
    "No billing profiles available",
  "billingsystem.wizard.select.incompatible.create":
    "Create {type} billing profile",
  "billingsystem.wizard.select.incompatible.description":
    "<b>{organization}</b> is a <b>{type}</b> organization and can only be linked to a {type} billing profile.",
  "billingsystem.wizard.select.incompatible.existing":
    "The existing profiles under {account} are <b>{type}</b> and cannot be used here.",
  "billingsystem.wizard.select.incompatible.learnmore":
    "Learn more about Fixed and Flex organizations",
  "billingsystem.wizard.select.incompatible.title":
    "Create a {type} billing profile to continue",
  "billingsystem.wizard.select.title": "{organization}",
  "billingsystem.wizard.select.title.new":
    "{organization} organization was created",
  "billingsystem.wizard.steps.billing": "Billing profile",
  "billingsystem.wizard.steps.legal": "Billing account",
  "billingsystem.wizard.steps.payment": "Payment method",
  "billingsystem.wizard.steps.type": "Business type",
  "billingsystem.wizard.type.company": "Company",
  "billingsystem.wizard.type.company.description":
    "For incorporated companies or legal entities.",
  "billingsystem.wizard.type.government": "Public sector",
  "billingsystem.wizard.type.government.description":
    "For government owned or funded entities.",
  "billingsystem.wizard.type.individual": "Individual",
  "billingsystem.wizard.type.individual.alreadyExists":
    "(You already have an individual billing account.)",
  "billingsystem.wizard.type.individual.description":
    "For individuals without an incorporated company or billing account.",
  "billingsystem.wizard.type.onnext": "Save and continue",
  "billingsystem.wizard.type.title":
    "What type of account do you want to create?",
  "blackfire.add": "Add Blackfire",
  "blackfire.card.cta.contact_us": "Contact us",
  "blackfire.card.cta.launch": "Launch Blackfire",
  "blackfire.card.cta.learn_more": "Learn more",
  "blackfire.card.cta.not_configured": "Learn more",
  "blackfire.card.cta.not_subscribed": "Contact us",
  "blackfire.card.message.dg2":
    "Blackfire is available as part of the Observability Suite. If you haven't subscribed to Blackfire yet, contact us to learn more.",
  "blackfire.card.message.grid.unsubscribed":
    "Learn more about how to monitor, validate and improve site performance with Blackfire.",
  "blackfire.card.message.not_configured":
    "Configure Blackfire to enable the Observability suite features on this environment.",
  "blackfire.card.message.subscribed":
    "Monitor, validate and improve site performance with Blackfire.",
  "blackfire.integration.enabled_message":
    "Blackfire is enabled for this project. You can now monitor, validate and improve site performance at Blackfire.io",
  "blackfire.integration.upgrade_message":
    "Blackfire monitoring can be added by visiting Blackfire.io, or contact sales to upgrade to the full Observability Suite.",
  "blackfire.integration.upgrade_title": "Upgrade to Blackfire",
  "blackfire.io": "https://blackfire.io",
  "blackfire.title": "Blackfire",
  branch: "Branch",
  "branch.button": "create branch",
  "branch.button.sizing_api_enabled": "Branch",
  "branch.cli": "CLI",
  "branch.cli.command":
    "{commandName} branch {branchName} {environmentId} {type}",
  "branch.cli.command.sizing.development.minimum":
    "{commandName} branch {branchName} {environmentId}",
  "branch.cli.command.sizing.development.non_minimum":
    "{commandName} branch {branchName} {environmentId} --resources-init={radioSelection}",
  "branch.cli.command.sizing.staging.default":
    "{commandName} branch {branchName} {environmentId} --type=staging",
  "branch.cli.command.sizing.staging.non_default":
    "{commandName} branch {branchName} {environmentId} --type=staging --resources-init={radioSelection}",
  "branch.cli.sizing_api_enabled": "CLI command",
  "branch.create.prompt":
    "Branching will create a new branch in the Git repository and an exact copy of your environment. Name your branch below to get started.",
  "branch.create.prompt.sizing_api_enabled":
    "Create a new preview environment as a copy of your {environmentType} environment.",
  "branch.dialog.cli.description":
    "You can also use this terminal command to branch from {environmentName}",
  "branch.guaranteed_resources.warning":
    "Guaranteed resources from the parent will be provisioned, impacting your bill.",
  "branch.name.label": "Branch name",
  "branch.name.label.sizing_api_enabled": "Environment name",
  "branch.name.placeholder": "Branch name",
  "branch.name.placeholder.sizing_api_enabled": "Name",
  "branch.radioBtn.default": "Use default resources",
  "branch.radioBtn.manual": "Manually configure resources after branch",
  "branch.radioBtn.minimum": "Use minimum resources",
  "branch.radioBtn.parent": "Use parent environment resources",
  "branch.radioGroup.description":
    "Resource initialization strategy for your new preview environment.",
  branch_environmentName: "branch {environment}",
  branch_max_env:
    "You have reached the resources limit for this organization's trial.",
  branched_environment: "branched environment",
  branching: "branching",
  branching_from: "Branching from {environment}",
  "breadcrumb.billing": "Billing",
  "breadcrumb.billing.cost": "Cost",
  "breadcrumb.billing.details": "Details",
  "breadcrumb.billing.discounts-commitments": "Discounts & Commitments",
  "breadcrumb.billing.history": "Invoices",
  "breadcrumb.billing.history.id": "Invoice #{id}",
  "breadcrumb.billing.invoices": "Invoices",
  "breadcrumb.billing.plan": "Plans",
  "breadcrumb.billing.plan.id": "Subscription #{id}",
  "breadcrumb.billing.products": "Products",
  "breadcrumb.billing.profiles": "Profiles",
  "breadcrumb.billing.vouchers": "Vouchers",
  "breadcrumb.billing.vouchers.id": "Vouchers",
  "breadcrumb.organization.billing": "Billing",
  "breadcrumb.organization.billing.carbon-emissions": "Carbon Emissions",
  "breadcrumb.organization.billing.commitment": "Commitment",
  "breadcrumb.organization.billing.details": "Billing Details",
  "breadcrumb.organization.billing.history": "Invoices",
  "breadcrumb.organization.billing.history.id": "Invoice #{id}",
  "breadcrumb.organization.billing.plan": "Plans",
  "breadcrumb.organization.billing.plan.id": "Subscription #{id}",
  "breadcrumb.organization.billing.vouchers": "Vouchers",
  "breadcrumb.organization.billing.vouchers.add": "Redeem",
  "breadcrumb.organization.project.usage.billing": "Project",
  "breadcrumb.organization.settings": "Organization settings",
  "breadcrumb.organization.settings.security": "Security",
  "breadcrumb.organization.settings.teams": "Teams",
  "breadcrumb.organization.settings.users": "Organization users settings",
  "breadcrumb.organization.settings.users.invitations":
    "Organization invitations settings",
  "breadcrumb.organization.usage.billing": "Billing",
  "breadcrumb.profile": "My profile",
  "breadcrumb.project": "Project",
  "breadcrumb.projects": "Projects",
  "breadcrumb.settings": "Account settings",
  "breadcrumb.settings.accounts": "Connected accounts",
  "breadcrumb.settings.security": "Security",
  "breadcrumb.settings.security.setup": "MFA application set up",
  "breadcrumb.settings.ssh-keys": "SSH Keys",
  "breadcrumb.settings.teams.-.id": "Create team",
  "breadcrumb.settings.tokens": "API tokens",
  "breadcrumb.settings.users.id": "{id}",
  "breadcrumb.tabs.backups": "Backups",
  "breadcrumb.tabs.http_traffic": "HTTP Traffic",
  "breadcrumb.tabs.logs": "Logs",
  "breadcrumb.tabs.metrics": "Resources",
  "breadcrumb.tabs.profiling": "Profiling",
  "breadcrumb.tabs.services": "Containers",
  "breadcrumb.tickets": "Support",
  "breadcrumb.tickets.id": "Ticket #{id}",
  "breadcrumb.tickets.open": "Create ticket",
  build: "build",
  build_run: "Sign up to try it for free (no credit card required)",
  build_run_scale: "Build, run, and scale your apps—end to end.",
  building: "building",
  building_no_redirected: "If you are not redirected, please",
  building_redirect:
    "As soon as your project is ready, you will be redirected to it.",
  built_for: "Built for Node.js, Python, Java and more",
  built_in: "Built-in CI/CD",
  button_go_live: "Go live",
  by_signing_up_you_agree: "By signing up you agree to the",
  cache: "cache",
  cache_description:
    "When a request comes with the same cache key, the cached response is reused.",
  can_use_new_email: "You can now use your new email address to log in.",
  cancel: "Cancel",
  cannot_create_branch: "Cannot create a new branch",
  cant_verify_tfa: "can’t retrieve your TFA code?",
  "carbon.emissions.affects.note":
    "<b>Note:</b> Optimizing code or app performance reduces emissions only if it leads to lower resource allocation.",
  "carbon.emissions.affects.title": "What affects emissions?",
  "carbon.emissions.affects.whatYouProvision":
    "<b>What you provision:</b> Emissions rise in proportion to the resources you allocate.",
  "carbon.emissions.affects.whereYouRun":
    "<b>Where you run:</b> Data center regions vary greatly in grid-carbon intensity. Selecting a cleaner region is the most impactful way to reduce footprint.",
  "carbon.emissions.calculation.explanation":
    "We collect detailed billing data from our cloud service providers, represented as line items including associated costs and quantities. Our carbon management partner, Greenly, calculates the energy use and embodied emissions for each line item.",
  "carbon.emissions.calculation.link": "Learn more",
  "carbon.emissions.calculation.title": "How is this calculated?",
  "carbon.emissions.download": "Download CSV",
  "carbon.emissions.graph.daterange": "Jan {year} - Dec {year}",
  "carbon.emissions.graph.nodata":
    "No emissions data available for this period",
  "carbon.emissions.graph.regionexclusion":
    "Please note that emissions data does not include projects hosted in the Orange (FR-1) and OVHcloud (FR-3) regions",
  "carbon.emissions.graph.title": "{year} Total emissions",
  "carbon.emissions.main.note":
    "Carbon emissions calculation is a rapidly evolving field, with our methodologies constantly improving to reflect the latest science and regulations. Our approach is aligned with recognized standards such as the Greenhouse Gas (GHG) Protocol and the EU Corporate Sustainability Reporting Directive (CSRD).",
  "carbon.emissions.main.title": "Carbon emissions",
  "carbon.emissions.overview.title": "Emissions overview",
  "carbon.emissions.popover.content":
    "{year} emissions data excludes projects hosted in the Orange (FR-1) and OVHcloud (FR-3) regions.",
  "carbon.emissions.popover.title": "Data availability",
  "carbon.emissions.projects.nodata":
    "No projects with emissions data in {year}",
  "carbon.emissions.projects.nodata.individual": "No data",
  "carbon.emissions.projects.projectname": "Project name",
  "carbon.emissions.projects.title": "{year} Project emissions total",
  "carbon.emissions.projects.yeartotal": "Year total",
  "carbon.emissions.total": "Total",
  "carbon.emissions.units": "kg CO₂eq",
  "cdn_traffic_sticker.billing":
    "Please note that CDN traffic is not reflected on this page, only origin traffic. You can find CDN Bandwidth and Requests totals on the <link>project billing page</link>.",
  "cdn_traffic_sticker.overview":
    "You can find CDN Bandwidth and Request totals on the <link>Project Overview</link>",
  certificate: "Certificate",
  certificates: "Certificates",
  "certificates.add": "Add",
  "certificates.add_certificate": "Add certificate",
  "certificates.back_to": "Back to certificates",
  "certificates.description":
    "{appName} automatically generates TLS certificates for all of your applications to enable HTTPS.",
  "certificates.description2":
    "You can also provide custom certificates on this page.",
  "certificates.documentation": "documentation.",
  "certificates.info": "Learn more about Certificates in our",
  "certificates.no_certificates": "No certificates.",
  "certificates.no_certificates.description1":
    "No TLS certificate is currently set up.",
  "certificates.no_certificates.description2":
    "The default certificate was deleted by a project contributor.",
  "certificates.no_certificates.documentation":
    "See how to create a new one in our",
  "certificates.sort.expiryDate": "Expiry date",
  "certificates.sort.name": "Certificates",
  change: "change",
  change_email_link_expired:
    "Your verification link has expired. These are only valid for 24 hours. Please log in to try again.",
  change_email_settings: "Change email settings",
  change_payment_method_body:
    "Changing payment methods will remove your existing method from your account. Are you sure you want to change methods?",
  change_payment_method_confirm: "Yes, change method",
  change_payment_method_header: "change payment method",
  change_payment_method_note:
    "Note: You must add a new payment method before your previous one is removed.",
  changed_project_name_to: "changed project name to",
  changelog: "Changelog",
  check_consent: "Please check the consent box",
  check_inbox: "check your inbox",
  check_inbox_resent:
    "Check your inbox and if you still haven’t received an email please",
  city: "City",
  clear: "Clear",
  clear_all: "Clear all",
  cleared_the: "cleared the",
  cli: "cli",
  "cli.clone.description":
    "Clone your codebase and boost your development with the official tool to manage your projects",
  "cli.install": "Install CLI",
  cli_command: "CLI command:",
  cli_integration:
    "Our Command Line Interface (CLI) will walk you through setting up various integrations. You can also learn more about integrations in our <a>documentation</a>. To get started, use the following command",
  click_here: "click here",
  click_to_copy_content: "Click to copy Content",
  click_to_expand: "Click to expand",
  click_to_reduce: "Click to reduce",
  client_authentication: "client_authentication",
  clone: "Clone instantly",
  close: "Close",
  code: "code",
  code_trigger_btn: "Code",
  collaborators: "collaborators",
  "command.hide": "Hide command",
  "command.view": "View Command",
  "command_k.back": "Back",
  "command_k.copy_project_id": "Copy project ID",
  "command_k.esc": "esc",
  "command_k.no_results": "No results found.",
  "command_k.provide_feedback": "Provide feedback",
  "command_k.search.placeholder": "Search for projects or organizations...",
  "command_k.triggerer.tooltip": "Global search: Cmd/Ctrl + K",
  commit_details: "{author} committed at {date}",
  commits_tab: "Commits ({count})",
  company: "Company",
  company_details: "Company details",
  company_http: "https://",
  company_name: "Company name",
  company_role_label: "Profession",
  company_type_label: "Company activity",
  company_url: "Company URL",
  config_changes_tab: "Config changes ({changesLength})",
  "config_diff.description":
    "Configuration changes since the previous deployment for apps, services, workers, environments, and routes.",
  "config_diff.error": "Error loading configuration changes.",
  "config_diff.loading": "Loading config changes...",
  "config_diff.title": "{changesLength} Config file changes",
  configure: "Configure",
  "configure.alarm.thresholds": "Configure autoscaling",
  "configure.autoscaling.error.description":
    "No updates were saved for the <strong>{appName}</strong> container.",
  "configure.autoscaling.error.title": "Autoscaling updates were canceled",
  "configure.autoscaling.notif.linkTitle": "View {serviceName}",
  "configure.autoscaling.success.description":
    "Your updates to the autoscaling configurations have been successfully saved for the <strong>{appName}</strong> container.",
  "configure.autoscaling.success.title": "Autoscaling configurations saved",
  "configure.resources.autoscaling": "Autoscaling",
  "configure.thresholds": "Configure autoscaling",
  configure_app: "configure your application",
  configure_environment:
    "Configure your environment name and its parent environment.",
  "configure_environment.no_permission.sticker":
    "Ask your project admin to change this environment's configuration.",
  configure_resources: "Configure resources",
  "configure_resources.banner.sentence":
    "Subscribe to Upsun to access more resources.",
  "configure_resources.button.disabled":
    "Activate environment to configure resources",
  "configure_resources.close": "Close",
  "configure_resources.continuous_resources.apps_n_services":
    "App and service containers",
  "configure_resources.continuous_resources.clear": "Clear changes",
  "configure_resources.continuous_resources.continuous_baseline":
    "Continuous baseline",
  "configure_resources.continuous_resources.description":
    "Always-running environments built for core application workloads that must remain persistently online.",
  "configure_resources.continuous_resources.dialog.cpu&ram.description":
    "You can change the container profile of an application or service in your Yaml configuration file. Values that are below the minimum requirements will be disabled.",
  "configure_resources.continuous_resources.dialog.cpu&ram.title":
    "Advanced container profiles",
  "configure_resources.continuous_resources.dialog.instances.description":
    "Instances are copies of the same container that can be added to provide horizontal scaling for higher availability. All instances use the same storage.",
  "configure_resources.continuous_resources.dialog.instances.title":
    "Container instances",
  "configure_resources.continuous_resources.dialog.link.text": "Documentation",
  "configure_resources.continuous_resources.dialog.type.description":
    "<strong>Shared</strong> means that your container is running on our shared Grid hosts. <strong>Guaranteed</strong> means that your container is running on its own dedicated host.",
  "configure_resources.continuous_resources.dialog.type.title": "Type of CPU",
  "configure_resources.continuous_resources.disk_n_storage": "Disk / storage",
  "configure_resources.continuous_resources.instances": "Instances",
  "configure_resources.continuous_resources.object_storage": "Object storage",
  "configure_resources.continuous_resources.object_storage.disable_modal.continue":
    "Delete files and save",
  "configure_resources.continuous_resources.object_storage.disable_modal.description":
    "Disabling object storage permanently deletes everything stored there on the {environmentName} environment. This data <strong>cannot be recovered</strong> once the environment redeploys.",
  "configure_resources.continuous_resources.object_storage.disable_modal.title":
    "Object storage data will be lost",
  "configure_resources.continuous_resources.object_storage.disabled_warning":
    "Object storage is disabled. Saving now will permanently delete files stored on this environment. Toggle it back on to keep them.",
  "configure_resources.continuous_resources.object_storage.empty_error":
    "Object storage is enabled but no app has any allocated. Give at least one app an allocation, or turn object storage off.",
  "configure_resources.continuous_resources.object_storage.sticker":
    "Object storage is enabled. Your changes won't take effect until you save. <link>Learn about object storage</link>.",
  "configure_resources.continuous_resources.title": "Continuous resources",
  "configure_resources.continuous_resources.type": "Type",
  "configure_resources.continuous_resources.type.guaranteed":
    "Guaranteed resources",
  "configure_resources.guaranteed.modal.app.cpu":
    "Application CPU is {price}/month",
  "configure_resources.guaranteed.modal.continue": "Yes, allocate",
  "configure_resources.guaranteed.modal.description1":
    "You have chosen to allocate guaranteed CPU across your apps and services. This change will increase your <link>resource costs</link>.",
  "configure_resources.guaranteed.modal.description2":
    "This process requires a redeployment of your containers on their own host, which may take a few minutes to complete. Would you like to continue?",
  "configure_resources.guaranteed.modal.service.cpu":
    "Service CPU is {price}/month",
  "configure_resources.guaranteed.modal.title": "Allocate guaranteed CPU?",
  "configure_resources.notification.deploying.description":
    "We are provisioning your guaranteed resources on <strong>{environmentName}</strong>, this may take longer than a normal deploy.",
  "configure_resources.notification.deploying.linkTitle":
    "View {environmentName} environment",
  "configure_resources.notification.deploying.title":
    "Deploying guaranteed resources",
  "configure_resources.notification.fail.description":
    "Your guaranteed resource updates have failed to deploy on {environmentName}.",
  "configure_resources.notification.fail.linkTitle": "View build log",
  "configure_resources.notification.fail.title":
    "Guaranteed resources deployment failed",
  "configure_resources.notification.manual_deployement.title":
    "Guaranteed resources staged",
  "configure_resources.notification.manual_deployment.description":
    "Your guaranteed resources on <strong>{environmentName}</strong> have been saved and will apply on your next manual deploy. That deploy may take a bit longer than usual.",
  "configure_resources.notification.manual_deployment.linkTitle":
    "See staged activities",
  "configure_resources.notification.success.description":
    "Your guaranteed resources have successfully deployed on {environmentName}.",
  "configure_resources.notification.success.linkTitle": "View build log",
  "configure_resources.notification.success.title":
    "Guaranteed resources deployed",
  "configure_resources.page.admin.update.resources.warning":
    "Ask your project admin to update the resources on this environment.",
  "configure_resources.page.billing.warning":
    "To configure your project resources you need to add your billing details, as your free trial has expired.",
  "configure_resources.page.container_sizes": "Container sizes",
  "configure_resources.page.cpu_n_ram": "CPU & RAM",
  "configure_resources.page.cpu_n_ram.error": "CPU and RAM is required",
  "configure_resources.page.cpu_ram.placeholder": "Select CPU and RAM",
  "configure_resources.page.dialog.text":
    "Changing your resources will trigger an environment redeploy.",
  "configure_resources.page.dialog.text.manual":
    "You’ll need to manually deploy the environment to apply resource changes.",
  "configure_resources.page.disk.error": "Disk is required",
  "configure_resources.page.disk.placeholder": "ex 0.5 GB",
  "configure_resources.page.disk.services.tooltip": "Minimum {minDisk} GB",
  "configure_resources.page.disk.services.tooltip.no.minimum": "No minimum",
  "configure_resources.page.disk.units.label": "GB",
  "configure_resources.page.environments": "Select environment",
  "configure_resources.page.inactive.environment.warning":
    "This environment is inactive. Making a change to the resources will also activate this environment.",
  "configure_resources.page.no_resources.description":
    "Configure your app or service resources to scale vertically and horizontally. Changes will not be made until saving, where a deployment will be triggered.",
  "configure_resources.page.no_resources.error":
    "Resource configurations were not found. There could be an error with one of your yaml config files. For more information, <link>read our documentation</link>.",
  "configure_resources.page.no_resources.note":
    "No apps or services are configured.",
  "configure_resources.page.no_resources.warning":
    "Resource configurations were not found. There could be an error with one of your yaml config files. For more information, <link>read our documentation</link>.",
  "configure_resources.page.note.container_size_change":
    "Note: Changing container sizes will trigger a deployment on this environment and impact your monthly project cost. <link>View pricing</link>",
  "configure_resources.page.note.guaranteed_resources":
    "Note: Guaranteed resources is not available for higher memory profile. If you want guaranteed resources, you need to change the container profile.",
  "configure_resources.page.note.trial":
    "Note: Changing container sizes will trigger a deployment on this environment. Free trial resources are limited to up to 1 project, 2 environments, 4.5 CPU, 12GB RAM, and 20GB Disk.",
  "configure_resources.page.notification.description":
    "The resources on <strong>{environmentName}</strong> have been updated and the changes are being deployed.",
  "configure_resources.page.notification.linkTitle":
    "View {environmentName} environment",
  "configure_resources.page.notification.manual_deployment.description":
    "Resource settings for <strong>{environmentName}</strong> have been saved. The changes will be applied when you manually deploy the environment.",
  "configure_resources.page.notification.manual_deployment.linkTitle":
    "See staged activities",
  "configure_resources.page.notification.manual_deployment.title":
    "Resources updated",
  "configure_resources.page.notification.title":
    "Resources updated and deploying",
  "configure_resources.page.object.error": "Object storage is required",
  "configure_resources.page.object.placeholder": "0 TB",
  "configure_resources.page.object.tooltip": "Minimum {minObject} TB",
  "configure_resources.page.object.tooltip.no.minimum": "No minimum",
  "configure_resources.page.object.units.label": "TB",
  "configure_resources.page.object_n_storage": "Object storage",
  "configure_resources.page.reduce.warning":
    "Reducing the size of your containers could negatively impact your application's performance.",
  "configure_resources.page.resources.update.in_progress.warning":
    "A resource update activity is currently in progress. To change resources on this environment, please check back after that activity has completed.",
  "configure_resources.page.text":
    "Configure your app or service resources to suit your needs. Changes will be applied after you click save and your environment is redeployed.{br}Build resources can be configured in the <link>project resources</link>.",
  "configure_resources.page.title": "Configure resources",
  "configure_resources.page.total.category": "{category}",
  "configure_resources.page.total.quantity.instances":
    "{quantity} {quantity, plural, one {instance} other {instances}}",
  "configure_resources.page.total.quantity_type": "{quantity} {type}",
  "configure_resources.page.trial_resources.warning":
    "Your free trial includes {project} {project, plural, one {project} other {projects}}, {environment} {environment, plural, one {environment} other {environments}}, {cpu} CPU, {ram} GB RAM and {disk} GB Disk.",
  "configure_resources.page.type.placeholder": "Select type",
  "configure_resources.page.type.tooltip":
    "Guaranteed resources are not available for the Higher memory profile.",
  "configure_resources.tasks_resources.description":
    "Task containers scale to zero when idle. They strictly consume your allocated CPU and RAM when triggered and while running.",
  "configure_resources.tasks_resources.no_resources":
    "Task containers scale to zero when idle and only consume resources while running. <link> Learn how to add task containers</link>.",
  "configure_resources.tasks_resources.task_containers": "Task containers",
  "configure_resources.tasks_resources.task_containers.total":
    "On-demand max capacity",
  "configure_resources.tasks_resources.title": "Task resources",
  "configure_resources.upgrade": "Upgrade your account",
  confirm_deploy: "confirm & deploy",
  confirm_new_password: "Confirm new password",
  confirm_password: "Confirm password",
  confirm_remove: "Yes, Remove",
  "connect_integrations_form.configure.config.dectected":
    "Detected apps and services",
  "connect_integrations_form.configure.config.description":
    "We scanned your apps and services and generated a starter configuration to help you set up your project.",
  "connect_integrations_form.configure.config.disclaimer.generated":
    "# Upsun configuration, generated using AI at: {timestamp}",
  "connect_integrations_form.configure.config.disclaimer.warning":
    "# AI can make mistakes. Please modify this file to suit your needs.",
  "connect_integrations_form.configure.config.error.documentation_url":
    "https://developer.upsun.com/docs/get-started/here/configure",
  "connect_integrations_form.configure.config.error.fallback":
    "You can <link>follow our documentation</link> to write a configuration file manually.",
  "connect_integrations_form.configure.config.error.generic":
    "Sorry, we couldn't generate your configuration.",
  "connect_integrations_form.configure.config.error.retry": "Try again",
  "connect_integrations_form.configure.config.error.title":
    "Deploy your apps and services",
  "connect_integrations_form.configure.config.loading":
    "// Linking your Git repository...",
  "connect_integrations_form.configure.config.next_steps": "Next steps:",
  "connect_integrations_form.configure.config.notes":
    "Notes: AI can make mistakes. Please check and modify the configuration to fit your needs. See our <link>docs</link> to learn how.",
  "connect_integrations_form.configure.config.step_1":
    "1. Copy the code below into a new <code>{configuration_folder}/config.yaml</code> file in your project.",
  "connect_integrations_form.configure.config.step_2":
    "2. Commit the file and push changes",
  "connect_integrations_form.configure.config.step_2.code":
    'git add .\ngit commit -m "Add Upsun configuration"\ngit push',
  "connect_integrations_form.configure.config.title":
    "Deploy your apps and services",
  "connect_integrations_form.configure.config.waiting.bitbucket":
    "Importing your code from Bitbucket...",
  "connect_integrations_form.configure.config.waiting.bitbucket_server":
    "Importing your code from Bitbucket Server...",
  "connect_integrations_form.configure.config.waiting.default":
    "Importing your code...",
  "connect_integrations_form.configure.config.waiting.github":
    "Importing your code from GitHub...",
  "connect_integrations_form.configure.config.waiting.gitlab":
    "Importing your code from GitLab...",
  "connect_integrations_form.configure.config.waiting.subtext":
    "We'll analyze your application once the deployment is complete.",
  "connect_integrations_form.configure.local.commit.code":
    "git add .\ngit commit -m 'Add {app_name} configuration files'\n{cli_command} push",
  "connect_integrations_form.configure.local.commit.title": "Commit and deploy",
  "connect_integrations_form.configure.local.git_init.code": "git init",
  "connect_integrations_form.configure.local.git_init.description":
    "Make sure your local project is a Git repository. If not, initialize one:",
  "connect_integrations_form.configure.local.git_init.title": "Prerequisites",
  "connect_integrations_form.configure.local.init.code":
    "{cli_command} project:init\n{cli_command} project:set-remote {project_id}",
  "connect_integrations_form.configure.local.init.title":
    "Generate the configuration",
  "connect_integrations_form.configure.local.install.code.linux":
    "curl -fsSL https://raw.githubusercontent.com/platformsh/cli/main/installer.sh | bash",
  "connect_integrations_form.configure.local.install.code.macos":
    "brew install upsun/tap/platformsh-cli",
  "connect_integrations_form.configure.local.install.code.windows":
    "scoop bucket add upsun https://github.com/upsun/homebrew-tap.git && scoop install platform",
  "connect_integrations_form.configure.local.install.title":
    "Install {app_name} CLI",
  "connect_integrations_form.configure.local.review.description":
    "Open <code>{configuration_folder}/config.yaml</code> and ensure all apps and services are defined correctly.{br}See our <link>docs</link> for more guidance on writing the configuration file.",
  "connect_integrations_form.configure.local.review.title":
    "Review and complete the configuration file",
  "connect_integrations_form.configure.local.subtitle":
    "Your project is ready. Let's add an <code>{configuration_folder}/config.yaml</code> file to tell {app_name} how to build and deploy your app.",
  "connect_integrations_form.configure.local.title":
    "Deploy your app on {app_name}",
  "connect_integrations_form.description":
    "Use integrations to manage your Upsun environments directly from your Git repositories.",
  "connect_integrations_form.panel.domain.label": "Domain",
  "connect_integrations_form.panel.sync": "Sync code from {provider}",
  "connect_integrations_form.panel.validate": "Validate {provider} token",
  "connect_integrations_form.title": "Connect your code to {app_name}",
  connect_to_an_external_service: "connect to an external service",
  connect_to_bitbucket: "connect to Bitbucket",
  connect_to_github: "connect to GitHub",
  connect_with: "Connect with",
  connected: "Connected",
  connected_accounts: "Connected accounts",
  connected_to: "connected to the {userName} account",
  "conprof.comparison_mode.switch": "Compare",
  "conprof.flamebearer.comparison.legend.less": "Less {item} in B",
  "conprof.flamebearer.comparison.legend.more": "More {item} in B",
  "conprof.flamebearer.comparison.legend.only": "Only in {side}",
  "conprof.flamebearer.comparison.tooltip.footer":
    "Spans less than .1% of the total are not visible.",
  "conprof.flamebearer.comparison.tooltip.less":
    "B had less {profileTypeTitle} on average than A.",
  "conprof.flamebearer.comparison.tooltip.more":
    "B had more {profileTypeTitle} on average than A.",
  "conprof.flamebearer.comparison.tooltip.onlyA": "B is no longer present.",
  "conprof.flamebearer.comparison.tooltip.onlyB": "B is new.",
  "conprof.flamebearer.comparison.tooltip.same":
    "B had the same {profileTypeTitle} on average than A.",
  "conprof.flamebearer.comparison.tooltip.title": "Frame colors",
  "conprof.flamebearer.table.call": "Function calls",
  "conprof.flamebearer.table.exclusive": "% Excl.",
  "conprof.flamebearer.table.inclusive": "% Incl.",
  "conprof.flamebearer.tooltip.exclusive": "Excl.",
  "conprof.flamebearer.tooltip.footer":
    "% are relative to the total cost of the selected dimension.",
  "conprof.flamebearer.tooltip.inclusive": "Incl.",
  "conprof.profile_type.placeholder": "Profile Type",
  "conprof.profile_type.rate": "Rate",
  consent_description: "Authorize {app_name} to use your account",
  consent_user: "{user_name} ({user_email})",
  contact_org_owner:
    "Contact your organization owner to make necessary changes.",
  contact_sales: "Contact sales",
  contact_support: "contact our support team",
  contact_us: "Contact us",
  container_profile: "Container Profile",
  container_profile_description:
    "Container profiles give access to a specific list of CPU and RAM combinations and these combinations are allocated to each app and service depending on the range of resources it’s expected to need.",
  container_profiles: "Container profiles",
  containers: "Containers",
  continue: "Continue",
  "continue_on_desktop.description":
    "For the full {app_name} experience, jump over to {link} on your desktop to continue working with your terminal (or CLI).",
  "continue_on_desktop.subtitle": "Continue on desktop",
  "continue_on_desktop.title": "Let’s get started",
  continuous_profiling_not_available: "Continuous profiling not available",
  continuous_profiling_observability_suite:
    "Continuous profiling is a part of the Observability Suite",
  "continuous_profiling_removal_modal.cancel": "Cancel",
  "continuous_profiling_removal_modal.description":
    "Are you sure you want to remove this add-on? Removing this will lose 30 days of continuous profiling data retention and only retain this data for 15 minutes.",
  "continuous_profiling_removal_modal.disable": "Disable",
  "continuous_profiling_removal_modal.title": "Continuous profiling add on",
  cookies_to_whitelist: "cookies to whitelist",
  "cooldown.section.title": "Cool-down periods",
  copied: "Copied",
  copied_to_clipboard: "Copied to clipboard!",
  copy: "Copy",
  copy_build_url: "Copy URL",
  copy_log_content: "Copy log",
  copy_log_url: "Copy log URL",
  country: "Country",
  "cpu.guaranteed": "Guaranteed CPU",
  cpu_cores: "cpu cores",
  cpu_dialog: "CPU",
  "cpu_dialog.value": "{value} CPU",
  cpu_resource_allocation_info:
    "The total amount of CPU allocated to all the application, service and worker containers on this environment",
  create: "create",
  "create_first_organization.details":
    "Your organization is the workspace where your projects will live. Expecting to join your team’s existing organization? Ask an organization admin to send you an invite.",
  "create_first_organization.name.info":
    "Organizations own projects. You may choose to create a personal organization for your projects, or one for your companies projects.",
  "create_first_organization.path.info":
    "This is the unique url path to your organization’s projects.",
  "create_first_organization.subtitle": "Welcome to {appName}!",
  "create_first_organization.title": "Create your organization",
  create_first_project: "Create your first project",
  "create_first_project.trial":
    "Create your first project to start your free trial",
  create_first_project_description:
    "Use your own code, migrate a project, or use a project template to get started.",
  "create_first_project_description.paid":
    "Use your own code, migrate a project, or try a demo project to get started. Remember, with First Project Incentive, we’ll cover the equivalent costs of your first user license and project fee every month. To get started, just add on your resources.",
  "create_from_scratch.create": "Get started",
  "create_from_scratch.description":
    "Manually push your code to {appName}. Integrate GitHub or others for CI/CD later.",
  "create_from_scratch.title": "Deploy from a local Git repository",
  create_new_organization: "create new organization",
  create_new_project: "Create Project",
  create_new_team: "create new team",
  create_organization: "Create organization",
  "create_organization.billing_system.description":
    "When enabled, this organization will be created on the new billing system.",
  "create_organization.billing_system.label": "Create on new billing system",
  "create_organization.support.fixed":
    "If you need a <b>Fixed</b> organization, please submit a <support>support ticket.</support>",
  "create_organization.trial_info.containers.description":
    "Unlimited app & service containers and 1\u00a0on-demand task container (within the resources described below).",
  "create_organization.trial_info.containers.label": "Containers",
  "create_organization.trial_info.environments.description": "2",
  "create_organization.trial_info.environments.label": "Running environments",
  "create_organization.trial_info.organization.description": "1",
  "create_organization.trial_info.organization.label": "Organization",
  "create_organization.trial_info.project.description": "1",
  "create_organization.trial_info.project.label": "Project",
  "create_organization.trial_info.resources.description":
    "Up to 4.5\u00a0CPUs, 12\u00a0GB\u00a0RAM, and 20\u00a0GB\u00a0disk running concurrently.",
  "create_organization.trial_info.resources.label": "Resources",
  "create_organization.trial_info.title": "Your free trial includes",
  "create_organization.trial_info.users.description": "Unlimited",
  "create_organization.trial_info.users.label": "Users",
  create_project: "Create project",
  "create_project.connect.description":
    "Deploy from your existing repositories",
  "create_project.connect.title": "Connect your repository",
  "create_project.demo.create": "Demo app",
  "create_project.demo.title": "Deploy demo app",
  "create_project.provider.local": "Local repo",
  "create_project_button.create_first_organization.cta": "Create organization",
  "create_project_button.create_first_organization.description":
    "To manage projects, billing, and more, you must first create an organization. Organizations may be used for personal projects or for your company. Create your first organization to enable projects, teams, and more!",
  "create_project_button.create_first_organization.title":
    "Create an organization to get started!",
  "create_project_button.delete_demo_project.cta": "Yes, delete and continue",
  "create_project_button.delete_demo_project.description":
    'Your free trial allows for one project. Click "Yes" to confirm deletion and continue with your new project.<br></br>Or <link>subscribe to {app_name}</link> to create more projects',
  "create_project_button.delete_demo_project.title":
    "Delete the Demo project to continue",
  "create_project_button.disabled.tooltip":
    "Contact your admin for permission to create projects.",
  "create_project_button.generic.title": "You can not create a project",
  "create_project_button.restricted_org.admin.description":
    "You cannot create projects at this time because your organization is inactive.",
  "create_project_button.restricted_org.contact_support": "Contact support",
  "create_project_button.restricted_org.member.description":
    "You cannot create projects at this time because your organization is inactive.",
  "create_project_button.restricted_org.member.disclaimer":
    "Contact your organization admin to resolve this issue.",
  "create_project_button.restricted_org.title": "Inactive organization",
  "create_project_button.trial_limit_reached.cancel": "Cancel",
  "create_project_button.trial_limit_reached.description":
    "To create another project, please delete your existing one or subscribe to {app_name} today to create more projects.",
  "create_project_button.trial_limit_reached.subscribe": "Subscribe",
  "create_project_button.trial_limit_reached.title":
    "Your trial is limited to one project",
  "create_project_modal.button": "Create a project",
  "create_project_modal.description":
    "Continuous profiling is a project-based add-on. Please create a project to enable this feature.",
  "create_project_modal.title": "Create a project",
  create_your_organization: "Create your organization",
  created: "created",
  created_a_new_project: "created a new project",
  created_backup: "created backup",
  created_environment: "created environment",
  created_on: "created on",
  creating_backup: "is creating a backup",
  "credit-card": "Credit card",
  credit_card: "Credit card",
  credit_card_number: "Credit card number",
  critical_issues: "critical issues",
  critical_projects: "critical projects",
  crons: "Crons",
  "crons.cancelled": "Last execution cancelled",
  "crons.failed": "Last execution failed",
  "crons.succeeded": "Last execution succeeded",
  crons_dialog: "Crons",
  current_password: "Current password",
  custom_form: "custom form",
  customer_g2:
    "{app_name} is a leader in Cloud Platform as a Service according to our customers on G2.",
  customer_type_company: "Company",
  customer_type_governance: "Public sector",
  customer_type_individual: "Individual",
  cvc: "cvc",
  dark: "Dark",
  darkmode: "Dark mode",
  dashboard: "dashboard",
  "dashboard.search_placeholder": "Search by project name",
  data: "data",
  dataLine: "Data line",
  data_available_duration: "Data available for {duration}",
  deactivate_button: "Deactivate & Delete Data",
  deactivate_confirm_button: "Deactivate environment and delete data",
  deactivate_confirm_text:
    "Are you sure you want to deactivate the environment",
  deactivate_environment: "Deactivate environment",
  "deactivate_environment.button": "Deactivate environment and delete data",
  deactivated_environment: "deactivated environment",
  december: "December",
  dedicated: "Dedicated",
  "dedicatedenv.dialog.text": "This branch deploys to Dedicated Infrastructure",
  "dedicatedenv.dialog.title": "Dedicated environment",
  "default.included": "Default included",
  default_ttl: "default ttl",
  "define.thresholds.docs":
    "Define the thresholds per resource or metric for automatic scaling events. To learn more about autoscaling, <link>check out our documentation</link>.",
  delete: "delete",
  "delete_account.description":
    "I would like to delete my Upsun account, including any linked Ibexa Cloud, Pimcore PaaS, or Shopware PaaS accounts. I understand that Blackfire accounts must be deleted separately via support.blackfire.io.",
  "delete_account.subject": "Delete my account",
  delete_branch_link:
    "https://docs.upsun.com/anchors/fixed/environments/deactivate/delete-branch/",
  delete_branch_link_cli: "CLI command",
  delete_confirm_button: "Delete environment",
  delete_confirm_text:
    "Are you sure you want to delete the environment {environmentName} from {projectName}? Type the environment name to confirm that you want to delete this environment.",
  delete_environment: "Delete environment",
  delete_environment_description:
    "While the branch is available, you can activate this environment at a later time. Reactivating will sync data from the parent environment and redeploy.",
  delete_git_branch: "delete Git branch",
  delete_git_branch_description: "also deletes Git branch",
  delete_git_branch_text:
    "If you would like to remove the branch completely, you need to use Git and run:",
  delete_organization: "Delete organization",
  deleted_backup: "deleted backup",
  deleted_domain: "deleted domain",
  deleted_environment: "deleted environment",
  deleted_environment_variable: "deleted environment variable",
  deleted_project_variable: "deleted project variable",
  deleted_route: "deleted route",
  "demo_project.create": "Get started",
  "demo_project.description":
    "Explore {appName}'s core features with the {appName} Demo App.",
  "demo_project.title": "Deploy {appName} Demo",
  deploy: "Deploy",
  "deploy.button.deploy": "Deploy",
  "deploy.button.next": "Next",
  "deploy.button.set_maintenance_window": "Set maintenance window",
  "deploy.button.start": "Start",
  "deploy.command": "{commandName} environment:deploy",
  "deploy.modal.note": "note",
  "deploy.modal.radio.deploy": "Deploy",
  "deploy.modal.radio.deploy.description":
    "Deploy the latest code and configuration to the environment.",
  "deploy.modal.radio.redeploy": "Redeploy",
  "deploy.modal.radio.redeploy.description":
    "Restart the environment using the existing code and configuration. No staged changes will be applied.",
  "deploy.modal.text":
    "Deploy the environment using the latest code and configuration, or simply restart it without making any changes.",
  "deploy.modal.title": "Choose an action",
  "deploy.redeploy_checkbox.description":
    "Restarts the environment while keeping the current code and configuration intact.",
  "deploy.rejected.toaster.message":
    "The deployment couldn’t start due to a backend error. Try again later.",
  "deploy.sticker.text": "You’re up to date. Redeploy if needed.",
  deploy_anywhere: "Deploy at scale anywhere!",
  deploy_key: "deploy key",
  deploy_key_description:
    "Add this SSH public key to your private code repositories to allow {appName} to access them during the build process.",
  deploy_your_application: "Deploy your application",
  deployed_environment: "deployed",
  "deployment.cancelled": "Deployment cancelled",
  "deployment.failure": "Deployment failure",
  "deployment.failure.build": "Build failure",
  "deployment.successful": "Deployment successful",
  "deployment.warning.hooks": "Deployed with failing {hooks}",
  "deploymentStrategy.modal.deployment_failed":
    "Your last deployment failed, so we won’t be able to guarantee zero downtime. Deploy again using the stop-start strategy.",
  "deploymentStrategy.modal.radio.rolling": "Zero-downtime",
  "deploymentStrategy.modal.radio.rolling.description":
    "Deploys a new version alongside the current one and switches traffic seamlessly. No downtime for users. Verify compatibility.",
  "deploymentStrategy.modal.radio.stopstart": "Stop-start",
  "deploymentStrategy.modal.radio.stopstart.description":
    "Stops the service, applies the update, then restarts it. Causes a short downtime.",
  "deploymentStrategy.modal.title": "Select deployment strategy",
  "deploymentStrategy.note":
    "Note: Additional instances are tracked for usage costs.",
  "deploymentStrategy.note.no_maintenance_window":
    "No maintenance window defined. Set it in the next step.",
  "deploymentStrategy.rolling.command": "upsun deploy -s rolling",
  "deploymentStrategy.sticker.no_maintenance_window":
    "Ask your project admin to set a maintenance window in Project settings.",
  "deploymentStrategy.stopstart.command": "upsun deploy -s stopstart",
  deployment_agreement:
    "by continuing, I understand that this project and its usage costs will be added to my monthly invoices and charged to the credit card on file for this account.",
  deployment_service_load_error:
    "There was error loading your deployments deployments",
  detele_account: "Delete account",
  dev_envs: "development environments",
  dev_plan: "Development plan",
  dev_plan_info:
    "The development plan does not allow mapping a domain name to the production environment and cannot be used for live websites.",
  developers: "developers",
  development: "development",
  development_description: "agile project development",
  development_details:
    "Test every feature in parallel and in isolation with automatically generated staging servers for every git branch.",
  dgh_view: "DGH View",
  "dgh_view.toggle.tooltip": "Toggle between DGH and container view",
  "disable.autoscaling.suggestion.tooltip":
    "To manage instances manually, disable autoscaling",
  disable_fastly_origin_restriction: "disabled fastly origin restriction",
  disabled: "disabled",
  disconnect: "Disconnect",
  disk: "Disk",
  disk_dialog: "Disk",
  disk_resource_allocation_info:
    "The total amount of the persistent writable mounts allocated to all the application, service and worker containers on this environment",
  display_name: "Display name",
  display_settings: "Display settings",
  docs: "Docs",
  documentation: "documentation",
  documentations: "docs",
  domain: "domain",
  "domain.input.placeholder": "stagingdomain.com",
  domain_name: "Domain name",
  domains: "domains",
  "domains.add_subtitle":
    "Enter the domain name and select a production domain for environment mapping.",
  "domains.add_title": "Add preview environment domain",
  "domains.back_to": "Back to domains",
  "domains.complete.configuration.description":
    "The domain {customDomain} was successfully added. If you haven’t already, copy the target below and add it to your DNS provider as a CNAME record.",
  "domains.complete.configuration.title": "Complete configuration",
  "domains.details.learn_more":
    "You can’t edit a custom preview environment domain. You can only delete it and create a new one as a replacement.",
  "domains.documentation":
    "Learn more about domains in our <a>documentation</a>",
  "domains.environment": "Environment",
  "domains.learn_more":
    "For the routing of your app, attach your preview environment domain to an existing production domain. <link>Learn more</link>",
  "domains.production_domains": "Production domains",
  "domains.replacement_domain": "Attached production domain",
  "domains.replacement_domain.info":
    "For the routing of your app, attach your preview environment domain to an existing production domain.",
  "domains.select_domain": "Select a domain",
  dont_have_account: "don’t have an account?",
  dont_have_account_yet: "don’t have an account yet? Sign up for free today!",
  downgrade: "Downgrade",
  "download.pdf": "Download PDF",
  download_build_log: "Download .txt log",
  "drawer.troubleshooting.intro":
    "Once your project is deployed, use these quick checks to diagnose startup and connectivity issues. For full details, see our",
  "drawer.troubleshooting.intro.link": "Troubleshoot development",
  "drawer.troubleshooting.intro.page": "page.",
  "drawer.troubleshooting.section1.all_logs": "All logs",
  "drawer.troubleshooting.section1.all_logs_desc":
    "(<code>{cli_command} log</code>) lists every available log stream.",
  "drawer.troubleshooting.section1.app_logs": "App logs",
  "drawer.troubleshooting.section1.app_logs_desc":
    "(<code>{cli_command} log app</code>) reveal stack traces, syntax errors, or missing dependencies.",
  "drawer.troubleshooting.section1.deploy_logs": "Deploy logs",
  "drawer.troubleshooting.section1.deploy_logs_desc":
    "(<code>{cli_command} log deploy</code>) show build and migration-time errors.",
  "drawer.troubleshooting.section1.learn_more": "Learn more about logs",
  "drawer.troubleshooting.section1.title": "1. Check logs",
  "drawer.troubleshooting.section2.bullet1":
    "Launches your process (e.g. {npm_start}, {gunicorn}) without exiting",
  "drawer.troubleshooting.section2.bullet1.gunicorn": "gunicorn",
  "drawer.troubleshooting.section2.bullet1.npm_start": "npm start",
  "drawer.troubleshooting.section2.bullet2":
    "Binds to the port in the <code>$PORT</code> environment variable (<code>{cli_command} ssh 'echo $PORT' </code>)",
  "drawer.troubleshooting.section2.code": "web.command.start",
  "drawer.troubleshooting.section2.file": "./upsun/config.yaml",
  "drawer.troubleshooting.section2.intro": "Ensure your {code} in {file}:",
  "drawer.troubleshooting.section2.learn_more": "Read about start commands",
  "drawer.troubleshooting.section2.title": "2. Verify start command",
  "drawer.troubleshooting.section3.bullet1":
    "<code>{cli_command} activity:log</code> —> view the latest activity log",
  "drawer.troubleshooting.section3.bullet2":
    "<code>{cli_command} activity:list</code> —> list recent operations",
  "drawer.troubleshooting.section3.intro":
    "In the Console, select an environment activity to inspect failures or timeouts. Or via CLI:",
  "drawer.troubleshooting.section3.learn_more": "CLI activity reference",
  "drawer.troubleshooting.section3.title": "3. Review recent activity",
  "drawer.troubleshooting.section4.bullet1":
    "Inspect internal log files and writable mounts (<code>{cli_command} mount:list</code>)",
  "drawer.troubleshooting.section4.bullet2":
    "Test service connections and explore the filesystem",
  "drawer.troubleshooting.section4.intro":
    "Run <code>{cli_command} ssh</code> to:",
  "drawer.troubleshooting.section4.learn_more":
    "Learn more about container access",
  "drawer.troubleshooting.section4.title": "4. SSH into the container",
  "drawer.troubleshooting.section5.code_example1":
    "<code>ping database.internal</code>",
  "drawer.troubleshooting.section5.code_example2":
    "<code>psql $DATABASE_URL</code>",
  "drawer.troubleshooting.section5.intro":
    "From within the container, confirm reachability of linked services:",
  "drawer.troubleshooting.section5.learn_more": "Adding and linking services",
  "drawer.troubleshooting.section5.outro":
    "Ensure services are declared under {services} in: {file}.",
  "drawer.troubleshooting.section5.outro.file": ".upsun/config.yaml",
  "drawer.troubleshooting.section5.outro.services": "services:",
  "drawer.troubleshooting.section5.title": "5. Verify service connectivity",
  "drawer.troubleshooting.title": "Troubleshooting your application",
  "dropdown.container_log.code":
    "{cli_command} log -p {projectId} -e {environmentId}",
  "dropdown.container_log.description":
    "View logs to debug issues and monitor the environment.",
  "dropdown.container_log.go_to_logs": "Go to logs",
  "dropdown.container_log.label": "Container logs",
  "dropdown.container_log.logs_notice":
    "Browse all this environment's logs in one place",
  "dropdown.disabled.deleting": "Deleting environment.",
  "dropdown.disabled.inactive":
    "Inactive environment. Change status in general settings.",
  "dropdown.disabled.logs": "Select an environment to access container logs",
  "dropdown.disabled.logs.not_ready":
    "Container logs are available once the project is set up",
  "dropdown.disabled.paused":
    "Paused environment. Change status in general settings.",
  "dropdown.disabled.ssh": "Select an environment to access SSH",
  "dropdown.disabled.ssh.no_commands": "There are no SSH commands available",
  "dropdown.disabled.ssh.not_ready":
    "SSH is available once the project is set up",
  "dropdown.disabled.url": "Select an environment to access URLs",
  "dropdown.disabled.url.not_ready":
    "App URLs generate once the project is set up",
  "dropdown.routes.code": "{cli_command} route:list --project {projectId}",
  "dropdown.routes.description":
    "List project routes details such as application mapping and types.",
  "dropdown.routes.no_env":
    "First select an environment to preview your application routes.",
  "dropdown.routes.overview": "Routes overview",
  "dunning.update_billing": "Update billing",
  duplicate_email: "{email} already has access to the project",
  duration: "Duration",
  "duration.of": "% for the last",
  easily_add: "Easily add & manage your services",
  edit: "Edit",
  "edit_billing_account.description.business":
    "Only the name of the billing account can be changed.<br></br>For all other changes, please <link>contact our support team</link>.",
  "edit_billing_account.description.individual":
    "Edit your account name or choose a new account type below. Please note that self-service changes are only available when updating from an Individual account—for any other billing changes, please <link>contact our support team</link>.",
  "edit_billing_account.description.upgrade":
    "The legal entity or individual responsible for charges. It acts as the umbrella for your billing profiles and holds the Tax ID (if applicable).",
  "edit_billing_account.display_name": "Billing account display name",
  "edit_billing_account.display_name.description":
    "This name identifies this account in your billing interfaces and drop downs.",
  "edit_billing_account.title": "Edit billing account",
  "edit_billing_profile.description":
    "Update the billing profile details below.",
  "edit_billing_profile.title": "Edit billing profile",
  "edit_billing_user.save": "Save",
  "edit_billing_user.title": "Edit billing member",
  edit_domain: "edit domain",
  edit_plan: "Edit plan",
  edit_route: "edit route",
  edit_user: "edit user",
  edit_user_organization:
    "Edit the permissions of your user for this organization",
  edit_variable: "edit variable",
  email: "Email",
  email_address: "Email address",
  email_confirmation: "Email confirmation",
  email_placeholder: "Email address",
  email_sending:
    "<b>Enable outgoing emails:</b> This allows your application to send emails via a SendGrid-based SMTP proxy.",
  "email_sending.description":
    "This allows your application to send emails via a SendGrid-based SMTP proxy",
  "email_sending.title": "<b>Enable outgoing emails</b>",
  email_success_change: "Your email was successfully changed!",
  email_username: "Email",
  email_username_placeholder: "Email address",
  empty_repository: "empty repository",
  enable: "Enable",
  "enable.thresholds.configuration.info":
    "Retain your configurations, but remove the graph indicators and disable the activity creation when threshold is breached.",
  "enable.thresholds.configuration.info.title": "Enable thresholds",
  enable_continuous_profiling: "Enable continuous profiling",
  enable_high_contrast: "Enable high contrast mode",
  enabled: "enabled",
  "enabled.description":
    "Variables can be enabled or disabled per environment.",
  enabled_no_cap: "enabled",
  end_to_end: "end-to-end",
  endpoint: "Endpoint",
  enter_company_name: "Enter company name here",
  enter_team_name: "enter team name",
  enter_team_name_example: "e.g. developers",
  enter_url: "Enter URL here",
  enter_valid_email: "Please enter a valid email address",
  enterprise: "enterprise",
  "entity_header.error_loading_entity":
    "Failed to load billing entity details. Please try again.",
  env_name_delete: "Environment name",
  "env_name_delete.placeholder": "Name",
  "environemnt.activity.deleted.tooltip": "This environment has been deleted.",
  environment: "environment",
  "environment types": "environment types",
  "environment.access.environment_types":
    "Permission changes to this environment will apply to all other environments of this type.",
  "environment.access.redeploymessage":
    "For changes to take effect please redeploy this environment",
  "environment.accesslist.add_user": "Add user",
  "environment.accesslist.description":
    "Configure your users access to this environment and/or its child environments.",
  "environment.backups.backupSize": "({backupSize} GB)",
  "environment.backups.btn.manage_schedule": "Manage schedule",
  "environment.backups.empty.details":
    "You have no recent or running backups on this environment.",
  "environment.backups.empty.title": "No backups",
  "environment.backups.info.dev":
    "This environment has a maximum <strong>{amount} manual </strong> backups. Additional backups made will replace the oldest backup.",
  "environment.backups.info.prod":
    "This environment has a maximum <strong>{automatedAmount} automated</strong> and <strong>{manualAmount} manual</strong> backups. Additional backups made will replace the oldest manual backup.",
  "environment.backups.modal.checkbox": "Create live backup",
  "environment.backups.modal.custom_backup_schedule.note":
    "Note: Creating a backup will impact your monthly project cost. <link>View pricing page</link>",
  "environment.backups.modal.explanation":
    "Create a complete backup of this environment. Your backup will include all persistent data from all running services and any files stored on mounted volumes.",
  "environment.backups.modal.info_dialog.text":
    "Manual live backups are run without any downtime to your environment, but may result in data inconsistencies. Alternatively, consistent backups run after pausing all requests which can result in downtime.",
  "environment.backups.modal.info_dialog.title": "Live Backups",
  "environment.backups.modal.lastbackup.progress": "In progress...",
  "environment.backups.modal.lastbackup.text": "Last backup:",
  "environment.backups.modal.note":
    "Note: This backup will replace your oldest stored backup.",
  "environment.backups.title": "Backups",
  "environment.backups.tooltip.custom_backup_scheduling.description":
    "Backups are charged based on the total storage used. There is no limit to the number of backups or backup schedules that you can have.",
  "environment.branch.error.admin.description":
    "To add more environments upgrade your plan as you have used all of your allocated environments.",
  "environment.branch.error.standard.description":
    "To add more environments upgrade your plan as you have used all of your allocated environments.  Contact your project owner to upgrade your plan settings.",
  "environment.branch.error.title": "Environment limit reached",
  "environment.deployment_type.descripton.no_permission":
    "Ask your admin to change this",
  "environment.details.no_url": "Waiting for URL...",
  "environment.not.redeployed":
    "Environment can not be redeployed until it is configured.",
  "environment.notfound": "environment not found",
  "environment.overview.crons": "Crons",
  "environment.overview.crons.sleeping":
    "Crons are paused, as there’s been 14 days of no deployment activity on this environment.",
  "environment.overview.crons.status.paused": "paused",
  "environment.overview.crons.status.running": "running",
  "environment.overview.crons.status.sleeping": "Paused",
  "environment.overview.deployment_type": "Deployment type",
  "environment.overview.deployment_type.automatic": "automatic",
  "environment.overview.deployment_type.description":
    "You can deploy automatically (default), or choose to enable manual deployments where changes to code, variables, domains, and settings are queued until you manually trigger a deployment.{br} Applies to production and staging environments.",
  "environment.overview.deployment_type.info":
    "There are staged changes that require a deployment",
  "environment.overview.deployment_type.learnMore": "Learn more",
  "environment.overview.deployment_type.manual": "manual",
  "environment.overview.deployment_type.no_access":
    "Ask your admin to change this",
  "environment.overview.deployment_type.settings": "Settings",
  "environment.overview.deployment_type.title": "Deployment type",
  "environment.overview.explicit_deployment.info":
    "There are staged changes that require a deployment",
  "environment.routes.viewall": "View all routes",
  "environment.search": "Search environments",
  "environment.services.configuration.routes":
    "Routes describe how an incoming HTTP request is going to be handled by {appName}.<br></br>They are defined using the <code>{appRouteFilePath}</code> file in your Git repository and can be configured through code. To make changes to your route you can edit this file, commit and push it to the git remote.",
  "environment.services.configuration.routes_doc":
    "Visit our <a>documentation</a> on Routes to find examples and settings for HTTP Cache, Redirects, and Server Side Includes.",
  "environment.settings.active.description":
    "You can pause environment to prevent unnecessary consumption of resources.",
  "environment.settings.active.description.production":
    "Paused production environment might cause downtime and impact your live services.",
  "environment.settings.deployment_type":
    "<b>Enable automatic deployments:</b> Changes are deployed automatically as they’re made. If disabled, all changes are staged until you manually trigger a deployment.",
  "environment.settings.deployment_type.confirm_modal.description":
    "Updating this setting will immediately start a deployment to apply all pending changes.{br}Are you sure you want to proceed?",
  "environment.settings.deployment_type.confirm_modal.title":
    "This action will trigger a deployment",
  "environment.settings.deployment_type.description":
    "Changes are deployed automatically as they’re made. If disabled, all changes are staged until you manually trigger a deployment.",
  "environment.settings.deployment_type.title":
    "<b>Enable automatic deployments:</b>",
  "environment.settings.explicit_deployment.automatic.description":
    "Changes are deployed immediately as they are made.",
  "environment.settings.explicit_deployment.automatic.label": "Automatic",
  "environment.settings.explicit_deployment.label": "Deployment type",
  "environment.settings.explicit_deployment.manual.description":
    "Changes to code, variables, domains, and settings are queued until you trigger a deployment.",
  "environment.settings.explicit_deployment.manual.label": "Manual",
  "environment.settings.paused.description":
    "The environment was paused manually or after two weeks of inactivity, which reduces its electricity consumption/carbon emissions.",
  "environment.settings.pausedEnv.btn": "{status} environment",
  "environment.settings.paused__or_active_env.title":
    "Status is <strong>{status}</strong>",
  "environment.status.active": "active",
  "environment.status.deleting": "deleting",
  "environment.status.dirty": "building",
  "environment.status.disabled": "disabled",
  "environment.status.inactive": "inactive",
  "environment.status.inactive.main.title": "Main environment inactive",
  "environment.status.inactive.title": "Environment inactive",
  "environment.status.inactive.update":
    "This environment does not have a URL, as the status is inactive. You can update your status in general settings.",
  "environment.status.inactive.url": "URL unavailable",
  "environment.status.no_routes.main.title": "Main environment has no routes",
  "environment.status.no_routes.title": "Environment has no routes",
  "environment.status.no_routes.update":
    "This environment does not have a URL, as no routes have been defined. Define routes in your .platform/routes.yaml file.",
  "environment.status.paused": "paused",
  "environment.upgrade.admin.description":
    "To enable this environment, you will need to upgrade your plan settings, as you have used all of your allocated environments.",
  "environment.upgrade.standard.description":
    "To enable this environment, you will need to upgrade your plan settings, as you have used all of your allocated environments.  Please contact your project owner to upgrade your plan settings.",
  "environment.variable.access":
    "To add or edit variables you need project admin access on this environment",
  "environmentTree.line.child.inactive": "Inactive child branch",
  "environmentTree.line.commit": "Commit: {sha}",
  "environmentTree.line.deployment.activity.inprogress": "In progress",
  "environmentTree.line.deployment.inprogress": "Deploying...",
  "environmentTree.line.deployment.is.paused": "Environment is paused",
  "environmentTree.line.deployment.last.failed": "Last deployment failed",
  "environmentTree.line.deployment.last.not_found": "No deployment found",
  "environmentTree.line.deployment.last.success": "Last deployment successful",
  "environmentTree.line.parent": "Parent branch",
  "environmentTree.line.parent.inactive": "Inactive Parent branch",
  "environmentTree.line.root": "Main branch",
  "environmentTree.line.root.inactive": "Inactive Main branch",
  "environmentTree.line.route.ssl_encrypted": "SSL encrypted",
  "environmentTree.menu.empty": "No results",
  "environmentTree.navbar.filter.active": "Active",
  "environmentTree.navbar.filter.inactive": "Inactive",
  "environmentTree.navbar.filter.label": "Filter by",
  "environmentTree.navbar.filter.show": "Show",
  "environmentTree.navbar.filter.sort": "Sort by",
  "environmentTree.navbar.filter.sort_available":
    "Environments can only be sorted in the list view.",
  "environmentTree.navbar.filter.title": "Filter environments",
  "environmentTree.navbar.search": "Search",
  "environmentTree.navbar.sort.created_at": "Date created",
  "environmentTree.navbar.sort.title": "Alphabetically A-Z",
  "environmentTree.sort.created_at": "Created",
  "environmentTree.sort.deployed_at": "Deployed",
  "environmentTree.sort.title": "Environment name",
  "environmentTree.sort.type": "Type",
  "environmentTree.sort.url": "URLs",
  environment_application_size: "Environments Application size",
  environment_application_size_message:
    "All development environments default to the Standard size. The size can be increased to match your production environment if needed.",
  environment_by_type: "Environments by type",
  environment_deleted_or_inactive:
    "We couldn't find the environment you're looking for. It might have been deleted or doesn't exist. Please try refreshing your browser.",
  environment_health: "environment health",
  "environment_impact.carbon_intensity": "~{carbonIntensity} gCO2eq/kWh",
  "environment_impact.default":
    "All of our infrastructure providers are committed to improving their environmental footprints.",
  "environment_impact.default.green":
    "Get a 3% discount by deploying to our greener regions!",
  "environment_impact.green":
    "Includes 3% discount on CPU, memory, and build resources",
  "environment_impact.label": "Energy Grid Carbon Intensity",
  environment_info: "environment info",
  environment_maintenance_redeployed_description:
    "Maintenance Window for environment <strong>{environment}</strong>, redeployed",
  environment_maintenance_redeploying_description:
    "Maintenance Window for environment <strong>{environment}</strong>, redeploying",
  environment_name: "Environment name",
  "environment_services.search_placeholder": "Search apps and services",
  environment_settings: "Environment settings",
  "environment_settings.error.deployment_type.inactive":
    " This environment is inactive. Activate it to change the deployment type.",
  "environment_settings.error.deployment_type.type_downgrade":
    "Development environments need automatic deployments to run. Enable them to proceed.",
  "environment_status.warning":
    "This action will destroy all services running on this environment (PHP, MySQL, volumes...) so that only the Git branch remains.",
  environment_text: "environment",
  environment_type: "Environment type",
  environment_type_name: "environment type name",
  environment_type_permissions: "Environment type permissions",
  environment_types: "environment types",
  environments: "Environments",
  "environments.empty_state":
    "Environments will be listed here after the project is initialized.",
  "environments.links_tooltip": "{title} branch links",
  "environments.list_layout": "environments list layout",
  "environments.tree_layout": "environments tree layout",
  environments_description: "{price} a month per 3 environments",
  error_403_title: "Access denied",
  error_environment_403:
    "You do not have permission to access this environment. Please contact the project administrator to request access.",
  error_loading_environment: "It's not you - it's us",
  error_loading_environment_description:
    "The environment you were looking for could not be found.",
  error_loading_invitation: "It's not you - it's us",
  error_loading_invitation_description:
    "The invitation you were looking for could not be found.",
  error_loading_organization: "It's not you - it's us",
  error_loading_organization_description:
    "The organization {organizationName} could not be found.",
  error_loading_organizations: "It's not you - it's us",
  error_loading_organizations_description:
    "We couldn't load your organizations. Please try again.",
  error_loading_organizations_retry: "Try again",
  error_loading_project: "It's not you - it's us",
  error_loading_project_description:
    "The project you were looking for could not be found.",
  error_organization_403:
    "You do not have permission to access the organization {organizationName}. Please contact the project administrator to request access.",
  error_organization_404:
    "The organization {organizationName} could not be found.",
  error_organization_502:
    "The organization {organizationName} is not responding, please contact support.",
  error_project_403:
    "You do not have permission to access this project. Please contact the project administrator to request access.",
  error_project_404: "The project you were looking for could not be found.",
  error_project_502:
    "The project you were looking for is not responding, please contact support.",
  error_status: "You can check {appName} status <a>here</a>",
  estimated_cost: "Estimated cost",
  estimated_total: "estimated monthly total",
  example_file: "Example file",
  expires: "Expires",
  expiry: "expiry",
  failure: "Failure",
  fastest_way: "The fastest way to build digital products",
  february: "February",
  "field.is_required": "{label} is required.",
  "file.services.yaml": "{prependText}: services.yaml",
  file_example: "File example",
  files: "files",
  filledArea: "Filled area",
  filter: "Filter",
  "filter.domain": "Domain",
  "filter.integration": "Integrations",
  "filter.title": "Filter by",
  "filter.upgrade": "Upgrade",
  filter_hosts: "Filter hosts",
  "filter_select.count_of_total": "{count} of {total}",
  "filter_select.no_matching_values_found": "No matching values found",
  "filter_select.search.placeholder": "Filter values",
  finish_country_setup: "Please add your country to finish your account setup.",
  finish_setup: "Finish setup",
  first_name: "First name",
  "first_project_incentive.tag": "First Project Incentive: $19",
  "first_project_incentive.tag.indicator":
    "First Project Incentive: {allowanceDiscount} ¹",
  "footer.message": "Version {appVersion} {footerText} Upsun",
  for: "for",
  for_example: "E.g.",
  forgot_password: "I forgot my password",
  forgot_your_password: "Forgot your password",
  forgot_your_password_federated:
    "Your password cannot be reset on {app_name} as your account is subject to third-party authentication. Use the link below to access your authentication provider",
  free_during_trial: "Free during trial",
  free_trial: "Free trial",
  free_trial_info:
    "We offer new users a one-month free development plan trial. The development plan doesn’t allow mapping a domain name to the production environment and can’t be used for live websites.",
  frequency: "Frequency",
  from: "from",
  full_name: "Full name",
  gb_memory: "<b>{value}</b> GB memory",
  general: "general",
  general_project_settings: "General project settings",
  git: "Git",
  "git.clone.description": "Clone your codebase using Git and an SSH Key.",
  "git.learnmore": "Learn More",
  git_clone: "git clone",
  git_driven:
    "Git-driven development workflow with instant environment cloning",
  git_driven_short: "Git-driven development workflow",
  global_security: "Global security, 24/7",
  go_to_your_sso_provider: "Go to your SSO provider",
  "green_discount.description":
    "Projects deployed on carbon-efficient regions receive at 3% discount on CPU, memory, and build resources.",
  "green_discount.title": "Green discount",
  grid: "Grid",
  group_by_type: "Group by type",
  groups: "groups",
  havent_receive: "haven’t received your email yet?",
  headers_to_whitelist: "headers to whitelist",
  health: "health",
  healthy_projects: "healthy projects",
  help: "Get help",
  "help.community.forum": "Community forum",
  "help.submit_idea": "Submit an idea",
  help_support: "Help & Support",
  help_text: "Help",
  hidden: "hidden",
  hide_all_instances: "hide all",
  hide_commits: "Hide",
  hight_performance: "High performance container based multicloud hosting",
  hipaa: "HIPAA",
  history: "History",
  home: "home",
  host: "Host",
  how_do_you_want_to_start: "How do you want to start?",
  hsts: "HSTS",
  "http.bandwidth.info":
    "Your total bandwidth is all of the bandwidth used in the timeframe selected.",
  "http.display_all_urls": "Display all URLs",
  "http.impact": "Impact",
  "http.method": "Method",
  "http.no_impact_url": "No URLS available",
  "http.other_urls": "Other URLs",
  "http.requests": "Requests",
  "http.response_time.avg": "Response time (Average)",
  "http.response_time.p50": "Response time (Median)",
  "http.response_time.p96": "Response time (P96)",
  "http.show_top_urls_only": "Show only top URLs",
  "http.status_codes": "Status codes",
  "http.top_impact_url": "Top URL Impact",
  "http.top_timestamp_impact_url": "Top {count} URL timestamp Impact",
  "http.url_impact": "URL impact",
  "http.url_impact.info":
    "Impact is the percentage of time spent in a URL versus all the other ones. Displays up to {count} top URLs; the remainder are grouped as Other URLs.",
  http_access: "HTTP access",
  http_request: "HTTP requests",
  http_traffic: "HTTP traffic",
  "https_access.description":
    "To redirect access to your environment's website, please add either login or IP address details. You can disable this at any time without losing your credentials.",
  "icons.copied": "Copied!",
  "icons.copy": "Copy to clipboard",
  "icons.copy_log": "Copy log",
  "icons.download": "Download file",
  "icons.downloaded": "Downloaded!",
  "icons.grid": "Grid",
  "icons.list": "List",
  "icons.share_link": "Copy link",
  image: "image",
  "image.dialog.decommissioned.description":
    "<strong>{imageId} [{serviceName}]</strong> was decommissioned on {decommissionDate}. Builds using this image are blocked. Upgrade to a supported version to continue deploying. {br}<link>Upgrade guide</link>",
  "image.dialog.decommissioned.no_dates.description":
    "<strong>{imageId} [{serviceName}]</strong> was decommissioned. Builds using this image are blocked. Upgrade to a supported version to continue deploying. {br}<link>Upgrade guide</link>",
  "image.dialog.sunset.pre_sunset.description":
    "<strong>{imageId} [{serviceName}]</strong> will reach end of support on {sunsetDate}. Plan your upgrade to avoid disruption.{br}<link>Upgrade guide</link>",
  "image.dialog.sunset.pre_sunset.no_dates.description":
    "<strong>{imageId} [{serviceName}]</strong> will reach end of support. Plan your upgrade to avoid disruption.{br}<link>Upgrade guide</link>",
  "image.dialog.sunset.support_ended.description":
    "<strong>{imageId} [{serviceName}]</strong> is no longer supported. It will be decommissioned on {decommissionDate} ({daysRemaining, plural, one {# day} other {# days}} remaining). Upgrade to a supported version to avoid build failures. {br}<link>Upgrade guide</link>",
  "image.dialog.sunset.support_ended.no_dates.description":
    "<strong>{imageId} [{serviceName}]</strong> is no longer supported. It will be decommissioned. Upgrade to a supported version to avoid build failures. {br}<link>Upgrade guide</link>",
  "image.sticker.decommissioned.item":
    "<strong>{imageId} [{serviceName}]</strong> was decommissioned on {decommissionDate}. Builds using this image are blocked. Upgrade to a supported version to continue deploying. <link>Upgrade guide</link>",
  "image.sticker.decommissioned.no_dates.item":
    "<strong>{imageId} [{serviceName}]</strong> was decommissioned. Builds using this image are blocked. Upgrade to a supported version to continue deploying. <link>Upgrade guide</link>",
  "image.sticker.decommissioned.no_dates.single":
    "<strong>{imageId} [{serviceName}]</strong> was decommissioned. Builds using this image are blocked. Upgrade to a supported version to continue deploying. <link>Upgrade guide</link>",
  "image.sticker.decommissioned.single":
    "<strong>{imageId} [{serviceName}]</strong> was decommissioned on {decommissionDate}. Builds using this image are blocked. Upgrade to a supported version to continue deploying. <link>Upgrade guide</link>",
  "image.sticker.decommissioned.title":
    "<strong>Decommissioned image:</strong> No longer available.",
  "image.sticker.sunset.pre_sunset.item":
    "<strong>{imageId} [{serviceName}]</strong> will reach end of support on {sunsetDate}. Plan your upgrade to avoid disruption. <link>Upgrade guide</link>",
  "image.sticker.sunset.pre_sunset.no_dates.item":
    "<strong>{imageId} [{serviceName}]</strong> will reach end of support. Plan your upgrade to avoid disruption. <link>Upgrade guide</link>",
  "image.sticker.sunset.pre_sunset.no_dates.single":
    "<strong>{imageId} [{serviceName}]</strong> will reach end of support. Plan your upgrade to avoid disruption. <link>Upgrade guide</link>",
  "image.sticker.sunset.pre_sunset.single":
    "<strong>{imageId} [{serviceName}]</strong> will reach end of support on {sunsetDate}. Plan your upgrade to avoid disruption. <link>Upgrade guide</link>",
  "image.sticker.sunset.support_ended.item":
    "<strong>{imageId} [{serviceName}]</strong> is no longer supported. It will be decommissioned on {decommissionDate} ({daysRemaining, plural, one {# day} other {# days}} remaining). Upgrade to a supported version to avoid build failures. <link>Upgrade guide</link>",
  "image.sticker.sunset.support_ended.no_dates.item":
    "<strong>{imageId} [{serviceName}]</strong> is no longer supported. It will be decommissioned. Upgrade to a supported version to avoid build failures. <link>Upgrade guide</link>",
  "image.sticker.sunset.support_ended.no_dates.single":
    "<strong>{imageId} [{serviceName}]</strong> is no longer supported. It will be decommissioned. Upgrade to a supported version to avoid build failures. <link>Upgrade guide</link>",
  "image.sticker.sunset.support_ended.single":
    "<strong>{imageId} [{serviceName}]</strong> is no longer supported. It will be decommissioned on {decommissionDate} ({daysRemaining, plural, one {# day} other {# days}} remaining). Upgrade to a supported version to avoid build failures. <link>Upgrade guide</link>",
  "image.sticker.sunset.title":
    "<strong>Sunset images:</strong> Limited support (critical updates only). Plan your upgrade.",
  "image.tag.decommissioned": "Decommissioned",
  "image.tag.sunset": "Sunset",
  import_your_repository: "import your repository",
  include_subdomains: "include_subdomains",
  incoming: "Incoming",
  info: "info",
  information: "Information",
  initialized_environment: "initialized environment",
  initiated_sync: "initiated sync of",
  instances: "Instances",
  "instances.section.title": "Instance limits",
  instances_dialog: "Instances",
  "integration.activity": "Activity",
  "integration.add": "Add integration",
  "integration.blackfire.description":
    "Monitor, validate and improve site performance with Blackfire, a {appName} product.",
  "integration.blackfire.environment.variables.url":
    " View {environment} environment variables.",
  "integration.blackfire.info.description":
    "You can customize your integrations through our Command Line Interface (CLI).",
  "integration.blackfire.info.title": "Integrations settings",
  "integration.blackfire.multiple.main.environments.url": "Main",
  "integration.blackfire.multiple.project.environments.url":
    "Project variables",
  "integration.blackfire.project.variables.url": " View project variables.",
  "integration.blackfire.url": " Learn more.",
  "integration.blackfire.warning":
    "Blackfire variables in an environment are overriding this integration.",
  "integration.blackfire.warning.multiple":
    "Blackfire variables in an environment are overriding this integration. View or manage these variables in: ",
  "integration.configure.bitbucket.intro":
    "You can get the information below from an Oauth consumer in your Bitbucket account.",
  "integration.configure.bitbucket_server.intro":
    "You can get the information below from an Oauth consumer in your Bitbucket account.",
  "integration.configure.ensure_scopes":
    "<b>Ensure the token has the following scopes:</b>",
  "integration.configure.field.app_credentials/key.label": "App credential key",
  "integration.configure.field.app_credentials/key.placeholder":
    "Enter your credential key",
  "integration.configure.field.app_credentials/secret.label":
    "App credential secret",
  "integration.configure.field.app_credentials/secret.placeholder":
    "Enter your credential secret",
  "integration.configure.field.base_url.label": "Custom domain",
  "integration.configure.field.base_url.placeholder":
    "Enter only if using a custom domain",
  "integration.configure.field.channel.label": "Channel",
  "integration.configure.field.channel.placeholder": "Enter channel name",
  "integration.configure.field.environments.info.text":
    "You can separate these with commas to list multiple types.",
  "integration.configure.field.environments.info.title":
    "Included environments",
  "integration.configure.field.environments.label": "Included environments",
  "integration.configure.field.environments.placeholder":
    "List environment IDs to include, defaults to “*”",
  "integration.configure.field.events.info.text":
    "You can separate these with commas to list multiple types.",
  "integration.configure.field.events.info.title": "Events to report",
  "integration.configure.field.events.label": "Events to report",
  "integration.configure.field.events.placeholder":
    "List your events to report, e.g. environment.push - Defaults to “*”",
  "integration.configure.field.excluded_environments.info.text":
    "You can separate these with commas to list multiple types.",
  "integration.configure.field.excluded_environments.info.title":
    "Excluded environments",
  "integration.configure.field.excluded_environments.label":
    "Excluded environments to not execute the hook on",
  "integration.configure.field.excluded_environments.placeholder":
    "List environment IDs to exclude.",
  "integration.configure.field.from_address.label": "From address",
  "integration.configure.field.from_address.placeholder": "Enter address email",
  "integration.configure.field.info.authenticated_as":
    "Authenticated as <b>{name}</b>",
  "integration.configure.field.info.change_token": "Change Token",
  "integration.configure.field.project.label": "Project",
  "integration.configure.field.project.placeholder": "Project name",
  "integration.configure.field.recipients.label": "Recipients",
  "integration.configure.field.recipients.placeholder":
    "Enter email addresses separated by commas.",
  "integration.configure.field.repository.git.disclaimer":
    "Repositories can only be changed by removing the existing integration and creating a new one.",
  "integration.configure.field.repository.git.label": "Repositories",
  "integration.configure.field.repository.git.placeholder": "Choose repository",
  "integration.configure.field.repository.label": "Repository",
  "integration.configure.field.repository.placeholder": "user/repo",
  "integration.configure.field.routing_key.label": "Routing key",
  "integration.configure.field.routing_key.placeholder": "Enter routing key",
  "integration.configure.field.script.label": "Javascript code",
  "integration.configure.field.script.placeholder":
    "Enter your javascript code",
  "integration.configure.field.shared_key.label": "Shared key",
  "integration.configure.field.shared_key.placeholder": "Enter shared key",
  "integration.configure.field.states.info.text":
    "You can separate these with commas to list multiple types.",
  "integration.configure.field.states.info.title": "States to report",
  "integration.configure.field.states.label": "States to report",
  "integration.configure.field.states.placeholder":
    "List your states to report, e.g. pending, in_progress, complete - Defaults to “complete”..",
  "integration.configure.field.token.label": "Access Token",
  "integration.configure.field.token.placeholder": "Enter token",
  "integration.configure.field.url.label": "URL",
  "integration.configure.field.url.placeholder": "Enter URL",
  "integration.configure.field.username.label": "Username",
  "integration.configure.field.username.placeholder": "Enter username",
  "integration.configure.github.field.base_url.placeholder":
    "Enter only if using a custom domain",
  "integration.configure.github.intro":
    "The GitHub integration allows you to manage your {appName} environments directly from your GitHub repository.",
  "integration.configure.github.scopes":
    "<code>admin:repo_hook</code> to automatically create web hooks {br}<code>repo</code> to integrate with your repositories{br}Add <code>read:org</code> to integrate with your organization´s repositories",
  "integration.configure.github.sub_intro":
    "<a>Generate a new token</a> in GitHub. If you have an enterprise account go to: Settings page / Developer settings / Personal access tokens",
  "integration.configure.gitlab.intro":
    "The GitLab integration allows you to manage your {appName} environments directly from your GitLab repository.",
  "integration.configure.gitlab.scopes":
    "<code>api</code> to access your API{br}<code>read_repository</code> to read the repository",
  "integration.configure.gitlab.sub_intro":
    "<a>Generate a new token</a> in GitLab. If you have an enterprise account go to: Settings page / Developer settings / Personal access tokens.",
  "integration.configure.health_email.intro":
    "A notification will trigger an email to be sent from an address of your choice to one or more recipient addresses.",
  "integration.configure.health_pagerduty.intro":
    "Create a new <a>PagerDuty integration</a> using the Events API v2, then copy the routing key for the integration and enter that below.",
  "integration.configure.health_slack.intro":
    "With a <a>custom bot user</a> for your Slack group, the API token is the Bot User OAuth Access Token provided by Slack.",
  "integration.configure.health_webhook.intro":
    "Webhooks allow you to set up integrations, which subscribe to certain activities on in {appName} projects, such as creating or merging branches, synchronizing data with parent environments, or activating new environments.",
  "integration.configure.intro": " ",
  "integration.configure.option.build_draft_pull_requests":
    "Create new branches and run the build for each draft pull request.",
  "integration.configure.option.build_merge_requests":
    "Create new branches and run the build for each merge request.",
  "integration.configure.option.build_pull_requests":
    "Create new branches and run the build for each pull request.",
  "integration.configure.option.build_pull_requests_post_merge":
    "Build the result of merging the pull request.",
  "integration.configure.option.build_wip_merge_requests":
    "Create new branches and run the build for each WIP pull request.",
  "integration.configure.option.fetch_branches":
    "Fetch branches from the remote repository to your project.",
  "integration.configure.option.merge_requests_clone_parent_data":
    "Clone parent environment’s data when creating a merge request environment.",
  "integration.configure.option.prune_branches":
    "Remove branches from your project that have disappeared remotely (requires the fetch branches option to be enabled).",
  "integration.configure.option.pull_requests_clone_parent_data":
    "Clone parent environment’s data when creating a pull request environment.",
  "integration.configure.option.resync_pull_requests":
    "Re-sync environment data on every pull request build.",
  "integration.configure.script.intro":
    "Activity Scripts respond to activities in {appName} projects, such as creating or merging branches, synchronizing data with parent environments, or activating new environments. You can write code that is triggered by these activities and takes action in response. {br} Activity Scripts are powered by a lightweight JavaScript engine, and has runtime access to objects representing your project and environment. Find out more in our <a>documentation</a>.",
  "integration.configure.title": "Edit your integration",
  "integration.configure.webhook.intro":
    "Webhooks allow you to set up integrations, which subscribe to certain activities on in {appName} projects, such as creating or merging branches, synchronizing data with parent environments, or activating new environments.",
  "integration.custom.environments": "Environments",
  "integration.custom.events": "Events",
  "integration.custom.excluded_environments": "Excluded environments",
  "integration.custom.states": "States",
  "integration.custom.supported_runtimes": "Supported runtimes",
  "integration.forward_logs_to": "Forward logs from your project to {name}",
  "integration.forward_logs_to_newrelic":
    "Forward logs from your project to New Relic",
  "integration.getting_started.observability_suite_description":
    "These integrations require an upgrade to access. The Observability Suite includes access to them all.",
  "integration.getting_started.observability_suite_title":
    "Observability integrations",
  "integration.git.base_url": "Enterprise base URL",
  "integration.git.build_draft_pull_requests":
    "Create new branches and run the build for each draft pull request.",
  "integration.git.build_merge_requests":
    "Create new branches and run the build for each pull request.",
  "integration.git.build_pull_requests":
    "Create new branches and run the build for each pull request.",
  "integration.git.build_pull_requests_post_merge":
    "Build the result of merging the pull request.",
  "integration.git.build_wip_merge_requests":
    "Create new branches and run the build for each draft pull request.",
  "integration.git.fetch_branches":
    "Fetch branches from the {name} repository to your project.",
  "integration.git.id": "ID",
  "integration.git.merge_requests_clone_parent_data":
    "Re-sync environment data on every pull request build.",
  "integration.git.prune_branches":
    "Remove branches from your project that have disappeared from {name}.",
  "integration.git.pull_requests_clone_parent_data":
    "Clone parent environment’s data when creating a pull request environment.",
  "integration.git.repository": "Repository",
  "integration.git.resync_pull_requests":
    "Re-sync environment data on every pull request build.",
  "integration.git.settings": "Project settings",
  "integration.health.channel": "Channel",
  "integration.health.from_address": "From address",
  "integration.health.recipients": "Recipients",
  "integration.health.routing_key": "Routing key",
  "integration.health.shared_key": "Shared key",
  "integration.health.url": "Webhook URL",
  "integration.info.content":
    "Connect and manage your integrations here or customize them through the CLI. Note that some integrations can not be verified.",
  "integration.info.link":
    "Learn more about integrations in our <a>documentation</a>",
  "integration.info.title": "Integrations Settings",
  "integration.log_forwarding_form_cost_notice":
    "* Outgoing bandwidth from log forwarding integrations are included in usage costs.",
  "integration.log_forwarding_form_title":
    "Enter the information for your {type} integration in the fields below.",
  "integration.observability_suit.info_learn_about":
    "Learn about observability suite",
  "integration.observability_suite": "Observability Suite",
  "integration.observability_suite.info_title":
    "All included in Observability Suite",
  "integration.observability_suite_upgrade_title":
    "Upgrade to the Observability Suite",
  "integration.otlplog.excluded_services": "Excluded Apps & Services",
  "integration.remove.sentence":
    "Are you sure you want to remove the <b>{integration}</b> integration from project <b>{project}</b>? ",
  "integration.remove.title": "Remove integration",
  "integration.setup.add": "+ Add",
  "integration.setup.categories": "Categories",
  "integration.setup.categories.all": "All categories",
  "integration.setup.categories.custom.sentence": " ",
  "integration.setup.categories.custom.title": "Custom",
  "integration.setup.categories.filter": "Filter",
  "integration.setup.categories.git.info.text":
    "Only one Git service can be integrated at any one time.",
  "integration.setup.categories.git.info.title": "Git Service limitation",
  "integration.setup.categories.git.sentence":
    "You can only have one git service connected at any time",
  "integration.setup.categories.git.title": "Git service",
  "integration.setup.categories.health.sentence": " ",
  "integration.setup.categories.health.title": "Health notifications",
  "integration.setup.categories.label": "Filter categories",
  "integration.setup.categories.monitoring.sentence": " ",
  "integration.setup.categories.monitoring.title": "Monitoring",
  "integration.setup.categories.observability_suite.sentence":
    "Available with the observability suite. <a>Learn more</a>",
  "integration.setup.categories.observability_suite.title": "Log forwarding",
  "integration.setup.categories.search.placeholder": "Search integration",
  "integration.setup.categories.usage_billed.sentence":
    "Usage costs based on outgoing bandwidth. <a>Learn more</a>",
  "integration.setup.configure": "Configure your integration",
  "integration.setup.connected": "Connected",
  "integration.setup.modal.git.sentence":
    "Are you sure you want to replace your existing <b>{current}</b> integration with <b>{new}</b>? Your {current} integration will be removed and the project’s repository will no longer be in sync with your {current} repository. ",
  "integration.setup.modal.git.title": "Replace your Git service",
  "integration.setup.select": "Select integration",
  "integration.setup.title": "Add Integration",
  "integration.table.headers.category": "Category",
  "integration.table.headers.id": "ID",
  "integration.table.headers.integration": "Integration",
  "integration.title": "Details",
  "integration.type.bitbucket": "Bitbucket",
  "integration.type.bitbucket.description":
    "Integrate with public or private Bitbucket repositories.",
  "integration.type.bitbucket_server": "Bitbucket server",
  "integration.type.bitbucket_server.description":
    "Integrate with a self-hosted version of Bitbucket.",
  "integration.type.blackfire": "Blackfire",
  "integration.type.github": "GitHub",
  "integration.type.github.description":
    "Integrate with public or private GitHub repositories.",
  "integration.type.gitlab": "GitLab",
  "integration.type.gitlab.description":
    "Integrate with public or private GitLab repositories.",
  "integration.type.health.email": "Email",
  "integration.type.health.email.description":
    "Get health notifications for your project delivered by email.",
  "integration.type.health.pagerduty": "PagerDuty",
  "integration.type.health.pagerduty.description":
    "Get health notifications for your project delivered to your PagerDuty service.",
  "integration.type.health.slack": "Slack",
  "integration.type.health.slack.description":
    "Get health notifications for your project delivered to a Slack channel of your choice.",
  "integration.type.health.webhook": "Health webhook",
  "integration.type.health.webhook.description":
    "Send information or messages to another app, service or web endpoint.",
  "integration.type.hipchat": "HipChat",
  "integration.type.hipchat.description": "FIXME",
  "integration.type.httplog": "HTTP log",
  "integration.type.newrelic": "NewRelic",
  "integration.type.otlplog": "OpenTelemetry Logs",
  "integration.type.script": "Activity Scripts",
  "integration.type.script.description":
    "Write code triggered by various activities to extend an integration or build your own.",
  "integration.type.splunk": "Splunk",
  "integration.type.sumologic": "Sumo Logic",
  "integration.type.syslog": "Syslog endpoint",
  "integration.type.webhook": "Custom webhook",
  "integration.type.webhook.description":
    "Send information or messages to another app, service or web endpoint.",
  "integration.verify": "Verify integration",
  integrations: "Integrations",
  "integrations.add": "Add integration",
  "integrations.add_integration_to_project":
    "Connect a Git service, health checks, or webhooks to your project",
  "integrations.category.blackfire": "Monitoring",
  "integrations.category.custom": "Custom",
  "integrations.category.git": "Git Service",
  "integrations.category.health": "Health Notification",
  "integrations.category.httplog": "HTTP log",
  "integrations.category.logs": "Logs",
  "integrations.category.monitoring": "Monitoring",
  "integrations.category.observability_suite": "Log forwarding",
  "integrations.cli_integration":
    "Our Command Line Interface (CLI) will walk you through setting up various integrations. You can also learn more about integrations in our <a>documentation</a>. To get started, use the following command",
  "integrations.getting_started.intro":
    "Email integrations are created by default that send health notifications to your project admins. Select an integration below to add it to your project.",
  "integrations.getting_started.title": "Select an integration to get started",
  "integrations.no_integration": "No integrations",
  "integrations.title": "Integrations",
  internal_only_tag: "Internal only",
  internal_server_desc:
    "Try checking your internet connection, disable any ad blockers and if all else fails - get in touch so we can take a closer look.",
  internal_server_title: "Something’s not right",
  into: "into",
  invalid_username: "Invalid username",
  "invitation.add": "Add",
  "invitation.confirmationModalBody":
    "An invitation has been sent to {email} and will appear in your project's access settings once accepted.",
  "invitation.confirmationModalTitle": "Invitation sent",
  "invitation.details.email": "Email",
  "invitation.details.pending": "Pending invitation",
  "invitation.display_name_will_display":
    "Display name will display if invitation is accepted",
  "invitation.environment": "Environment",
  "invitation.environment.permission": "Environment permissions",
  "invitation.environment.type": "Roles",
  "invitation.environment_types": "Environment types",
  "invitation.environment_types.permission": "Environment type roles",
  "invitation.info": "Invited by {name} on {date}",
  "invitation.manualResendModalBody":
    "Are you sure you want to resend the invitation for {email}? ",
  "invitation.pending": "Invite pending",
  "invitation.pendingFail":
    "Your invitation is still being processed, please try again later.",
  "invitation.pendingLoading": "Checking access...",
  "invitation.permisssions.missing":
    "You don't have enough permissions to add a user",
  "invitation.resend": "Resend invitation",
  "invitation.resendModalBody":
    "An invitation has already been sent to {email}. Do you want to send this invitation again?",
  "invitation.resendModalTitle": "Invitation already sent",
  "invitation.resend_success": "Resent invitation",
  "invitation.revoke": "Revoke invitation",
  "invitation.revokeModalBody":
    "Are you sure you want to revoke the invitation for {email}? ",
  "invitation.revokeModalTitle": "Revoke invitation",
  "invitation.role.admin": "Project admin",
  "invitation.role.contributor": "contributor",
  "invitation.role.viewer": "viewer",
  "invitation.something_went_wrong":
    "Something went wrong, please try again later",
  "invitation.table.admin": "Admin",
  "invitation.table.environments": "Environments",
  "invitation.table.project": "Project",
  invitation_error: "Invitation error",
  invitation_error_desc:
    "You need to sign up using the email address that you received your invitation link from.",
  invitation_error_title: "Sorry, but..",
  invitation_pending: "Invitation pending",
  invite: "Invite",
  invite_users: "Invite users",
  "invoice.enterprise_message":
    "Please note that discounts and contract details are not yet reflected in these invoices. You can review this directly with your account manager.",
  "invoice.included_project_title": "Projects Included",
  "invoice.monthly.total": "Total monthly payment",
  "invoice.trial.credit": "Free trial credit",
  "invoice.trial.expires": "Expires: {date}",
  "invoice.trial.remaining": "Free trial credit remaining",
  "invoice.trial.with_project":
    "Add a payment method to keep your projects running after your free trial ends.",
  "invoice.trial.without_project":
    "<a>Create a project</a> to get the most out of your free trial before it expires.",
  "invoice_details.back_to_invoices": "Back to Invoices",
  "invoice_details.duration": "Duration",
  "invoice_details.invoice_number": "Invoice number",
  invoices: "Invoices",
  "invoices.download_error.description":
    "Something went wrong downloading the invoice PDF. Please try again.",
  "invoices.download_error.title": "Couldn’t download invoice",
  "invoices.error_loading": "Failed to load invoices. Please try again.",
  "invoices.no_invoices": "No invoices found.",
  "invoices.payment_status.paid": "Paid",
  "invoices.status_active": "Active",
  "invoices.title": "Invoices",
  "invoices.upcoming": "Upcoming",
  ip_addresses: "IP Address",
  ip_addresses_description1: "Enter one IP address or range per line.",
  ip_addresses_description2:
    "Enter one IP address per line. Separate the IP address from the permission by a space. ",
  is_controlled:
    "<b>Enable HTTP access control:</b> Restrict access to your environments website by a username/password, or by IP address.",
  "is_controlled.description":
    "Restrict access to your environment's website by a username/password, or by IP address.",
  "is_controlled.missing_configs":
    "Please add Login/IP or disable access control",
  "is_controlled.title": "<b>HTTP Access control enabled</b> ",
  is_default: "Make default domain",
  "is_default.description":
    "Enabling this will unset the existing default domain and use this domain as the new default. There can only be 1 default domain.",
  is_hidden:
    "<b>Hide from search engines: </b>Tells search engines to ignore this environment.",
  "is_hidden.description": "Tells search engines to ignore this environment.",
  "is_hidden.description2":
    "Environments without a custom domain are hidden by default. Add a custom domain to enable this setting. Learn more in our <link>documentation</link>.",
  "is_hidden.title": "<b>Hide from search engines</b>",
  is_sending_email: "Email sending",
  issuer_info: "issuer info",
  issues: "issues",
  january: "January",
  july: "July",
  june: "June",
  key: "Key",
  "kickstart.create": "Get started",
  "kickstart.description":
    "Manually push your code to {appName}, and integrate your Git provider",
  "kickstart.title": "Kickstart a new repository",
  "kyc_verification.code.help":
    "Didn't get a code? <a>Choose another method</a>.",
  "kyc_verification.code.intro.call":
    "We'll call you at {phone}. Enter the code below.",
  "kyc_verification.code.intro.sms":
    "Enter the code we sent over SMS to {phone}.",
  "kyc_verification.code.submit": "Confirm",
  "kyc_verification.code.title": "Enter the code",
  "kyc_verification.methods.call.label": "Phone call",
  "kyc_verification.methods.call.label_details": "We'll call you with a code.",
  "kyc_verification.methods.continue": "Continue",
  "kyc_verification.methods.help":
    "Need more help? <a>Contact our support team</a>.",
  "kyc_verification.methods.intro": "Where do you want your code sent?",
  "kyc_verification.methods.sms.label": "Text message (SMS)",
  "kyc_verification.methods.sms.label_details": "We'll text you a code.",
  "kyc_verification.methods.submit": "Resend code",
  "kyc_verification.methods.title": "Verification methods",
  "kyc_verification.phone.error":
    "There's an issue with this phone number, please check the numbers and try again",
  "kyc_verification.phone.fields.phone.label": "Phone number",
  "kyc_verification.phone.fields.phone.placeholder": "Enter phone number",
  "kyc_verification.phone.intro":
    "Can we have your number? We just need to verify you’re human after all. And we promise it won’t be stored. You’ll be sent a verification code to enter here and that’s it!",
  "kyc_verification.phone.submit": "Send code",
  "kyc_verification.phone.switch_method": "Other verification methods",
  "kyc_verification.phone.title": "Verify your number",
  "kyc_verification.ticket.back": "Cancel",
  "kyc_verification.ticket.contact": "Contact support",
  "kyc_verification.ticket.intro":
    "It looks like your account requires additional verification. Please contact our support team to activate your new {app_name} account.",
  "kyc_verification.ticket.title": "Account verification needed",
  label: "Label",
  "label.field.required": "Required field",
  large_description: "resource intensive and multiple apps",
  last_activity: "Last activity",
  last_backup: "Last backup",
  last_deployed: "Last deployed",
  last_name: "Last name",
  last_run: "last run",
  last_used: "last used",
  latest_backup: "latest backup",
  latest_deployment: "latest deployment",
  latest_from_the_blog: "latest from the blog",
  learn_more: "Learn more",
  learn_more_about: "Learn more about",
  "learn_more_at_blackfire.io": "Learn more about Blackfire.io",
  learnhow: "Learn how",
  learnmore: "Learn more",
  "learnmore.pricing": "<a>Learn more on our pricing page</a>",
  legal_entity_name: "Legal entity name",
  lets_get_started: "Let’s get started!",
  lets_go: "Let's go",
  light: "Light",
  lightmode: "Light mode",
  "list.projects.permission": "List projects permission",
  live: "Live",
  load_more: "Load more",
  loading: "loading",
  loading_more: "Loading more",
  log: "Log",
  "log_analyzer_agent.toast.completed.description":
    "The report for {environmentName} is ready.",
  "log_analyzer_agent.toast.completed.link": "View report",
  "log_analyzer_agent.toast.completed.title": "Log analysis complete",
  "log_analyzer_agent.toast.failed.description":
    "The analyzer stopped before it could write a report.",
  "log_analyzer_agent.toast.failed.link": "View details",
  "log_analyzer_agent.toast.failed.title": "Log analysis didn't finish",
  "log_analyzer_agent.toast.started.description":
    "Analyzing logs from {environmentName}. This can take a few minutes.",
  "log_analyzer_agent.toast.started.link": "View progress",
  "log_analyzer_agent.toast.started.title": "Log analysis started",
  log_empty: "Log is empty.",
  "log_forwarding.observability_required_message":
    "Log forwarding integrations require the Observability Suite for access.",
  log_forwarding_billing_note:
    "Note: Log forwarding usage is billed based on outgoing bandwidth.",
  log_in: "Log in",
  log_in_title: "Log in to {app_name}",
  log_out: "Log out",
  login_label: "Login",
  "login_length-error": "Login must be at least 2 characters.",
  login_message:
    "By logging in, including with my linked account or my Platform.sh <br></br> account, I agree to the",
  login_with_email: "log in using your email",
  "login_with_platformsh_account.terms_tooltip":
    "Please accept the terms before you sign up",
  logins: "logins",
  logo: "logo",
  logout: "Logout",
  logs: "Logs",
  logs_context: "Context",
  logs_context_empty: "No context",
  logs_context_invalid: "Invalid context",
  logs_context_oversized: "Oversized context",
  logs_context_unsupported: "Unable to display context",
  "logs_overview.analyze_logs":
    "{count, plural, one {Analyze # log} other {Analyze # logs}}",
  "logs_overview.analyze_logs.no_count": "Analyze logs",
  "logs_overview.analyzing_logs": "Analyzing…",
  "logs_overview.help.analyzer_intro":
    "Want a diagnosis? The AI log analyzer reviews errors in your logs, explains the likely cause in the context of your setup, and suggests fixes. It never changes your code.",
  "logs_overview.help.button": "Help with logs",
  "logs_overview.help.guide": "Read the logs guide",
  "logs_overview.help.guide_intro":
    "Not sure what you're looking at? Our logs guide explains each log type and how to read it.",
  "logs_overview.help.setup": "Set up AI log analyzer",
  "logs_overview.help.title": "Get help with your logs",
  "logs_overview.loading_failed": "Failed to render logs overview.",
  "logs_overview.reset_filters": "Reset filters",
  "logs_overview.show_less_filters": "Hide filters",
  "logs_overview.show_more_filters":
    "More filters{count, plural, =0 {} other { ({count})}}",
  "logs_overview.total_logs": "{count} logs",
  logs_raw_json: "Raw JSON",
  logs_raw_json_help: "Displays raw structured JSON when available",
  machine_name: "Machine name",
  "maintenanceWindow.modal.description":
    "We run regular security updates that need brief downtime. <item>With <strong>stop-start</strong> updates apply during downtime.</item> <item>With <strong>zero downtime</strong> you must set a maintenance window so updates don’t disrupt your app.</item>",
  "maintenanceWindow.modal.title": "Set a project maintenance window",
  "maintenanceWindow.reschedule.modal.title": "Reschedule server update",
  maintenance_message: "Maintenance message",
  maintenance_redeploy: "Maintenance Window redeploy",
  maintenance_upgraded_description:
    "Upgraded {product_name} {service_name} to version {new_version} {learn_more}",
  maintenance_upgrading_description:
    "Upgrading {product_name} {service_name} to version {new_version} {learn_more}",
  "maintenancemodal.cta": "Check status",
  "maintenancemodal.description":
    "We're updating our systems to bring you an even better experience.",
  "maintenancemodal.thanks": "Thank you for your patience.",
  "maintenancemodal.title": "Scheduled maintenance",
  manage: "Manage one site or 1,000",
  "manage.account": "Manage your account",
  manage_members: "manage members",
  "manage_organizations.add_to_billing_profile": "Add to billing profile",
  "manage_organizations.cancel": "Cancel",
  "manage_organizations.clear_all": "clear all",
  "manage_organizations.description":
    "Link the organizations you want this billing profile to cover.",
  "manage_organizations.organizations_selected":
    "{count} Organizations selected",
  "manage_organizations.select_placeholder":
    "Type to search or select organizations",
  "manage_organizations.title": "Manage organizations",
  manage_project: "manage project",
  manage_settings: "manage settings",
  manage_users: "Manage users",
  march: "March",
  marketing_acceptance_checkbox:
    "Stay up to date with {app_name} news and offers",
  max: "Max",
  "max.instances.allowed":
    "The maximum instances allowed on this region is {maxInstances}",
  "max.instances.dialog.description":
    "The maximum number of instances available can vary based on the region of the project.",
  "max.instances.dialog.title": "Maximum instances",
  "max.instances.text": "instances remain, stop scaling up.",
  max_envs_limit:
    "You’ve reached your environment limit. Upgrade your plan in order to reactivate this environment.",
  maximum: "Maximum",
  may: "May",
  median: "Median",
  medium_description: "low traffic multi-apps",
  "member.confirmationUpdatePermissionModalBody":
    "Are you sure you want to {action} <b>{addedRoles}</b> {rolePluralAdded} {bothActions} <b>{removedRoles}</b> {rolePluralRemoved} for the user <b>{username}</b>({email})? {plural} affect all projects within the organization.",
  "member.confirmationUpdatePermissionsModalTitle": "Edit organization roles",
  "member.security.mfa.setup.recoverycodes": "Save recovery codes",
  "member.security.mfa.setup.recoverycodes.continue": "Continue",
  "member.security.mfa.setup.recoverycodes.copy":
    "Copy these recovery codes and keep them somewhere safe. These can be used as a fallback method if you ever need to log in without your device.",
  "member.security.mfa.setup.recoverycodes.loginnote":
    "After registering your authenticator app, you will need to log in again to complete the set up.",
  "member.security.mfa.setup.title": "MFA application setup",
  member_name: "member name",
  members: "members",
  "members.confirmationDeleteModalBody":
    "Are you sure you want to remove <b>{email}</b> from the organization <b>{organizationName}</b>? This will remove this {count, plural, one{user} other{users}} from all projects within this organization",
  "members.confirmationDeletenModalTitle": "Remove user",
  "members.inviteToTeamTitle": "Add to teams",
  members_email_address: "Enter email address, separate multiple with a comma",
  "menu.account": "Account",
  "menu.all_organization_project": "All organizations projects",
  "menu.billing": "Billing",
  "menu.billing_accounts": "Billing accounts",
  "menu.billing_accounts.hide": "Hide",
  "menu.billing_accounts.show_all": "Show all (+{length})",
  "menu.documentation": "Documentation",
  "menu.logout": "Logout",
  "menu.my_profile": "My Profile",
  "menu.new_billing_introduction.description":
    "Access your new billing interface from your user menu to manage billing across all your organizations. No more switching between them.",
  "menu.new_billing_introduction.link": "Go to Billing",
  "menu.new_billing_introduction.title":
    "Introducing a new way to manage billing",
  "menu.organization": "Organization",
  "menu.organization.invite_user": "Invite user",
  "menu.organization.select_org": "Select an organization to view settings",
  "menu.pluginapp": "Plugin app manager",
  "menu.projects": "Projects",
  "menu.select_organization": "Select Organization",
  "menu.settings": "Settings",
  "menu.staff_test_mode": "Staff test mode",
  "menu.support": "Support",
  "menu.teams": "Teams",
  "menu.users": "Users",
  "menu.view_all_billing_accounts": "View all accounts ({count})",
  merge: "Merge",
  "merge.button": "merge",
  "merge.cli": "CLI",
  "merge.cli.sizing_api_enabled": "CLI Command",
  "merge.command": "{commandName} merge {action}",
  "merge.dialog.cli.description":
    "You can also use this terminal command to merge {currentEnvironment} into your {parentEnvironment} environment.",
  "merge.question":
    "Merge your environment {currentEnvironment} into your {parentEnvironment} environment.",
  "merge.question.sizing_api_enabled":
    "Are you sure you want to merge {currentEnvironment} into {parentEnvironment}? By default new applications and services will be allocated the resources that are defined in the {currentEnvironment} environment.",
  "merge.radioBtn.child": "Use child environment resources",
  "merge.radioBtn.default": "Use default resources",
  "merge.radioBtn.manual": "Manually configure resources after merge",
  "merge.radioBtn.minimum": "Use minimum resources",
  "merge.radioGroup.description":
    "Resource initialization strategy for {parentEnvironment} environment.",
  "merge.title": "Merge to {parentEnvironment}",
  merge_child_from_parent: "merge {child} from {parent}",
  merged: "merged",
  merged_pull_request_from: "merged pull request from",
  merging: "merging",
  messages: "messages",
  metadata: "metadata",
  metrics: "metrics",
  "metrics.cpu.dialog.text":
    "The amount of CPU used on user and system processes.",
  "metrics.cpu.dialog.title": "CPU usage",
  "metrics.cpu.title": "CPU",
  "metrics.currentaverage": "Current average",
  "metrics.currentavg": "Current avg.",
  "metrics.dedicated.heading": "Infrastructure metrics",
  "metrics.deployment.toggle":
    "Showing only successful push, merge, and sync activities",
  "metrics.description.cpu": "Current CPU usage",
  "metrics.description.disk": "<b>{usage}</b> / {total} allocated disk space",
  "metrics.description.memory": "Current memory usagae",
  "metrics.disk.dialog.text.exports":
    "Average and host disk utilization on the {mountpoint} folder for all other services.",
  "metrics.disk.dialog.text.generic":
    "Average and host disk utilization on the {mountpoint} folder.",
  "metrics.disk.dialog.text.root":
    "Average and host disk utilization on the {mountpoint} folder - Infrastructure disk, including /tmp.",
  "metrics.disk.dialog.title": "Disk {mountpoint}",
  "metrics.disk.title": "Disk",
  "metrics.empty": "No metrics available for this service.",
  "metrics.error": "Failed to load metrics. Please try again in a moment.",
  "metrics.error.empty.header": "Your metrics are almost here!",
  "metrics.error.empty.paragraph":
    "Metrics collection will start once you redeploy your environment.",
  "metrics.error.generic.header": "Something went wrong...",
  "metrics.error.generic.link":
    "If the issue persists, <a>open a support ticket</a>",
  "metrics.error.generic.paragraph":
    "Metrics page is temporarily unavailable, please try again in a few minutes.",
  "metrics.explorer.title": "Metric Explorer",
  "metrics.grid./mnt": "Persistent Disk",
  "metrics.grid./mnt.tooltip":
    "The persistent writable mount allocated to the {serviceKind} container.",
  "metrics.grid./tmp": "Temporary Disk",
  "metrics.grid./tmp.tooltip":
    "The temporary (non-persistent) mount allocated to the {serviceKind} container.",
  "metrics.grid./tmp.tooltip.description":
    "Some detailed information about this feature.",
  "metrics.grid./tmp.tooltip.title": "Shared /tmp disk",
  "metrics.grid.cpu.title": "CPU",
  "metrics.grid.cpu.tooltip":
    "The amount of CPU allocated to the {serviceKind} container.",
  "metrics.grid.cpu_pressure.title": "CPU Pressure",
  "metrics.grid.heading": "Metrics",
  "metrics.grid.hide": "Hide graphs",
  "metrics.grid.io_pressure.title": "IO Pressure",
  "metrics.grid.memory.title": "RAM",
  "metrics.grid.memory.tooltip":
    "The amount of RAM (Memory) allocated to the {serviceKind} container.",
  "metrics.grid.memory_pressure.title": "RAM Pressure",
  "metrics.grid.router.dialog.btn.documentation": "Router documentation",
  "metrics.grid.router.dialog.btn.support": "Contact support",
  "metrics.grid.router.dialog.description":
    "Router resources are pre-allocated and cannot be adjusted manually. If the Router appears resource-constrained, please request an adjustment.",
  "metrics.grid.router.dialog.title": "Router resource allocation",
  "metrics.grid.tasks.section": "Tasks",
  "metrics.grid.view": "View graphs",
  "metrics.loading": "Loading metrics...",
  "metrics.no_data": "No data for this timestamp",
  "metrics.no_match": "No metrics match your filter.",
  "metrics.press_to_hide": 'Press "ctrl" to hide in other graphs',
  "metrics.press_to_show": 'Hold "ctrl" to show in all graphs',
  "metrics.ram.dialog.text":
    "The RAM (Memory) used on apps and system processes.",
  "metrics.ram.dialog.title": "RAM usage",
  "metrics.ram.title": "RAM",
  "metrics.report.support.text": "Having trouble? ",
  "metrics.report.support.title": "Contact support",
  "metrics.search_placeholder": "Filter metrics",
  "metrics.select_metric": "Select a metric to view its timeline.",
  "metrics.service.emtpy":
    "There is no metrics data for {serviceKind}/{serviceName}",
  "metrics.service.share.copied": "Copied",
  "metrics.service.share.copy": "Click to copy share link",
  "metrics.split.heading": "Infrastructure metrics",
  "metrics.split.unified": "Service hosts",
  "metrics.split.web": "Web hosts",
  "metrics.thresholds.burst": "burst",
  "metrics.thresholds.critical": "critical",
  "metrics.thresholds.warning": "warning",
  "metrics.timeframe.info.minute":
    "data points every {time, plural, one {# min} other {# mins}}",
  "metrics.timeframe.info.minutes":
    "data points every {time, plural, one {# min} other {# mins}}",
  "metrics.timeframe.info.seconds":
    "data points every {time, plural, one {# second} other {# seconds}}",
  "metrics.timepast": "Past {duration} {durationText}",
  "metrics.title": "Resources",
  "metrics.title.cpu": "CPU",
  "metrics.title.disk": "Disk",
  "metrics.title.memory": "Memory",
  "metrics.tooltip.cpu.warning.description":
    "High CPU usage has been detected. This may affect service performance. Consider scaling to guaranteed resources.",
  "metrics.tooltip.cpu.warning.title": "High CPU usage detected",
  "metrics.total_usage.container_view": "By container",
  "metrics.total_usage.dgh_view": "Total",
  metrics_sync_across_tab: "Keep time range synced across tabs and pages",
  metrics_sync_unpin_tab: "Unpin time selection",
  micro_service_support: "Micro-service / Multi-App support",
  "migrate.create": "Get started",
  "migrate.description":
    "Automatically deploy to {appName} from GitHub pull requests and branches.",
  "migrate.title": "Sync your GitHub repository with {appName}",
  min: "Min",
  "min.instances.allowed":
    "The minimum instances allowed on this region is {minInstances}",
  "min.instances.dialog.description":
    "The minimum number of instances that your application can have at any given time.",
  "min.instances.dialog.title": "Minimum instances",
  "min.instances.text": "instances remain, stop scaling down.",
  min_version: "min_version",
  minimum: "Minimum",
  minutes: "Minutes",
  minutes_ago: "{time, plural, one {# minute} other {# minutes}} ago",
  "modal.confirm.leave.form.detail":
    "There are unsaved changes in this form that could be lost.",
  "modal.confirm.leave.form.title": "Are you sure you want to leave?",
  "modal.delete_account.descritpion1":
    "Deleting your Upsun account automatically deletes all your linked Ibexa Cloud, Pimcore PaaS, and Shopware PaaS accounts.",
  "modal.delete_account.descritpion2":
    "Our support team will begin to process your account deletion shortly. If you proceed, you’ll be redirected next to our support page to track the status of your request. To minimize additional accrued charges while your deletion request is pending, please delete any active projects on your accounts.",
  "modal.delete_account.sticker":
    "Important note: If you want to transfer the ownership of any organization to a new owner, please submit a new ticket prior to deleting your account.",
  "modal.delete_account.submit_request": "Submit request",
  "modal.delete_account.title": "Delete account",
  "modal.ide.update": "Update and close",
  "modal.integration.button": "Got it!",
  "modal.integration.info.content":
    "You can use this terminal command to set up new integrations with your project.",
  "modal.integration.info.title": "Learn more",
  "modal.limitation.description":
    "You have reached the limit. To create more projects you need to add your billing info and subscribe to {app_name}",
  "modal.limitation.title": "Need to create a new project?",
  "modal.organization.project.body.paymentfailed":
    "Please check your invoice and billing details or contact your billing provider to resolve your failed payment.",
  "modal.organization.project.button.billing.invoices": "Invoices",
  "modal.organization.project.button.billing.paymentfailed": "Billing details",
  "modal.organization.project.button.invoices.paymentfailed": "Invoices",
  "modal.organization.project.button.paymentmissing": "Add billing details",
  "modal.organization.project.title.paymentfailed": "Payment failed",
  "modal.organization.project.title.paymentmissing": "Payment method missing",
  "modal.resource.default.dialog.description":
    "{appName} will auto allocate your application and service containers with the default resources.",
  "modal.resource.default.dialog.title": "Default resource sizes",
  "modal.resource.initialization.dialog.description":
    "You can define which strategy to use when allocating resources for any new app or service containers.",
  "modal.resource.initialization.dialog.title":
    "Resource initialization strategy",
  "modal.resource.manual.dialog.description":
    "Please note that the deployment will fail, which is normal, as it allows you to configure your resources manually without deploying the merge right away. You can configure resources via the CLI or through the console.",
  "modal.resource.manual.dialog.title": "Manually configure resources",
  "modal.resource.minimum.dialog.description":
    "{appName} will allocate your application and service containers with the minimum  resources required to run your containers.",
  "modal.resource.minimum.dialog.title": "Minimum resource sizes",
  "modal.trial.limit.hard.button": "Add billing details",
  "modal.trial.limit.hard.details":
    "To create another project please add your billing details as your free trial has ended.{br}Or if you would like to extend your free trial please contact our <a>sales team</a>.",
  "modal.trial.limit.hard.title": "Free trial limit",
  "modal.trial.limit.plan.button": "Add billing details",
  "modal.trial.limit.plan.details":
    "To edit your plan you’ll need to either add your billing details or delete one of your projects as your free trial is nearing its limit.{br}Or if you would like to extend your free trial please contact our <a>sales team</a>.",
  "modal.trial.limit.plan.title": "Free trial limit",
  "modal.trial.limit.soft.button": "Add billing details",
  "modal.trial.limit.soft.details":
    "To create another project you’ll need to either add your billing details or delete one of your projects as your free trial is nearing its limit.{br}Or if you would like to extend your free trial please contact our <a>sales team</a>.",
  "modal.trial.limit.soft.title": "Free trial limit",
  "modal.trial.limit.very_hard.button": "Add billing details",
  "modal.trial.limit.very_hard.details":
    "To create another project please add your billing details.",
  "modal.trial.limit.very_hard.title": "Billing details",
  modified_environment_variable: "modified environment variable",
  modified_project_variable: "modified project variable",
  modified_route: "modified route",
  modified_subscription: "modified subscription",
  modify_settings: "modify settings",
  monthly_price: "Monthly price",
  more: "more",
  more_commit_toggle:
    "{commits} {commits, plural, one {commit} other {commits}}",
  more_info_in_docs: "More information can be found in our ",
  mtls: "mTLS",
  multicloud: "Multicloud production hosting",
  multiple_domains: "Multiple domains with free SSL certificates",
  my_organizations: "My organizations",
  my_x_project: "my {brandName} project",
  name: "Name",
  new: "New",
  new_password: "New password",
  "new_password-character_length": "Between 10-72 characters long",
  "new_password-lowercase": "At least one lowercase letter",
  "new_password-match": "Passwords don't match",
  "new_password-met": "Met",
  "new_password-not_met": "Not met",
  "new_password-number": "At least one number",
  "new_password-symbol": "At least one symbol (e.g. {symbols})",
  "new_password-uppercase": "At least one uppercase letter",
  new_payment_method: "Select new payment method",
  new_project: "New project",
  newsletter: "newsletter",
  "newsletter.description":
    "Yes, I wish to receive special offers and information from {appName}",
  next: "Next",
  "no-access": "No access",
  "no.scaling.tooltip": "Service in cooldown, not scaling application",
  "no_access.project.delete_domain":
    "Ask your project admin to remove a domain",
  "no_access.project.make_default_domain":
    "Ask your project admin to edit a domain",
  no_access_environment_decativate:
    "Ask your project admin to deactivate environment",
  no_access_environment_decativate_local_target:
    "Ask your project admin to deactivate environment",
  no_access_environment_reactivate:
    "Ask your project admin to reactivate environment",
  no_backup: "No backup",
  no_config_changes: "No config changes",
  no_credit_card: "(no credit card required)",
  no_credit_card_signup: "No credit card required",
  no_data: "No data available.",
  no_defined_routes: "No defined routes",
  no_delete_permission:
    "Ask your project admin to delete the environment. <link> Learn more</link>",
  no_domains: "no domains.",
  no_edit_or_view: "You cannot edit or view the {editType} for another user.",
  no_fill: "No fill",
  no_integration: "No integrations",
  no_more_logs: "No more logs",
  no_options: "No options",
  "no_organization_access.description":
    "Your account isn't part of an organization yet. After your admin adds you, you'll see your projects here.",
  "no_organization_access.title":
    "Ask your admin to add you to an organization",
  no_results: "No results",
  no_routes: "no routes.",
  no_ssh_keys: "no SSH keys are available",
  no_title: "no title",
  no_upcoming_invoices: "You have no upcoming invoices",
  no_users: "No users",
  no_variables: "no variables.",
  not_all_systems_operational: "not all systems are operational",
  not_connected: "Not connected",
  not_found_title: "Page not found",
  not_included: "Not included",
  notification_settings: "notification settings",
  november: "November",
  number: "number",
  number_of_commits:
    "{commitsLength} {commitsLength, plural, one {commit} other {commits}}",
  "object_storage.button.enable": "Enable object storage",
  "object_storage.modal.description":
    "Each container starts at 0.5 TB and you can adjust each one freely, including down to 0. This will affect your monthly pricing, and changes won't take effect until you save.{br} <link>Learn more about object storage</link>.",
  "object_storage.modal.title": "You're enabling object storage.",
  "observability-suite_learnmore": "Learn more about the Observability Suite.",
  "observability.pipeline.error.message": "Unable to fetch data",
  "observability.pipeline.error.retry": "Retry",
  "observability.pipeline.error.unsupported.logs.message":
    "Logs are not currently supported for this project's region.",
  october: "October",
  of: "of",
  of_app: "of app",
  of_storage: "of storage",
  off: "Off",
  ok: "ok",
  okay: "Okay",
  on: "On",
  "onboarding.follow_steps": "Next, follow the steps on the left.",
  "onboarding.migrate.bitbucket": "Coming soon",
  "onboarding.migrate.error.duplicate_installation":
    "That GitHub organization is already associated with another Upsun organization.",
  "onboarding.migrate.error.exchange_failed":
    "GitHub token exchange failed: Please check your credentials and retry.",
  "onboarding.migrate.error.invalid_installation":
    "GitHub rejected the connection request. Please contact your GitHub repository admin. <link>Learn more</link>",
  "onboarding.migrate.error.invalid_state":
    "GitHub validation error: Please try connecting again.",
  "onboarding.migrate.github.connect": "Connect with GitHub",
  "onboarding.migrate.github.create": "Create with GitHub",
  "onboarding.migrate.gitlab": "Coming soon",
  "onboarding.migrate.note": "Where is your code hosted?",
  "onboarding.migrate.permissions.1":
    "Fetch Git branches from GitHub into {app_name}.",
  "onboarding.migrate.permissions.2":
    "Pull requests on GitHub will create an {app_name} preview environment.",
  "onboarding.migrate.permissions.3":
    "GitHub pull request changes will redeploy {app_name} preview environments.",
  "onboarding.migrate.permissions.4":
    "Deleting GitHub branches will remove {app_name} environments.",
  "onboarding.migrate.permissions.notice":
    "Once authenticated, {app_name} will be able to:",
  "onboarding.migrate.title": "Migrate your project",
  "onboarding.repository.note":
    "If your organization or repository is not displayed, <link>update your GitHub permissions</link>.",
  "onboarding.repository.organization": "GitHub organization",
  "onboarding.repository.other_providers": "Connect to other git providers",
  "onboarding.repository.repository": "GitHub repository",
  "onboarding.repository.select_repository": "Select repository",
  "onboarding.repository.title": "Create project from repository",
  "onboarding.repository.token_dialog.description":
    "Need a repo from a different GitHub account? <link>Use a personal access token.</link>",
  "onboarding.repository.token_dialog.title": "Connect to different repo",
  "onboarding.resource.values": "{cpu}{ram}{disk}",
  "onboarding.resources.count": "Your resources{resourceCount}",
  "onboarding.setup.access_project.description":
    "Your project is ready and has been deployed to this URL:",
  "onboarding.setup.access_project.links.learn_more":
    "Learn more about what you can do in {app_name}",
  "onboarding.setup.access_project.links.title.configure_app":
    "Configure your app to use {app_name}",
  "onboarding.setup.access_project.links.title.create_service":
    "Create a service (Redis, PostgreSQL)",
  "onboarding.setup.access_project.links.title.manage_directories":
    "Manage writable directories (Mounts)",
  "onboarding.setup.access_project.links.title.manage_hooks":
    "Manage build hooks",
  "onboarding.setup.access_project.links.title.manage_variables":
    "Manage environment variables",
  "onboarding.setup.access_project.not_ready":
    "Your project has been created and is ready to host your application! Follow the steps above to get started.",
  "onboarding.setup.access_project.not_ready.links.title":
    "Here are some useful links for you to explore:",
  "onboarding.setup.access_project.scratch.provisioning":
    "Please wait a moment while your project is being provisioned...",
  "onboarding.setup.access_project.title": "Access your project",
  "onboarding.setup.brew": "Homebrew",
  "onboarding.setup.cli.brew": "Homebrew",
  "onboarding.setup.cli.description":
    "Follow the steps below to get your project up and running.",
  "onboarding.setup.cli.later_configuration":
    "<link>Skip this step</link> to configure your project later",
  "onboarding.setup.cli.scoop": "Scoop",
  "onboarding.setup.cli.shellScript": "Shell script",
  "onboarding.setup.cli.skip": "Skip these steps",
  "onboarding.setup.cli.title": "Prepare project locally",
  "onboarding.setup.clone.dialog":
    "Setup your project locally to stage changes and prepare your {app_name} deployments.",
  "onboarding.setup.clone.dialog.title": "Clone repository locally",
  "onboarding.setup.commit.dialog":
    "Commit & deploy your newly version-controlled infrastructure to {app_name}.",
  "onboarding.setup.config.description":
    "Let’s configure and validate your project configuration files. All commands should be run within your local project directory.",
  "onboarding.setup.config.description.migrate":
    "Your project is now integrated to your Git repository. Let’s configure and validate your project configuration files. All commands should be run within your local project directory.",
  "onboarding.setup.config.title": "Add {app_name} configuration",
  "onboarding.setup.configure.dialog":
    "Prepare your {app_name} infrastructure to be version-controlled.",
  "onboarding.setup.connect.dialog":
    "Associate your local repository with your {app_name} project to enable <code>{cli_command} push</code>, <code>{cli_command} db:dump</code> and other powerful CLI commands.",
  "onboarding.setup.connect.dialog.title": "Connect directory to {app_name}",
  "onboarding.setup.create_project_organization": "{app_name} organization",
  "onboarding.setup.demo.clone.code": "{cli_command} get {projectId}",
  "onboarding.setup.demo.clone.title": "Clone repository locally",
  "onboarding.setup.demo.commit.code":
    "{cli_command} add {config_dir_name} \n'git commit -m 'Add {app_name} configuration files'",
  "onboarding.setup.demo.commit.title": "Commit {app_name} configuration",
  "onboarding.setup.demo.configure.code": "{cli_command} project:init",
  "onboarding.setup.demo.configure.title": "Create {app_name} configuration",
  "onboarding.setup.demo.connect.code":
    "{cli_command} project:set-remote {projectId}",
  "onboarding.setup.demo.connect.dialog":
    "Associate your local repository with your  {app_name} project to enable <code>{cli_command} push</code>, <code>{cli_command} db:dumb</code> and other powerful CLI commands.",
  "onboarding.setup.demo.connect.dialog.title":
    "Connect directory to {app_name}",
  "onboarding.setup.demo.connect.title": "Connect directory to {app_name}",
  "onboarding.setup.demo.create_branch.code":
    "{cli_command} project:set-remote {projectId}",
  "onboarding.setup.demo.create_branch.dialog":
    "A dedicated branch allows you to explore {app_name} without impacting your existing production and staging branches.",
  "onboarding.setup.demo.create_branch.dialog.title":
    "Create {app_name} branch",
  "onboarding.setup.demo.create_branch.title":
    "Connect directory to {app_name}",
  "onboarding.setup.demo.deploy.code": "{cli_command} push",
  "onboarding.setup.demo.deploy.title": "Deploy your changes to {app_name}",
  "onboarding.setup.demo.deployed.description":
    "Open the demo guide to start exploring {app_name} features by visiting your project’s public URL",
  "onboarding.setup.demo.deployed.title": "Your demo project has been deployed",
  "onboarding.setup.demo.install.code.brew":
    "brew install platform/tap/platform-cli",
  "onboarding.setup.demo.install.code.scoop":
    "scoop bucket add platformsh https://github.com/platformsh/homebrew-tap.git scoop install platform",
  "onboarding.setup.demo.install.code.shell":
    "curl -fsSL https://raw.githubusercontent.com/platformsh/cli/main/installer.sh | VENDOR={cli_command} bash",
  "onboarding.setup.demo.install.footnote":
    "If not using Homebrew or on Windows, refer to the <a>CLI documentation</a>.",
  "onboarding.setup.demo.install.title":
    "Install {app_name} CLI locally using Homebrew (MacOS and Linux)",
  "onboarding.setup.done.configure": "Resize apps and services",
  "onboarding.setup.done.demo.code": "{cli_command} url --primary",
  "onboarding.setup.done.demo.description":
    "Launch the demo guide to start exploring {app_name} features",
  "onboarding.setup.done.demo.title": "Congrats! Your demo project is ready!",
  "onboarding.setup.done.demo.tooltip":
    "Please copy the `{cli_command} demo:start` command before proceeding",
  "onboarding.setup.done.manage": "Manage project",
  "onboarding.setup.done.open": "Open demo app",
  "onboarding.setup.done.title": "Explore your application",
  "onboarding.setup.done.view": "View project",
  "onboarding.setup.done.view.tooltip":
    "First, click the public URL above to launch the demo app",
  "onboarding.setup.error.deployment.button": "Manage project",
  "onboarding.setup.error.deployment.title": "Sorry something went wrong.",
  "onboarding.setup.error.project_creation.button": "Retry",
  "onboarding.setup.error.project_creation.title":
    "Sorry something went wrong on our side.",
  "onboarding.setup.error.provisioningFailure":
    "Sorry! We had a technical glitch and couldn’t create {project_name}. Please start again by creating a new project.",
  "onboarding.setup.error.provisioningFailure.create": "Create new project",
  "onboarding.setup.finished.demo.detail":
    "Launch the demo guide to start exploring {app_name}.",
  "onboarding.setup.finished.description":
    "Your project has been built using the default resource sizes for your application and service containers.",
  "onboarding.setup.finished.title.end": "Explore your app",
  "onboarding.setup.finished.title.start": "Your project is ready!",
  "onboarding.setup.install": "Install CLI",
  "onboarding.setup.install.dialog":
    "Manage your {app_name} projects directly from your terminal. Anything you can do within the Console can be done with the CLI.",
  "onboarding.setup.install.dialog.title": "Install CLI",
  "onboarding.setup.is_being_created.demo":
    "Creating a project for your demo app...",
  "onboarding.setup.is_being_created.migrate":
    "Your project is being created from your <br></br>{repository} GitHub repository.",
  "onboarding.setup.is_being_created.scratch":
    "A project is being created to host your application.",
  "onboarding.setup.is_deploying": "Your project is deploying...",
  "onboarding.setup.is_waiting_for_push.created":
    "Your project has been created.",
  "onboarding.setup.is_waiting_for_push.error":
    "Congrats, your project is connected. Now let’s ensure your project is configured for {app_name}.<br></br>Use <code>{cli_command_name} project:init</code> to create a new {app_name} configuration, or <code>{cli_command_name} validate</code> to check your existing configuration.",
  "onboarding.setup.is_waiting_for_push.error.help":
    "You can find out more detail on the error by checking the deployment logs below.",
  "onboarding.setup.is_waiting_for_push.push":
    "Waiting for your first successful git push.",
  "onboarding.setup.migrate.activate.code":
    "{cli_command} environment:activate",
  "onboarding.setup.migrate.activate.dialog":
    "The GitHub branches that you create are available as {app_name} production, staging, and test environments",
  "onboarding.setup.migrate.activate.dialog.title":
    "Activate the {app_name} environment",
  "onboarding.setup.migrate.activate.title":
    "Activate the {app_name} environment",
  "onboarding.setup.migrate.clone.code": "{url} && cd {directory}",
  "onboarding.setup.migrate.clone.title":
    "If you haven’t already, clone repository locally",
  "onboarding.setup.migrate.commit.code":
    "git add .\ngit commit -m 'Add {app_name} configuration files'\n{cli_command} push\n{cli_command} activity:log",
  "onboarding.setup.migrate.commit.title":
    "Commit your files and deploy your application to {app_name}",
  "onboarding.setup.migrate.commit_config.code":
    "git add . \ngit commit -m 'Add {app_name} configuration files'",
  "onboarding.setup.migrate.commit_config.dialog":
    "Make your app architecture available to {app_name}.",
  "onboarding.setup.migrate.commit_config.dialog.title":
    "Commit {app_name} configuration",
  "onboarding.setup.migrate.commit_config.title":
    "Commit {app_name} configuration",
  "onboarding.setup.migrate.configure.code": "{cli_command} project:init",
  "onboarding.setup.migrate.configure.title": "Configure your project",
  "onboarding.setup.migrate.connect.code":
    "{cli_command} project:set-remote {projectId}",
  "onboarding.setup.migrate.connect.title": "Connect directory to {app_name}",
  "onboarding.setup.migrate.create_branch.code":
    "git checkout -b {cli_command}-deployment",
  "onboarding.setup.migrate.create_branch.title": "Create {app_name} branch",
  "onboarding.setup.migrate.create_config.code": "{cli_command} project:init",
  "onboarding.setup.migrate.create_config.dialog":
    "The files created here instruct {app_name} on how to deploy your app.",
  "onboarding.setup.migrate.create_config.dialog.title":
    "Create {app_name} configuration",
  "onboarding.setup.migrate.create_config.title":
    "Create {app_name} configuration",
  "onboarding.setup.migrate.deploy.code":
    "git push --set-upstream origin {cli_command}-deployment",
  "onboarding.setup.migrate.deploy.dialog":
    "This branch will be created as an environment on {app_name}",
  "onboarding.setup.migrate.deploy.dialog.title":
    "Push your changes to your new Github branch",
  "onboarding.setup.migrate.deploy.title":
    "Push your changes to your new GitHub branch",
  "onboarding.setup.migrate.install.code":
    "brew install platform/tap/platform-cli",
  "onboarding.setup.migrate.install.footnote":
    "If not using Homebrew or on Windows, refer to the <a>CLI documentation</a>.",
  "onboarding.setup.migrate.install.title":
    "Install {app_name} CLI using Homebrew (MacOS and Linux)",
  "onboarding.setup.resources.updating": "Updating resources..",
  "onboarding.setup.scoop": "Scoop",
  "onboarding.setup.scratch.clone.code":
    "{cli_command} project:set-remote {projectId}",
  "onboarding.setup.scratch.clone.dialog":
    "To configure your project for {app_name}, you'll need access to it on your machine.",
  "onboarding.setup.scratch.clone.dialog.title": "Clone repository locally",
  "onboarding.setup.scratch.clone.title":
    "Navigate to your local repository and connect it to {app_name}",
  "onboarding.setup.scratch.commit.code":
    "git add .\ngit commit -m 'Add {app_name} configuration files'\n{cli_command} push",
  "onboarding.setup.scratch.commit.title":
    "Commit your files and deploy your application to {app_name}",
  "onboarding.setup.scratch.commit_config.code":
    "git add .  \ngit commit -m 'Add {app_name} configuration files'",
  "onboarding.setup.scratch.commit_config.dialog":
    "Make your app architecture available to {app_name}.",
  "onboarding.setup.scratch.commit_config.dialog.title":
    "Commit {app_name} configuration",
  "onboarding.setup.scratch.commit_config.title":
    "Commit {app_name} configuration",
  "onboarding.setup.scratch.configure.code": "{cli_command} project:init",
  "onboarding.setup.scratch.configure.title": "Configure your project",
  "onboarding.setup.scratch.connect.code":
    "{cli_command} project:set-remote {projectId}",
  "onboarding.setup.scratch.connect.title": "Connect directory to {app_name}",
  "onboarding.setup.scratch.create_config.code": "{cli_command} project:init",
  "onboarding.setup.scratch.create_config.dialog":
    "The files created here instruct {app_name} on how to deploy your app.",
  "onboarding.setup.scratch.create_config.dialog.title":
    "Create {app_name} configuration",
  "onboarding.setup.scratch.create_config.title":
    "Create {app_name} configuration",
  "onboarding.setup.scratch.deploy.code": "{cli_command} push",
  "onboarding.setup.scratch.deploy.dialog":
    "Deploy your version-controlled infrastructure to {app_name} using: <code>{cli_command} push --activate</code>  <br></br>This is similar to a git push, but also activates your environment.",
  "onboarding.setup.scratch.deploy.dialog.title": "Deploy application",
  "onboarding.setup.scratch.deploy.title": "Deploy your changes to {app_name}",
  "onboarding.setup.scratch.init.code": "git init",
  "onboarding.setup.scratch.init.title":
    "Initialize your git repository (Optional)",
  "onboarding.setup.scratch.install.code":
    "brew install platform/tap/platform-cli",
  "onboarding.setup.scratch.install.footnote":
    "If not using Homebrew or on Windows, refer to the <a>CLI documentation</a>.",
  "onboarding.setup.scratch.install.title":
    "Install {app_name} CLI using Homebrew (MacOS and Linux)",
  "onboarding.setup.scratch.skip":
    "<a>Skip this step</a>, and finish setup later.",
  "onboarding.setup.shell": "Shell script",
  "onboarding.setup.tip.1":
    "Configure your app and service container CPU, RAM and Disk storage how you like.",
  "onboarding.setup.tip.2":
    "Scale your applications horizontally by increasing the number of instances.",
  "onboarding.setup.tip.3":
    "Create new teams and grant permissions to manage all of your contributors at once.",
  "onboarding.setup.tip.4":
    "Did you know you can integrate with GitHub, GitLab and Bitbucket?",
  "onboarding.setup.title": "Deploy to {app_name}",
  "onboarding.setup.waiting_for_project": "Waiting for project information...",
  one_more_step: "One more step",
  one_user: "1 User",
  only_one_method: "Only one can be saved to your account at any time.",
  "open.new.tab": "Link opens in new tab",
  open_mobile_nav: "open navigation",
  open_window: "Open window",
  operation: "Operation",
  operations: "Operations",
  optional: "optional",
  or: " or ",
  or_enter_a_repository_url: "or enter a repository URL",
  or_use_email: "or use email",
  "order.detail.standard_user_management.dialog.content":
    "Advanced user management is included in the Beta period. After the Beta period, this add-on will be an additional cost.",
  "order.detail.standard_user_management.dialog.link": "Learn more",
  "order.detail.standard_user_management.dialog.title":
    "Advanced user management",
  "order_status.canceled": "Canceled",
  "order_status.cardonfile_payment_error_hard_decline":
    "Payment failed (hard decline)",
  "order_status.cardonfile_payment_failed_soft_decline":
    "Payment failed (soft decline)",
  "order_status.cart": "Shopping cart",
  "order_status.checkout_checkout": "Checkout: Billing",
  "order_status.checkout_complete": "Checkout: Complete",
  "order_status.checkout_login_register": "Checkout: Account",
  "order_status.checkout_register": "Checkout: Register",
  "order_status.checkout_review": "Checkout: Review",
  "order_status.completed": "Completed",
  "order_status.dunning_past_due": "Past due",
  "order_status.fulfilment_fulfilment": "Fulfilment",
  "order_status.fulfilment_problem": "Problem",
  "order_status.invoiced": "Invoiced",
  "order_status.payment_error_disputed": "Payment failed (disputed)",
  "order_status.pending": "Pending",
  "order_status.processing": "Processing",
  "order_status.recurring_open": "Upcoming",
  "order_status.recurring_payment_pending": "Recurring: Payment pending",
  "order_status.recurring_usage_pending": "Recurring: Usage pending",
  organization: "Organization",
  "organization.basics.billing_callout.cta": "Set up Billing Profile",
  "organization.basics.billing_callout.description":
    "Add billing details to manage billing for your organization and projects in one place.",
  "organization.basics.billing_callout.load_error":
    "Failed to load the billing profile. Please try again.",
  "organization.basics.billing_callout.no_access":
    "This organization already has a billing profile, which you don't have access to. If you need access, ask one of its billing users to invite you.",
  "organization.basics.billing_callout.retry": "Try again",
  "organization.basics.billing_callout.title": "Organization billing",
  "organization.billing.breakdown.current.alert": "Alert at {alertThreshold}",
  "organization.billing.breakdown.global_spend":
    "10% global spend for 8 hour response",
  "organization.billing.breakdown.manage_users": "Manage users",
  "organization.billing.breakdown.project_billing": "Project billing",
  "organization.billing.breakdown.project_settings": "Project settings",
  "organization.billing.breakdown.set.alert": "Set alert",
  "organization.billing.breakdown.support": "Support",
  "organization.billing.breakdown.support_sla.advanced":
    "Support SLA - Advanced",
  "organization.billing.breakdown.support_sla.premium": "Support SLA - Premium",
  "organization.billing.breakdown.support_sla.standard":
    "Support SLA - Standard",
  "organization.billing.breakdown.title": "{name} billing",
  "organization.billing.breakdown.user_licenses": "User licenses",
  "organization.billing.breakdown.users": "{number} user{s}",
  "organization.billing.breakdown.viewers": "Viewers",
  "organization.billing.btn.download": "Download",
  "organization.billing.btn.view_invoice": "View invoice",
  "organization.billing.current": "Current",
  "organization.billing.current_spend": "Current spend",
  "organization.billing.current_spend.description":
    "The cost that has accumulated so far this month. This includes any changes made prior to today that will be reflected on your monthly invoice.",
  "organization.billing.current_spend_this_month": "Current spend this month",
  "organization.billing.discount": "Discounts",
  "organization.billing.discount.allowance_discount": "First Project Incentive",
  "organization.billing.discount.allowance_discount.trial":
    "First Project Incentive*",
  "organization.billing.discount.enterprise_discount": "Enterprise Discount",
  "organization.billing.discount.startup_discount": "Startup Discount",
  "organization.billing.downgrading": "Downgrade",
  "organization.billing.enable": "Enable",
  "organization.billing.enterprise_message":
    "Please note that discounts and contract details are not yet reflected in these billing pages. You can review this directly with your account manager.",
  "organization.billing.estimate.description.current":
    "These totals are estimates based on changes made so far this month - plus the current resource allocation if nothing changes for the rest of the month.",
  "organization.billing.estimate.description.next":
    "These totals are what you would expect to pay for one month with your existing resource allocation plus any add-ons, including VAT.",
  "organization.billing.estimate.title.current": "Estimated invoice total",
  "organization.billing.estimate.title.next": "Future projected monthly total",
  "organization.billing.free": "Free",
  "organization.billing.future": "Future",
  "organization.billing.future_months": "Future months",
  "organization.billing.future_months_projection": "Future months projection",
  "organization.billing.invoice": "Previous invoice",
  "organization.billing.invoice.description":
    "This breakdown is based on the usage to date and then using averages to estimate remaining costs for the month.",
  "organization.billing.invoice.next.description":
    "Future projected costs are estimates based on your existing resource allocation plus any add-ons for one month.",
  "organization.billing.invoice.next.month": "{month} project breakdown",
  "organization.billing.invoice.next.vat.description":
    "Future projected costs are estimates based on your existing resource allocation plus any add-ons for one month. When applicable, VAT is included in the costs listed below.",
  "organization.billing.last_update_at_value": "Last updated at {value}",
  "organization.billing.modal.comply":
    "I understand that I'm committing to this upgrade for at least 30 days",
  "organization.billing.modal.comply.trial":
    "I understand that I'm committing to this upgrade for at least 30 days after my free trial has ended",
  "organization.billing.modal.current": "(Current)",
  "organization.billing.modal.default": "Default",
  "organization.billing.modal.default.detail":
    "Use only default permissions that are included with user licenses.",
  "organization.billing.modal.description":
    "Upgrade to unlock advanced user management capabilities like organization permissions, teams, and MFA enforcement.",
  "organization.billing.modal.note":
    "Note: User management changes cannot be downgraded for 30 days.",
  "organization.billing.modal.org_support": "Organization support",
  "organization.billing.modal.org_support.body":
    "Upgrade to receive service-level agreements with faster response times for your support tickets.",
  "organization.billing.modal.org_support.comply":
    "I understand that I’m committing to this upgrade for at least {value} days.",
  "organization.billing.modal.org_support.description":
    "Upgrade to receive faster response times for your support tickets. This upgrade will apply to new tickets, while any existing tickets will remain under your current support tier. ",
  "organization.billing.modal.org_support.note":
    "Note: Support add-on changes cannot be downgraded for {value} days.",
  "organization.billing.modal.org_support.title": "Organization support add-on",
  "organization.billing.modal.org_support.toast.description":
    "This add-on was successfully enabled and will be reflected on your current month projection within the next hour.",
  "organization.billing.modal.org_support.toast.title":
    "{supportLevel} organization support enabled",
  "organization.billing.modal.remaining":
    "{days} {days, plural, one{day} other{days}} left in minimum commitment",
  "organization.billing.modal.standard": "Advanced user management",
  "organization.billing.modal.standard.detail":
    "+{price} - teams, MFA Enforcement and Google SSO",
  "organization.billing.modal.title": "User management add on",
  "organization.billing.month": "{month} {type}",
  "organization.billing.monthly_estimate.current": "Projected total",
  "organization.billing.monthly_estimate.next": "Projected total",
  "organization.billing.mtc_downgrade_note":
    "You can downgrade after your commitment period ends. {value} days remaining.",
  "organization.billing.onboarding_training": "Onboarding - Training",
  "organization.billing.organization_addons": "Organization add-ons",
  "organization.billing.other": "Other",
  "organization.billing.per.user": "{price} per user",
  "organization.billing.per.user.addon": "+{price} per user",
  "organization.billing.premium_support.body":
    "Upgrade to receive service-level agreements with faster response times for your support tickets.",
  "organization.billing.premium_support.title": "Support SLA",
  "organization.billing.projected_total": "Projected total",
  "organization.billing.projected_total.description.current":
    "Based on the usage to date and estimating the rest of the month using the daily average.",
  "organization.billing.projected_total.description.future":
    "Based on your existing allocations or daily average, plus any add-ons for one month.",
  "organization.billing.projected_total.title.current":
    "This month’s projected total",
  "organization.billing.projected_total.title.future":
    "Future months’ projected total",
  "organization.billing.projects": "Projects",
  "organization.billing.prorated_quantity": "Prorated quantity",
  "organization.billing.prorated_quantity.description":
    "Based on an average of past changes and the current settings applied for all remaining days in the month.",
  "organization.billing.quantity": "Quantity",
  "organization.billing.subscribe.btn.disclaimer":
    "*Contact organization owner to subscribe",
  "organization.billing.subscribe.btn.learnmore": "Learn more",
  "organization.billing.subscribe.btn.subscribe": "Subscribe",
  "organization.billing.subscribe.btn.subscribe.tooltip":
    "Ask your admin to subscribe",
  "organization.billing.subscribe.btn.upgrade": "Upgrade",
  "organization.billing.subscribe.check1": "Preview environments",
  "organization.billing.subscribe.check2": "Observability",
  "organization.billing.subscribe.check3": "Team management",
  "organization.billing.subscribe.description":
    "Save up to $19 every month on your first user license and first project fee with <Link>First Project Incentive</Link>.*",
  "organization.billing.subscribe.description.terms":
    "*<Link>Terms and conditions apply</Link>",
  "organization.billing.subscribe.title": "Upgrade from trial",
  "organization.billing.subtotal": "Subtotal",
  "organization.billing.this_month": "This month",
  "organization.billing.this_months_projection": "This month's projection",
  "organization.billing.title": "Organization overview",
  "organization.billing.trial_discount_not_included":
    "The trial discount is not included.",
  "organization.billing.type": "Type",
  "organization.billing.unit_price": "Unit price",
  "organization.billing.upgrading": "Upgrade",
  "organization.billing.user_management": "User management",
  "organization.billing.user_management.body.downgrading":
    "Downgrading will remove advanced permissions, teams, and MFA enforcement",
  "organization.billing.user_management.body.upgrading":
    "Upgrade to unlock advanced user management capabilities like organization permissions, teams, and MFA enforcement.",
  "organization.billing.user_management.title": "User management",
  "organization.billing.users": "Users",
  "organization.billing.voucher": "Vouchers",
  "organization.billing_profile.support":
    "To make changes to your billing, <link>submit a support ticket</link>.",
  "organization.filter.permission.title": "Filter by permission",
  "organization.input.label.placeholder": "Organization name",
  "organization.input.name.validation-message":
    "Use 3-39 alphanumeric characters with single dashes between words. No consecutive dashes or dashes at the start/end.",
  "organization.input.url.placeholder": "Organization URL",
  "organization.invitation.failure.description":
    "Invitation to {email} failed.",
  "organization.invitation.failure.title": "Invitation failure",
  "organization.invitation.resend.confirm.body":
    "Are you sure you want to resend the invitation for {email}?",
  "organization.invitation.resend.confirm.title": "Resend invitation",
  "organization.invitation.resent.description":
    "{count, plural, one{Invitation} other{Invitations}} to {email} resent.",
  "organization.invitation.resent.title":
    "{count, plural, one{Invitation} other{Invitations}} re-sent",
  "organization.invitation.revoke.confirm.body":
    "Are you sure you want to revoke the invitation for {email}?",
  "organization.invitation.revoke.confirm.title": "Revoke invitation",
  "organization.invitation.revoke.rejected.description":
    "{email} could not be revoked.",
  "organization.invitation.revoke.rejected.title": "Invitation revoke failure",
  "organization.invitation.revoke.success.description": "{email} revoked.",
  "organization.invitation.revoke.success.title":
    "{count, plural, one{Invitation} other{Invitations}} revoked",
  "organization.invitation.sent.description": "{email} invited.",
  "organization.invitation.sent.title":
    "{count, plural, one{Invitation} other{Invitations}} sent",
  "organization.invitation.sort.updatedAsc": "Updated at (Asc)",
  "organization.invitation.sort.updatedDesc": "Updated at (Desc)",
  "organization.member.bulk.editSelected": "Edit selected",
  "organization.member.bulk.remove.fulfilled.description": "{email} removed.",
  "organization.member.bulk.remove.fulfilled.title":
    "{count, plural, one{User} other{Users}} removed",
  "organization.member.bulk.remove.rejected.description":
    "{email} could not be removed.",
  "organization.member.bulk.remove.rejected.title":
    "Failure removing {count, plural, one{user} other{users}}",
  "organization.member.bulk.remove_selected":
    "Remove {count, plural, one{user} other{users}}",
  "organization.member.bulk.resend_selected": "Resend selected",
  "organization.member.bulk.revoke_error_tooltip":
    "You cannot revoke any invitations that have errors",
  "organization.member.bulk.revoke_selected": "Revoke selected",
  "organization.member.bulk.selected_count": "{count} selected",
  "organization.member.bulk.team.allProjects": "All existing projects",
  "organization.member.bulk.team.allTeams": "All teams",
  "organization.member.bulk.team.create": "Create team",
  "organization.member.bulk.team.fulfilled.description":
    "{memberCount} users successfully added to {teamCount} teams",
  "organization.member.bulk.team.fulfilled.title": "Members added",
  "organization.member.bulk.team.invite": "Add to team",
  "organization.member.bulk.team.rejected.title":
    "Failed to add {member} to {team}",
  "organization.member.bulk.team.searchProject":
    "Type to search or select projects",
  "organization.member.bulk.team.searchTeam": "Type to search or select teams",
  "organization.member.bulk.team.searchUser": "Type to search or select users",
  "organization.member.bulk.team.searchUser.loading":
    "Loading organization members...",
  "organization.member.bulk.team.selectedProjects":
    "{count} {count, plural, one{project} other{projects}} selected",
  "organization.member.bulk.team.selectedTeams":
    "{count} {count, plural, one{team} other{teams}} selected",
  "organization.member.deleteconfirmation.title":
    "{email} successfully deleted",
  "organization.member.editPermissions": "Edit permissions",
  "organization.member.level.user": "User license",
  "organization.member.level.user.tooltip":
    "You are billed a $10 user license for this user.",
  "organization.member.level.viewer": "Viewer",
  "organization.member.level.viewer.tooltip":
    "You aren’t billed a $10 user license for viewers.",
  "organization.member.mfastatus.mfadisabled": "MFA disabled",
  "organization.member.mfastatus.mfaenabled": "MFA enabled",
  "organization.member.mfastatus.ssoenabled": "SSO enabled",
  "organization.member.owner": "Owner",
  "organization.member.removeProject": "Remove from project",
  "organization.member.sort.createdAsc": "Created at (Asc)",
  "organization.member.sort.createdDesc": "Created at (Desc)",
  "organization.member.teams.add": "Add user to teams",
  "organization.member.teams.remove.modal.description":
    "Are you sure you want to remove <b>{username}</b> from the team <b>{teamname}</b>?",
  "organization.member.teams.remove.modal.title": "Remove user",
  "organization.member.teams.removeFromTeam": "Remove from team",
  "organization.member.viewProject": "View project",
  "organization.members.caneditassigned":
    "You can only assign permissions that you have been granted.",
  "organization.members.cannoteditaccess":
    "Contact your org admin to make necessary changes.",
  "organization.members.cannoteditown":
    "You cannot manage your own permissions",
  "organization.members.teams": "Teams",
  "organization.new": "New organization",
  "organization.permissions.admin.definitionDetails":
    "Manage the organization and grants access to all organization permissions.",
  "organization.permissions.admin.definitionTerm": "Admin",
  "organization.permissions.billing.definitionDetails":
    "Manage the billing details of this organization.",
  "organization.permissions.billing.definitionTerm": "Manage billing",
  "organization.permissions.billing.info":
    "This permission can edit and manage the billing details of this organization.",
  "organization.permissions.members.definitionDetails":
    "Edit and assign permissions that you have been granted to users within this organization",
  "organization.permissions.members.definitionTerm": "Manage users",
  "organization.permissions.members.info":
    "This permission can edit and manage the users in this organization.",
  "organization.permissions.plans.definitionDetails":
    "Edit and manage project plans.",
  "organization.permissions.plans.definitionTerm": "Manage plans",
  "organization.permissions.plans.info":
    "This permission can edit and manage the project plans on all projects in this organization.",
  "organization.permissions.projects:create.definitionDetails":
    "Create new projects within the organization.",
  "organization.permissions.projects:create.definitionTerm": "Create projects",
  "organization.permissions.projects:create.info":
    "This permission can edit and manage the projects in this organization.",
  "organization.permissions.projects:list.definitionDetails":
    "View all projects within the organization.",
  "organization.permissions.projects:list.definitionTerm": "List projects",
  "organization.permissions.projects:list.details":
    "If a member has the manage plans or billing permission, they will automatically be able to see every organization project.",
  "organization.permissions.projects:list.details.noplans":
    "If a member has the billing permission, they will automatically be able to see every organization project.",
  "organization.project.access.invitemember":
    "To invite a new user to your organization, go to your <a>user management page</a>.",
  "organization.project.access.invitemember.member": "User",
  "organization.project.access.searchUser": "Type to search or select users",
  "organization.projectaccess.deleteModalBody":
    "Are you sure you want to remove <b>{userName}</b> from project <b>{projectName}</b>? ",
  "organization.projectaccess.deleteModalTitle": "Remove user",
  "organization.projectaccess.edituserpermissions.modal.description":
    "Manage the project permissions assigned to user <b>{userName}</b> ({userEmail}).",
  "organization.projectaccess.edituserpermissions.modal.title":
    "Edit {projectName} permissions",
  "organization.projectaccess.updateError.title":
    "Failed to update project access",
  "organization.projectaccess.updateSuccess.title": "Access updated",
  "organization.projects.header.id": "ID",
  "organization.projects.header.name": "Project name",
  "organization.projects.header.organization": "Organization",
  "organization.projects.header.owner": "Owner",
  "organization.projects.header.plan": "Plan",
  "organization.projects.header.region": "Region",
  "organization.security.sellable.description":
    "Upgrade to unlock advanced user management capabilities like organization permissions, teams, and MFA enforcement.",
  "organization.security.sellable.enable": "Upgrade",
  "organization.security.sellable.learnmore": "Learn more",
  "organization.security.sellable.title": "Upgrade user management features",
  "organization.sort.title": "Sort by",
  "organization.teams.member.add.notification.error.description":
    "Unable to add <b>{username}</b> to team <b>{team}</b><br></br>{description}",
  "organization.teams.member.add.notification.error.title":
    "Failed to invite to team",
  "organization.teams.member.add.notification.success.description":
    "{count} {count, plural, one{user} other{users}} added to the team <b>{team}</b>",
  "organization.tier.description":
    "Projects created within this organization will inherit the {tier} features.",
  "organization.url.preview.placeholder": "[your-url]",
  organization_create: "Create organization",
  organization_fixed: "Fixed organization",
  organization_flexible: "Flex organization",
  organization_name: "Organization name",
  organization_path: "Organization path",
  organization_settings: "Settings",
  organization_type: "Organization type",
  organization_type_compare_link: "Compare organization types",
  organization_type_description:
    "The organization type determines how all projects within the organization are billed and which features are available. The type cannot be changed after the organization is created.{br}{br}We recommend the “Flex” organization type for the best experience and access to the newest features.",
  organization_type_fixed: "Fixed",
  organization_type_fixed_description:
    "In a Fixed organization, all projects in this organization use a plan with predefined CPU and memory resources. These resources can’t be adjusted or scaled automatically. To increase capacity, you’ll need to upgrade to a higher plan.",
  organization_type_fixed_dialog_body:
    "All projects are on a plan with predefined CPU and Memory resources.",
  organization_type_fixed_existing: "Fixed (For existing fixed organizations)",
  organization_type_flexible: "Flex",
  organization_type_flexible_description:
    "With Flex, you can define the exact CPU and Memory resources that your applications and services need on every project—and adjust them at any time. You only pay for the resources you allocate.",
  organization_type_flexible_dialog_body:
    "You control the CPU and Memory resources allocated to each project, and can adjust them anytime or set them to adapt automatically.",
  organization_type_learn_more:
    "Learn more about fixed organization plans in our <a>documentation</a>.",
  organizations: "Organizations",
  "organizations.add_modal.info":
    "To learn more about organization permissions read our {documentationLink}",
  "organizations.delete_user": "Remove from organization",
  "organizations.edit_user": "Edit user",
  "organizations.empty_invitations": "You have no pending invitations",
  "organizations.empty_users": "No users",
  "organizations.free_during_trial": "Free during trial",
  "organizations.invite_user(s)": "Invite users",
  "organizations.members.cannoteditown":
    "You cannot manage your own permissions",
  "organizations.permissions": "Organization permissions",
  "organizations.permissions.description":
    "Users are automatically assigned all organization permissions. To customize permissions,",
  "organizations.permissions.link": "upgrade to our Standard add-on.",
  "organizations.permissions.note":
    "Note: The add-on is free during your free trial. After the trial, adding users \nwill increase your monthly costs. To learn more, visit our ",
  "organizations.search": "Search organizations",
  "organizations.security.menu": "Security",
  "organizations.security.mfa.description":
    "Multi-factor authentication (MFA) provides additional security for your organization. You can enforce users within your organization to enable MFA on their account.",
  "organizations.security.mfa.disable.success.title":
    "MFA successfully disabled",
  "organizations.security.mfa.disabled": "Disabled",
  "organizations.security.mfa.enable.action.enable": "Enable MFA",
  "organizations.security.mfa.enable.description":
    "All users within your organization will be required to have MFA enabled on their account. Users will not be able to access projects within your organization until they enable MFA.",
  "organizations.security.mfa.enable.enablefirst":
    "To enable this setting, you must <a>set up MFA</a> on your account first.",
  "organizations.security.mfa.enable.success.title": "MFA successfully enabled",
  "organizations.security.mfa.enable.title": "MFA required",
  "organizations.security.mfa.enabled": "MFA Enabled",
  "organizations.security.mfa.quired.description":
    "The organization <strong>{name}</strong> requires you to have Multi-Factor Authentication (MFA) enabled on your account. MFA provides additional security for your account. With MFA enabled, you log in to the site with a verification code in addition to your username and password.",
  "organizations.security.mfa.remind.error.title":
    "An error occurred while sending the reminder",
  "organizations.security.mfa.remind.success.description.multiple":
    "An email reminder has been sent to enable MFA.",
  "organizations.security.mfa.remind.success.description.single":
    "An email reminder has been sent to {userName} to enable MFA.",
  "organizations.security.mfa.remind.success.title": "Reminder sent",
  "organizations.security.mfa.required.button": "Set up application",
  "organizations.security.mfa.required.title":
    "Multi-Factor Authentication required",
  "organizations.security.mfa.setup.download.description":
    "You can enable MFA with these authenticator apps or one of your preference.",
  "organizations.security.mfa.setup.download.title":
    "Download authenticator app",
  "organizations.security.mfa.setup.install.code.label":
    "Authenticator text code",
  "organizations.security.mfa.setup.install.code.title":
    "Enter this code into your authenticator app",
  "organizations.security.mfa.setup.install.description":
    "After registering your authenticator app, you will need to log in again to complete the set up.",
  "organizations.security.mfa.setup.install.or": "or",
  "organizations.security.mfa.setup.install.scan.label": "QR Code",
  "organizations.security.mfa.setup.install.scan.title":
    "Scan the QR code below",
  "organizations.security.mfa.setup.install.title": "Install authenticator app",
  "organizations.security.mfa.setup.install.verify.label": "Verification code",
  "organizations.security.mfa.setup.install.verify.placeholder":
    "Enter code here",
  "organizations.security.mfa.setup.install.verify.title":
    "Input verification code from your authenticator app.",
  "organizations.security.mfa.setup.providers.info":
    "You can use any One Time Password (OTP) compatible app.",
  "organizations.security.mfa.users.header.email": "Email",
  "organizations.security.mfa.users.header.lastlogin": "Last login",
  "organizations.security.mfa.users.header.mfastatus": "MFA status",
  "organizations.security.mfa.users.header.name": "Name",
  "organizations.security.mfa.users.remind": "Remind",
  "organizations.security.mfa.users.remind.disabled":
    "MFA enforcement is not enabled for the organization",
  "organizations.security.mfa.users.selected": "{count} selected",
  "organizations.security.mfa.users.title": "User security settings",
  "organizations.security.mfa.users.view": "View user",
  "organizations.security.sso.enabled": "SSO Enabled",
  "organizations.security.sso.required.button": "Log in with SSO",
  "organizations.security.sso.required.description":
    "SSO has been enabled on <strong>{name}</strong> and you are required to log in again through SSO to access this organization.",
  "organizations.security.sso.required.title": "Single Sign-On (SSO) required",
  "organizations.security.title": "Security",
  "organizations.settings.add_users_text":
    "Invite new or existing {appName} users to your organization.",
  "organizations.settings.create_project_description":
    "Create a new project to start building and collaborating within your organization.",
  "organizations.settings.delete": "Delete",
  "organizations.settings.delete_modal.sentence":
    "You are about to delete the organization <b>{sub}</b>. If this organization owns a project, or has unpaid invoices, you need to delete the projects and pay the remaining invoices before doing so. This process is not reversible.",
  "organizations.settings.delete_modal.title": "Delete organization",
  "organizations.settings.invoices_text":
    "View your organizations latest invoices.",
  "organizations.settings.manageaddons.description":
    "Control which add-ons can be used by this organization.",
  "organizations.settings.manageaddons.title": "Manage add-ons",
  "organizations.settings.view_billing_details_text":
    "Manage your organizations billing details.",
  organizations_description:
    "Select an organization for managing your project’s billing and users’ permissions.{br}{br} If you need to create a new organization go  <a>here</a>.",
  organizations_fixed: "Fixed organizations",
  organizations_flexible: "Flex organizations",
  "organizations_list.add_ons": "Add-ons",
  "organizations_list.cost": "Cost",
  "organizations_list.edit": "Edit",
  "organizations_list.error_loading_account":
    "Failed to load billing account. Please try again.",
  "organizations_list.manage_organizations": "Manage organizations",
  "organizations_list.no_organizations": "No organizations found.",
  "organizations_list.organization_admins_count":
    "Organization admins ({count})",
  "organizations_list.organization_admins_description":
    "Users who can assign this billing account to their organizations.",
  "organizations_list.organization_name": "Organization name",
  "organizations_list.owner": "Owner",
  "organizations_list.projects": "Projects",
  "organizations_list.status_active": "Active",
  "organizations_list.title": "Organizations",
  "organizations_list.users": "Users",
  out_of_retention: "Outside of retention limits.",
  outgoing: "Outgoing",
  overdue: "Overdue",
  override: "Override",
  override_variables: "Add/Override variables",
  "overview.failed_activity":
    "Your latest activity failed. Check the log for details. <link>View log</link>",
  "overview.no.configured.resources":
    "Configure your resources to initialize or deploy your {environment} environment. <link>Configure resources</link>",
  p95: "P95",
  parent_environment: "Parent environment",
  password: "Password",
  "password.error.digit": "Add a number",
  "password.error.long": "Use at least 10 characters",
  "password.error.lowercase": "Add one lowercase letter",
  "password.error.special_char": "Add a symbol",
  "password.error.uppercase": "Add one uppercase letter",
  password_guidelines:
    "Must be 10 characters or more and contain at least one of each of the following: uppercase, lowercase, number and symbol.",
  "password_guidelines.characters": "Use at least 10 characters",
  "password_guidelines.lowercase": "Add one lowercase letter",
  "password_guidelines.number": "Add a number",
  "password_guidelines.symbol": "Add a symbol",
  "password_guidelines.uppercase": "Add one uppercase letter",
  password_guidelines_title: "Password requirements",
  password_label: "Password",
  password_length: "The password can't be shorter than minimum length 6",
  "password_length-error": "Password must be at least 6 characters.",
  password_placeholder: "Password",
  pause_env_confirm_button: "Pause environment",
  "pause_production_environment.modal.description":
    "Pausing your production environment may cause downtime and impact your live services.<br></br> Are your sure you want to proceed?",
  "pause_production_environment.modal.title": "Pause production environment",
  paused_text: "paused",
  "payload.commits":
    "{count, plural, =0 {zero} one {+ 1 commit} other {+ {count} commits}}",
  payment: "payment",
  payment_consent:
    "I agree to pay my monthly usage fees. I understand I can change plans and add options through the month, which may incur additional fees.",
  payment_description:
    "Usage will be calculated at the end of each month and automatically billed to the information provided below.",
  "payment_elements.address_disclaimer":
    "*Add your address before adding your payment method",
  "payment_elements.checkbox":
    "I agree to pay for my monthly usage. I understand that changing plans or adding options mid-month may incur additional charges.",
  "payment_elements.credit-card": "Credit card",
  "payment_elements.description":
    "Add a payment method for this billing profile.",
  "payment_elements.escalate_credit_card":
    "Use my credit card saved from identity verification",
  "payment_elements.expiration": "Expiration",
  "payment_elements.loading_note":
    "You are redirecting to securely complete next steps.",
  "payment_elements.mandate": "Mandate reference",
  "payment_elements.messages.sepa_info":
    "SEPA payments may be enabled by <link>contacting support</link>.",
  "payment_elements.messages.sepa_info.description":
    "I would like to enable SEPA as a payment method for my organization.",
  "payment_elements.messages.sepa_info.subject": "Request SEPA payment method",
  "payment_elements.note":
    "After submission, you will be redirected to securely complete next steps.",
  "payment_elements.saved.description": "Your current payment method",
  "payment_elements.update": "Update",
  payment_information: "payment information",
  payment_information_description:
    "This is a secure 128-bit SSL encrypted payment gateway.",
  payment_method: "Payment method",
  payment_voucher_description:
    "You have voucher credit that can be used for this purchase.",
  permission_level: "permission level",
  "phone_verification.code.help":
    "Didn't get a code? <a>Choose another method</a>.",
  "phone_verification.code.intro.call":
    "We'll call you at {phone}. Enter the code below.",
  "phone_verification.code.intro.sms":
    "Enter the code we sent over SMS to {phone}.",
  "phone_verification.code.submit": "Confirm",
  "phone_verification.code.title": "Enter the code",
  "phone_verification.methods.call.label": "Phone call",
  "phone_verification.methods.call.label_details":
    "We'll call you with a code.",
  "phone_verification.methods.continue": "Continue",
  "phone_verification.methods.help":
    "Need more help? <a>Contact our support team</a>.",
  "phone_verification.methods.intro": "Where do you want your code sent?",
  "phone_verification.methods.sms.label": "Text message (SMS)",
  "phone_verification.methods.sms.label_details": "We'll text you a code.",
  "phone_verification.methods.submit": "Resend code",
  "phone_verification.methods.title": "Verification methods",
  "phone_verification.phone.fields.phone.label": "Phone number",
  "phone_verification.phone.intro":
    "Can we have your number? We just need to verify you’re human after all. And we promise it won’t be stored. You’ll be sent a verification code to enter here and that’s it!",
  "phone_verification.phone.submit": "Send code",
  "phone_verification.phone.switch_method": "Other verification methods",
  "phone_verification.phone.title": "Verify your number",
  plaintext_email: "plaintext email only",
  plan: "plan",
  "plan.manage": "Manage Plan",
  plan_and_pricing: "Plan & Pricing",
  plan_and_pricing_sumup_description_1:
    "Your new project will be created on our smallest <b>{planType} plan</b>",
  plan_and_pricing_sumup_description_2:
    "You can change your plan, add more storage, users or environments at any time through your project account settings.",
  plan_and_pricing_sumup_plan: "Development",
  "plan_and_pricing_sumup_plan-label": "Plan",
  plan_and_pricing_text: " unless you're in our free trial",
  plan_and_pricing_trial_text:
    " and billed at $12 per month after your free trial ends",
  plan_environment_confirmation:
    "The selected plan has different options for environments. Please confirm the new number of environments and cost differences before saving.",
  "plan_includes.item.environments": "3 Development environments",
  "plan_includes.item.prod": "Main dev site (future production site)",
  "plan_includes.item.storage": "5 GB Storage per environment",
  "plan_includes.item.user": "1 User",
  "plan_includes.title": "Includes",
  plan_price: "$12 <label>USD</label>",
  plan_price_discounted: "<s>$12</s> <label>USD</label>",
  plans: "Plans",
  "plans.available_plans":
    "See all available plans and pricing on our <a>pricing page</a>.",
  "plans.blackfire.addon_add_prompt_continue_description":
    "Blackfire currently only supports {blackfireSupportLanguages}. Are you sure you want to add Blackfire to your subscription?",
  "plans.blackfire.addon_add_prompt_continue_description_note":
    "<strong>Note: </strong> User and environment data will be synchronized to <a>Blackfire.io</a>. Existing environments must be redeployed to activate the synchronization.",
  "plans.blackfire.addon_add_prompt_continue_title":
    "Continue with Blackfire enabled",
  "plans.blackfire.addon_support_prompt_continue_description":
    "Blackfire currently only supports {blackfireSupportLanguages} applications, but we didn’t detect any of these on your project. Are you sure you want to save the project with Blackfire enabled?",
  "plans.blackfire.addon_support_prompt_continue_title":
    "Continue with Blackfire enabled",
  "plans.blackfire.enterprize_addon_acquire_info":
    "Blackfire is a Platform.sh product and is part of the Observability Suite upgrade. Contact our sales team to upgrade.",
  "plans.blackfire.enterprize_addon_description":
    "Monitor, profile, and test your application. Included with the Observability Suite.",
  "plans.blackfire.enterprize_addon_included_info":
    "Blackfire is a Platform.sh product. This project already includes Blackfire through the Observability Suite upgrade.",
  "plans.blackfire.pro_addon_acquire_info":
    "Blackfire is a Platform.sh product that provides actionable performance insights for {blackfireSupportLanguages} projects. The profiler is included with every add-on on all plans. Production plans get access to monitoring and alerting.",
  "plans.blackfire.pro_addon_description":
    "Optimize app performance for a better user experience",
  platform_delete_env_cmd: "git push --delete {cli_name} {envName}",
  "platform_delete_env_cmd.integration":
    "git push {repository} --delete  {envName}",
  please_signup_again:
    "Please sign up again to receive your activation link in your inbox.",
  "pluginapp.error.error_loading": "Error while loading '{name}'",
  "pluginapp.error.unreachable":
    "The plugin app source is not reacheable. Please try again later.",
  preload: "preload",
  pressure_metrics: "Pressure Metrics",
  pressure_metrics_description:
    "Pressure shows how often your app is delayed waiting for resources. Low pressure means smooth performance.",
  preview: "Preview",
  price_increase_note:
    "Note: Adding users will increase your monthly costs. To learn more, visit\nour",
  prices_per_month: "prices per month, per site",
  pricing: "<b>Free for 30 days, then starts at $12 per month</b>",
  "pricing.page": "pricing page",
  primary_text: "primary_text",
  privacy_policy: "Privacy Policy",
  private_key: "Private key",
  production: "production",
  production_environment: "Production environment",
  production_environment_info:
    "Name your future production environment. This will be your default Git branch, which is important for connecting your repositories. Projects usually use 'main' as their default Git branch.",
  production_environment_learn_more: "Learn more",
  production_environment_name: "Production environment name",
  "production_environment_name.details":
    "This branch will be connected to your production environment on {app_name}.",
  "production_environment_name.dialog.info.github":
    "Select the branch from your Git repository that will be used for your production environment in Upsun. You'll be able to change it later.",
  "production_environment_name.dialog.title.github":
    "GitHub branch for production",
  "production_environment_name.error":
    "Must contain a <a>valid Git branch name</a>.",
  "production_environment_name.error.sticker":
    "Production environment name was not accepted",
  "production_environment_name.github": "GitHub branch for production",
  production_environment_text:
    "This is your production environment. You cannot deactivate or delete this environment. <link>Learn more</link>",
  professional: "professional",
  "professional.support": "Professional support",
  profile_dialog: "Profile",
  profiling: "Profiling",
  "profiling.blackfire_info":
    "Blackfire is a Platform.sh product that supports PHP and Python projects. It is included in your subscription, so you can use Blackfire.io to monitor, profile, and test your application.",
  "profiling.no_services": "No apps or services",
  "profiling.no_services.display.description":
    "To view continuous profiling data, first add an application or service.",
  "profiling.no_services.display.description.link":
    "<a>Learn more about configuring apps and services.</a>",
  "profiling.title": "Continuous profiling",
  profiling_enable_info_description:
    "For more information on how to enable continuous profiling for Node.js and Go applications, read our documentation",
  profiling_no_data_info_dev:
    "Development environments typically need to generate traffic to see profiling data. If the problem persists, then check for configuration issues.",
  profiling_no_data_info_prod:
    "Receiving no data on a production environment may mean there are configuration issues.",
  profiling_no_data_info_title: "No data.",
  profiling_not_enabled: "Profiling not enabled",
  profiling_not_supported: "Profiling not supported",
  profiling_not_supported_description:
    "Profiling is not currently supported for this application type.",
  project: "Project",
  "project.access.environment_types":
    "Permission changes to environments will apply to all other environments of the same type.",
  "project.access.leave": "Leave project",
  "project.access.leave.confirm":
    "Are you sure you want to remove <strong>{userName}</strong> from the project <strong>{projectTitle}</strong>?",
  "project.access.leave.success.description":
    "You successfully removed <strong>{userName}</strong> from the project <strong>{projectTitle}</strong>.",
  "project.access.leave.success.title":
    "{userName} removed from {projectTitle}",
  "project.access.owner.tooltip":
    "An organization owner can't be removed from a project",
  "project.access.remove_user": "Remove user",
  "project.access.view": "View user",
  "project.access.yourself": "yourself",
  "project.accesslist.add_team": "Add team",
  "project.accesslist.add_user": "Add user",
  "project.accesslist.add_user_to_project": "Add user to project",
  "project.accesslist.addbyadmin": "Ask your project admin to add a user",
  "project.accesslist.already_exists":
    "This user has already been added to this project. You can edit this user's access below.",
  "project.accesslist.description":
    "Configure your users access to all or specific environments of this project.",
  "project.billing.application": "Application",
  "project.billing.application_resources": "Application resources",
  "project.billing.backup.storage": "Backup Storage",
  "project.billing.backups": "Backups",
  "project.billing.bandwidth": "Bandwidth",
  "project.billing.breakdown.project.settings": "Project settings",
  "project.billing.breakdown.project.view": "View project",
  "project.billing.build": "Build",
  "project.billing.build.minutes": "Build minutes",
  "project.billing.build_resources": "Build resources",
  "project.billing.by.environment": "By environment",
  "project.billing.by.resource": "By resource",
  "project.billing.cdn_traffic_note.long":
    "CDN usage values are for the current month and updated daily. Overages will be invoiced. Contact your account manager for quota and prepaid details.",
  "project.billing.cdn_traffic_note.short":
    "CDN usage is usage is for the current month and updated daily.",
  "project.billing.continuous_profiling.body":
    "Retain 30 days of continuous profiling data.",
  "project.billing.continuous_profiling.title": "Continuous profiling",
  "project.billing.current_accumulation": "Current accumulation",
  "project.billing.current_allocation": "Current allocation",
  "project.billing.current_spend": "Current spend",
  "project.billing.current_spend.description":
    "The cost that has accumulated so far this month. This includes any changes made prior to today that will be reflected on your monthly invoice.",
  "project.billing.daily_average": "Daily average",
  "project.billing.daily_average.description":
    "Based on the average of the usage over the last 30 days.",
  "project.billing.disk": "Disk",
  "project.billing.disk.storage": "Disk Storage",
  "project.billing.enterprise_message":
    "Please note that discounts and contract details are not yet reflected in these invoices. You can review this directly with your account manager.",
  "project.billing.enterprise_only": "Enterprise only",
  "project.billing.environment": "Environment",
  "project.billing.fastly": "CDN Traffic <small>(Fastly)</small>",
  "project.billing.guaranteed.cpu": "Guaranteed CPU",
  "project.billing.hide_environment": "Hide environment",
  "project.billing.hide_environments": "Hide environments",
  "project.billing.invoice.description":
    "This breakdown is based on the usage to date and current allocation, and then uses averages to estimate remaining costs for the month.",
  "project.billing.label.backup_storage": "Backups",
  "project.billing.label.build_cpu": "CPU",
  "project.billing.label.build_memory": "Memory (1 TB)",
  "project.billing.label.cpu_app.guaranteed": "Guaranteed CPU",
  "project.billing.label.cpu_app.shared": "Shared CPU",
  "project.billing.label.cpu_services.guaranteed": "Guaranteed CPU",
  "project.billing.label.cpu_services.shared": "Shared CPU",
  "project.billing.label.egress_bandwidth": "Bandwidth",
  "project.billing.label.fastly_bandwidth": "Bandwidth",
  "project.billing.label.fastly_requests": "Requests",
  "project.billing.label.ingress_requests": "Requests",
  "project.billing.label.logs_fwd_content_size": "Outbound payload",
  "project.billing.label.memory_app": "Memory (1 GB)",
  "project.billing.label.memory_services": "Memory (1 GB)",
  "project.billing.label.storage_app_services": "Disk storage",
  "project.billing.logs_forwarding": "Logs forwarding",
  "project.billing.memory": "Memory",
  "project.billing.metric": "Metric",
  "project.billing.modal.continuous_profiling.advanced": "Advanced",
  "project.billing.modal.continuous_profiling.advanced.detail":
    "{price}/month - Retain 30 days of data",
  "project.billing.modal.continuous_profiling.standard": "Standard",
  "project.billing.modal.continuous_profiling.standard.detail":
    "Retain only 15 minutes of data",
  "project.billing.na": "N/A",
  "project.billing.observability": "Observability",
  "project.billing.onboarding_setup": "Onboarding - Setup",
  "project.billing.origin_traffic": "Origin traffic",
  "project.billing.origin_traffic_note.long":
    "Origin traffic values are for the current month and updated daily. Overages will be invoiced. Contact your account manager for quota and prepaid details.",
  "project.billing.origin_traffic_note.short":
    "Origin traffic values are for the current month and updated daily.",
  "project.billing.paused.environment": "Environment is paused",
  "project.billing.project.base": "Project base",
  "project.billing.project.fee.included": "10 GB included",
  "project.billing.project_add_ons": "Project add-ons",
  "project.billing.project_add_ons.remove": "Remove",
  "project.billing.project_addons": "Project add-ons",
  "project.billing.project_fee": "Project fee",
  "project.billing.projected_total": "Projected total",
  "project.billing.prorated_quantity": "Prorated quantity",
  "project.billing.quantity": "Quantity",
  "project.billing.ram": "RAM",
  "project.billing.resources": "Resources",
  "project.billing.resources.adjust": "Adjust",
  "project.billing.resources_by_environment": "Resources by environment",
  "project.billing.row.resource_allocation": "Total resource allocation",
  "project.billing.service": "Service",
  "project.billing.service_resources": "Service resources",
  "project.billing.shared.cpu": "Shared CPU",
  "project.billing.storage": "Storage",
  "project.billing.title": "Project overview",
  "project.billing.traffic": "Traffic",
  "project.billing.type": "Type",
  "project.billing.unit_price": "Unit price",
  "project.billing.usage": "Usage",
  "project.billing.value.build.minutes": "{minutes} minutes",
  "project.billing.value_cpu": "{value} CPU",
  "project.billing.value_cpu_hours": "{value} CPU hours",
  "project.billing.value_gb": "{value} GB",
  "project.billing.value_gb_ram": "{value} GB RAM",
  "project.billing.value_m_requests": "{value}M requests",
  "project.billing.value_requests": "{value} requests",
  "project.billing.value_slash_1k_after_500k": "{value} / 1K (after 500K)",
  "project.billing.value_slash_1m": "{value} / 1M",
  "project.billing.value_slash_gb": "{value} / GB",
  "project.billing.value_slash_gb_after_10gb": "{value} / GB (after 10 GB)",
  "project.billing.value_slash_hour": "{value} / hour",
  "project.billing.value_slash_month": "{value} / month",
  "project.billing.value_slash_tb": "{value} / TB",
  "project.billing.value_slash_tb_after_10gb": "{value} / TB (after 10 GB)",
  "project.billing.value_tb": "{value} TB",
  "project.billing.view_all_value_environments":
    "View all {value} {value, plural, one{environment} other{environments}}",
  "project.card.provisioning": "// {projectName} is being created",
  "project.card.provisioning.connectionLost": "Connection lost — retrying…",
  "project.card.provisioning.failed.link": "View project",
  "project.card.provisioning.failed.title":
    "Your project {projectName} could not be created.",
  "project.card.provisioning.ready.link": "View project",
  "project.card.provisioning.ready.title":
    "Your project {projectName} is ready.",
  "project.card.provisioning.starting": "Setting up your project…",
  "project.card.provisioning.status": "Building",
  "project.card.provisioning.step": "Step {current}/{total}",
  "project.card.tag.no-access": "No access",
  "project.card.tag.suspended": "Suspended",
  "project.card.tag.trial": "Free trial",
  "project.creation.stage.activate.description":
    "Building your production environment from your main Git branch. Every new branch spins up an isolated clone of code and data.",
  "project.creation.stage.activate.title":
    "Initializing your production-ready environment",
  "project.creation.stage.capabilities.description":
    "Enabling routing, security, backups, scaling, and scheduled operations, each tunable per environment.",
  "project.creation.stage.capabilities.title":
    "Enabling built-in platform services",
  "project.creation.stage.create.description":
    "Reading your repo's .upsun/config.yaml file and provisioning one isolated container for each part of your project.",
  "project.creation.stage.create.title": "Building your cluster from code",
  "project.creation.stage.grants.description":
    "Setting up your permission layer for your team, plus API and MCP servers for AI agents.",
  "project.creation.stage.grants.title": "Setting up role-based access",
  "project.creation.stage.integrations.description":
    "Connecting profiles, traces, and logs to your existing workflow.",
  "project.creation.stage.integrations.title":
    "Wiring observability into your workflow",
  "project.creation.stage.ready.title": "Checking for apps and services…",
  "project.creation.status.done": "Completed",
  "project.creation.status.failed": "Failed",
  "project.creation.status.in_progress": "In progress",
  "project.creation.status.pending": "Pending",
  "project.creation.status.title": "Project creation status",
  "project.details.billing_period": "Billing period: {value}",
  "project.details.cdn_bandwidth": "CDN bandwidth",
  "project.details.cdn_requests": "CDN requests",
  "project.details.disk": "Disk",
  "project.details.domain.set": "Set a custom domain",
  "project.details.domain.update": "Update custom domain",
  "project.details.double_value": "{value}<separator></separator>{value2}",
  "project.details.environment":
    "{count, plural, one{Environment}  other{Environments}}",
  "project.details.environments": "Environments",
  "project.details.environments_used": "{used} out of {total}",
  "project.details.no_url":
    "A URL to access your project will be shown here after the project is deployed.",
  "project.details.origin_bandwidth": "Origin bandwidth",
  "project.details.origin_requests": "Origin requests",
  "project.details.plan": "{name} Plan",
  "project.details.plan.upgrade": "Upgrade",
  "project.details.resources": "Resources",
  "project.details.traffic.no_permission": "Contact an admin to change alerts",
  "project.details.traffic_note":
    "Traffic data is accumulated throughout the current month and values are updated daily.",
  "project.details.traffic_this_month": "Traffic this month",
  "project.details.users": "Users",
  "project.maintenance_window.ask_admin":
    "Ask your project admin to set a maintenance window.",
  "project.maintenance_window.define_settings":
    "Define one to ensure your environments receive critical updates.",
  "project.maintenance_window.description":
    "To keep your environments secure and reliable, we regularly apply security and service updates. These updates require brief downtime, so we use a maintenance window to minimize disruption to your application.",
  "project.maintenance_window.error.description":
    "The maintenance window couldn’t be saved due to a backend error. Please try again later.",
  "project.maintenance_window.help.learn_more": "Learn more",
  "project.maintenance_window.help.text":
    "If you don’t define a maintenance window, we can’t guarantee your environments will receive critical updates.",
  "project.maintenance_window.interval.2w": "2 weeks",
  "project.maintenance_window.interval.4w": "4 weeks",
  "project.maintenance_window.no_settings": "No maintenance window set.",
  "project.maintenance_window.not_set": "Not set yet",
  "project.maintenance_window.repeat_every": "Repeat every",
  "project.maintenance_window.repeat_on": "Repeat on",
  "project.maintenance_window.rescheduled_to": "Rescheduled to",
  "project.maintenance_window.schedule": "Schedule",
  "project.maintenance_window.select_time": "Select time",
  "project.maintenance_window.set_maintenance_window_button":
    "Set maintenance window",
  "project.maintenance_window.success.description":
    "Reschedule specific updates or change this window for all upcoming maintenance.",
  "project.maintenance_window.success.title": "Maintenance window saved",
  "project.maintenance_window.time": "Time",
  "project.maintenance_window.title": "Maintenance window",
  "project.maintenance_window.upcoming_maintenance": "Upcoming maintenance:",
  "project.maintenance_window.update_info":
    "(Updates can be rescheduled within the same cycle if needed.)",
  "project.morelinks.configure_resources": "Configure resources",
  "project.morelinks.delete": "Delete",
  "project.morelinks.delete_modal.sentence":
    "Are you sure you want to delete your project <b>{sub}</b>? {br} {br} Please note that deleting your project is irreversible and all data associated with this project will be deleted, including backups. Lastly, at the end of the month you will be charged for any remaining project costs.",
  "project.morelinks.delete_modal.title": "Delete project",
  "project.morelinks.edit": "Edit plan",
  "project.morelinks.id": "ID {id}",
  "project.morelinks.view": "View project",
  "project.morelinks.wizard": "Setup wizard",
  "project.notfound": "project not found",
  "project.overview.domain": "Assign a domain",
  "project.overview.wizard": "Finish setup",
  "project.plan.backups.estimation":
    "{numberAutomated} automated + {numberManual} manual included",
  "project.plan.backups.info":
    "Backups create a complete snapshot of the environment and can be triggered through the console or the CLI. Automated backups are run between 3am - 5am based on your project’s timezone.",
  "project.plan.backups.no-backup-no-default":
    "Upgrade to an automated backup plan for your production environment.",
  "project.plan.backups.title": "Backups",
  "project.plan.backups.tooltip.text":
    "Contact our sales team to get access to the Premium backup plans. Those plans are available to Elite and Enterprise organizations.",
  "project.plan.backups.tooltip.text.no-backup-no-default":
    "Default automated backup plans will be applied November 30.",
  "project.plan.backups.tooltip.url.text": "Learn more",
  "project.plan.cdn_bandwidth": "CDN Bandwidth",
  "project.plan.cdn_requests": "CDN Requests",
  "project.plan.complex_micro_service_applications":
    "complex micro-services applications",
  "project.plan.environment.estimation": "{estimation} / environment",
  "project.plan.environment.title": "Environments",
  "project.plan.highmem_disclaimer":
    "<b>Note:</b> Resources in high-memory plans are not always allocated by default and should only be used in particular instances. Learn more about them and how to configure them in our <link_docs>resources docs</link_docs> or open a <link_tix>support ticket</link_tix> if you need assistance.",
  "project.plan.includes.additional_service":
    "<b>{value}</b> additional service (MySQL...)",
  "project.plan.includes.branch": "Dev site (future production site)",
  "project.plan.includes.custom_domain": "Custom domain",
  "project.plan.includes.custom_domains": "Custom domains",
  "project.plan.includes.envs":
    "<b>{value}</b> Development {value, plural, one {environment} other {environments}}",
  "project.plan.includes.production_site": "Production site",
  "project.plan.includes.ssl": "SSL support",
  "project.plan.includes.storage": "<b>{value}</b> GB storage per environment",
  "project.plan.includes.title": "Includes",
  "project.plan.includes.user": "<b>{value}</b> User",
  "project.plan.memory_intensive_apps": "memory intensive applications",
  "project.plan.multi_app_multi_data_apps": "multi-apps or multi-database apps",
  "project.plan.multiple_backends": "multiple backends",
  "project.plan.note.description":
    "*Note that you can only upgrade storage and backups at this time. Request a downgrade by submitting a",
  "project.plan.note.text": "support ticket",
  "project.plan.overage_note":
    "**Overages for Origin and CDN usage (bandwidth and requests) are are invoiced separately. Contact your account manager for quota and prepaid details.",
  "project.plan.planType": "Plan type",
  "project.plan.specs":
    "{cpu, plural, one {# CPU} other {# CPUs}} & {memory} GB Memory",
  "project.plan.storage.dialog":
    "If you want to add more than 100GB of storage or reduce it, you'll need to submit a support ticket.",
  "project.plan.storage.dialog.ticket": "Submit a ticket",
  "project.plan.storage.estimation": "{estimation} / GB; 5 GB per environment",
  "project.plan.storage.title": "Storage",
  "project.plan.support.supportSLA": "Support SLA",
  "project.plan.tier.label": "{tier} Tier",
  "project.plan.traffic.higher_traffic_websites": "higher-traffic websites",
  "project.plan.traffic.low_med_traffic_websites":
    "low-medium traffic websites",
  "project.plan.traffic.med_higher_traffic_websites":
    "medium-higher traffic websites",
  "project.plan.trial.info":
    "Free trials are limited to development only plans, add your billing details to change your plan.",
  "project.plan.trial.info.link": "Add billing details",
  "project.plan.type": "Plan",
  "project.plan.upgrade": "Upgrade plan",
  "project.plan.users.estimation":
    "{estimation} / per user per month. Billed when added to your platform",
  "project.plan.users.title": "Users",
  "project.screenshot.plan": "Plan ",
  "project.screenshot.state.live": "Live",
  "project.screenshot.state.not_live": "Go live",
  "project.settings.basic.form.name": "Project name",
  "project.settings.basic.form.region": "Region",
  "project.settings.basic.form.timezone.info":
    "The Project timezone only affects <b>backup scheduling and maintenance windows</b>. All Console timestamps use your browser's local timezone by default.",
  "project.settings.basic.form.timezone.label": "Timezone",
  "project.settings.basic.form.timezone.placeholder": "Select timezone",
  "project.settings.basic.name": "Project name",
  "project.settings.manageaddons.description":
    "Control which add-ons can be used by this project.",
  "project.setup.cli.install.brew": "brew install upsun/tap/platformsh-cli",
  "project.setup.cli.install.scoop":
    "scoop bucket add upsun https://github.com/upsun/homebrew-tap.git && scoop install platform",
  "project.setup.cli.install.shell":
    "curl -fsSL https://raw.githubusercontent.com/platformsh/cli/main/installer.sh | VENDOR={cli_command} bash",
  "project.setup.demo_start": "{cli_command} demo:start",
  "project.setup.tips.clone": "Clone and access your project",
  "project.setup.tips.clone_command":
    "git clone https://github.com/upsun/demo.git upsun-demo\ncd upsun-demo",
  "project.setup.tips.configurations":
    "Learn more about project configurations",
  "project.setup.tips.connect": "Connect your local project to {app_name}",
  "project.setup.tips.connect_command":
    "{cli_command} project:set-remote {projectId}",
  "project.setup.tips.connect_repo": "Connect directory to {app_name}",
  "project.setup.tips.connect_repo.command":
    "{cli_command} project:set-remote {projectId}",
  "project.setup.tips.deploy": "Deploy to {app_name}",
  "project.setup.tips.deploy.demo_command": "{cli_command} push",
  "project.setup.tips.deploy_commands":
    '{cli_command} project:init\ngit commit -m "Add {app_name} configuration"\n{cli_command} push',
  "project.setup.tips.description":
    "Follow these steps to start exploring {app_name} features.",
  "project.setup.tips.info": "Let’s launch your {app_name} demo project",
  "project.setup.tips.install_cli": "Install the CLI",
  "project.setup.tips.launch": "Launch Demo Guide (open project in browser)",
  "project.setup.tips.launch_command": "{cli_command} url --primary",
  "project.setup.tips.push": "Push your code to {app_name}",
  "project.setup.tips.start_project": "Start your demo project",
  "project.setup.tips.steps":
    "Follow these steps to get started and deploy your code to {app_name}.",
  "project.state.live": "Live",
  "project.state.not_live": "Go live",
  "project.variable.access":
    "To add or edit variables you need project admin access on this project",
  project_access: "Project access",
  project_admin: "project admin",
  project_backups: "Project backups",
  "project_detail.header.duration": "Duration",
  "project_detail.header.item": "Item",
  "project_detail.header.quantity": "Quantity",
  "project_detail.header.total": "Total",
  "project_detail.header.unit_price": "Unit price",
  "project_detail.total": "Total",
  project_details: "your project details",
  project_information: "Create your project",
  project_name: "Project name",
  project_overview: "Project overview",
  project_setting: "Project settings",
  project_settings: "project settings",
  project_status: "Project status",
  project_variables: "Project variables",
  projects: "Projects",
  "projects.filter.all": "All projects",
  "projects.grid_layout": "projects grid layout",
  "projects.hide_filter": "Hide filters",
  "projects.list_layout": "projects list layout",
  "projects.show_filter": "Show filters",
  "projects.sort.reverse": "Reverse order",
  "projects.toggle.sort": "Sort by",
  "projects.toggle.sort_by": "Sort by",
  "projects.toggle.sort_by.created_at": "Date created",
  "projects.toggle.sort_by.id": "Project ID",
  "projects.toggle.sort_by.name": "Alphabetically",
  "projects.toggle.sort_by.organization": "Organization",
  "projects.toggle.sort_by.owner": "Owner",
  "projects.toggle.sort_by.plan": "Plan size",
  "projects.toggle.sort_by.project_id": "Project ID",
  "projects.toggle.sort_by.project_region": "Region",
  "projects.toggle.sort_by.project_title": "Alphabetically",
  "projects.toggle.sort_by.region": "Region",
  projects_filters_clear: "Clear",
  projects_filters_empty_description:
    "Try adjusting your filters to see more projects",
  projects_filters_empty_reset: "Reset filters",
  projects_filters_empty_title: "No projects found",
  projects_filters_infrastructure: "Infrastructure",
  projects_filters_plan_size: "Plan size",
  projects_filters_plan_tooltip:
    "You can’t filter by Plan size for Dedicated projects",
  projects_filters_region: "Region",
  projects_filters_region_tooltip:
    "You can’t filter by Region for Dedicated projects",
  projects_filters_title: "Filter",
  provider: "Provider",
  public_key: "Public key certificate",
  push_text:
    "at the end of your setup, you will be provided with a repository to push your code to.",
  pushed: "pushed",
  pushed_to: "pushed to",
  qa: "qa",
  ram_dialog: "RAM",
  ram_resource_allocation_info:
    "The total amount of RAM (Memory) allocated to all the application, service and worker containers on this environment",
  ran_cron: "ran cron",
  ran_task: "ran task",
  receive_newsletter: "Receive newsletter",
  recent_projects: "recent projects",
  recovery_code: "Recovery code",
  redeploy: "Redeploy",
  "redeploy.button": "Redeploy",
  "redeploy.cli": "CLI",
  "redeploy.command": "{commandName} redeploy",
  "redeploy.modal.dialog":
    "You can also use this terminal command to redeploy your environment",
  "redeploy.modal.note":
    "Note: The redeploy will happen after any scheduled builds.",
  "redeploy.modal.text":
    "Redeploying an environment applies configuration changes, such as access rights and renewed SSL certificates, without pushing new code.",
  "redeploy.modal.title": "Redeploy environment",
  "redeploy.rejected.toaster.message":
    "The redeployment couldn’t start due to a backend error. Try again later.",
  redeployed_environment: "redeployed",
  redeploying_maintenance_environment: "redeploying",
  redirect_to: "Redirect to",
  redirects: "Redirects",
  "redirects.to": "Redirects:",
  refresh: "refresh",
  region: "Region",
  "region.certification.hipaa": "HIPAA",
  "region.certification.iso27001": "ISO 27001",
  "region.certification.pci": "PCI",
  "region.certification.soc2": "SOC 2",
  "region_picker.default_text": "Select region",
  "region_picker.search_region": "Search region",
  region_requirement:
    "we have selected this region based on your current location. Select another option below if you would like to change this before continuing.",
  register_meta_title: "Register on {app_name}",
  register_title:
    "<nowrap>One platform to build, run,</nowrap> and scale your websites & web apps",
  remember_this_browser: "Remember this browser for 1 month",
  remember_to_add: "remember to add:",
  remove: "Remove",
  "remove.n.instances": "Remove 1 instance",
  "remove.user": "Remove user",
  remove_connected_account: "Remove connected account",
  remove_from_team: "remove from team",
  remove_team: "Remove team",
  removed: "removed",
  renewal_environment_certificate: "renewed TLS certificates for",
  repeated_password: "Your new password cannot be the same as an old password",
  replicas: "replicas",
  report_tab: "Report",
  repository_url: "repository URL",
  request_admin_enable: "Ask your admin to enable.",
  requests_per_min: "requests per min",
  require: "require",
  required: "require",
  required_config: "required configuration",
  required_field: "This field is required",
  "requires_staff_verification.form.description":
    "Give us a short summary of who you are and what you aim to do with our product",
  "requires_staff_verification.form.subject": "User verification",
  "rescheduleActivity.modal.button.set_new_date": "Set new date",
  "rescheduleActivity.modal.date": "New date",
  "rescheduleActivity.modal.description":
    "Choose a new date to run your server update.",
  "rescheduleActivity.modal.select_time": "Select time",
  "rescheduleActivity.modal.time": "Time",
  "rescheduleActivity.modal.title": "Reschedule server update",
  "rescheduleActivity.success.description":
    "Your server update has been rescheduled.",
  "rescheduleActivity.success.title": "Server update rescheduled",
  resend: "Resend",
  resend_email: "resend email",
  reset_email_message:
    "<cd>{emailAddress}</cd> will be saved after you verify your new address.",
  reset_password: "Reset password",
  reset_password_description:
    "Enter the email address associated with your account and we’ll send an email with instructions to reset your password.",
  reset_password_title: "Reset your {app_name} password",
  "resource.lower.threshold": "CPU lower threshold",
  "resource.upper.threshold": "CPU upper threshold",
  resource_allocation_filter: "Resource Allocation",
  "resources.breakdown.cpu": "CPU",
  "resources.breakdown.cpu.guaranteed": "Guaranteed CPU",
  "resources.breakdown.cpu.shared": "Shared CPU",
  "resources.breakdown.disk": "Disk",
  "resources.breakdown.no_deployment":
    "Your allocated resources will appear here after the first successful deployment.",
  "resources.breakdown.object_storage": "Object storage",
  "resources.breakdown.ram": "RAM",
  "resources.breakdown.ram.tooltip":
    "Total RAM allocated to your environment. Always guaranteed.",
  "resources.breakdown.title": "Allocated resources",
  resources_allocation_text: "resource allocation",
  resources_not_found: "The resources could not be found",
  resources_on_text: "on",
  resources_updated_text: "updated",
  restored: "restored",
  restored_backup: "restored backup",
  restored_to_environment: "to environment",
  restricted: "Restricted",
  resume: "Resume",
  "resume.button": "Resume",
  "resume.cli": "CLI",
  "resume.command": "{commandName} environment:resume",
  "resume.modal.dialog":
    "You can also use this terminal command to resume your environment",
  "resume.modal.note": "Note: The redeploy will happen soon.",
  "resume.modal.text":
    "Your environment is paused, resume it to make it available again.",
  "resume.modal.title": "Resume environment",
  resumed_text: "resumed",
  return_form: "Return to form",
  return_login: "return to our log in",
  return_to_log_in: "Return to our log in",
  return_to_projects: "Return to projects",
  return_website: "Return to our website",
  routes: "routes",
  routes_yaml: "routes.yaml",
  run: "Run",
  run_command: "Run command",
  run_runtime_link_message: "Run runtime operation",
  run_source_link_message: "Run source operation",
  running_cron: "is running cron",
  running_task: "is running task",
  runtime: "Runtime",
  runtime_operation: "Runtime Operation",
  save: "Save",
  save_and_continue: "Save and continue",
  save_and_deploy: "Yes, save & deploy",
  save_changes: "save changes",
  save_continue: "save & continue",
  saving: "saving",
  "sca.authenticate": "Authenticate",
  "sca.description":
    "As of September 14, 2019, to comply with the <ComissionLink>Commission Delegated Regulation (EU) 2018/389</ComissionLink>, we require our users with European Credit Card payments to authenticate their orders with their payment institution. To authenticate your payments for the recurring order below simply click the “Authenticate” button below. <LearnMoreLink>Learn more</LearnMoreLink> about our compliance with the EU regulations.",
  "sca.order.cta": "View order details",
  "sca.order.title": "Order details",
  "sca.payment.cta": "Change payment method",
  "sca.payment.expiration": "Exp {month}/{year}",
  "sca.payment.title": "Payment details",
  "sca.sticker":
    "Please authenticate your credit card transaction to process this month’s payment. <link>Learn more</link>.",
  "sca.title": "Authenticate credit card transaction",
  "sca.toast.failed.cta": "Update payment",
  "sca.toast.failed.description":
    "Please contact your bank or enter a new card to ensure your payment gets processed.",
  "sca.toast.failed.title": "Authentication failed",
  "sca.toast.succeeded.description":
    "Your payment has been processed. Thank you!",
  "sca.toast.succeeded.title": "Payment was authenticated.",
  "sca.view_transaction": "View transaction",
  scale_any_time: "scale at any time",
  scale_description:
    "You can change plans at any time, add an unlimited number of development environments and more users.",
  scale_up_down: "Scale up and down at any time",
  "scaling.down": "Scaling down",
  "scaling.tooltip": "Threshold breached, scaling application",
  "scaling.up": "Scaling up",
  scheduled_maintenance: "scheduled maintenance",
  "screenshot.available": "Project preview",
  "screenshot.notAvailable": "Image not available",
  scroll_down: "Scroll to bottom",
  scroll_top: "Scroll to top",
  search_apps: "Search apps",
  search_by_team: "search by team name",
  search_engine_index: "Search engine index",
  search_templates: "Search all templates",
  secondary_text: "secondary_text",
  seconds_ago: "{time, plural, one {# second} other {# seconds}} ago",
  "security.authenticators.description":
    "You can enable MFA with these authenticators or one of your preference.",
  "security.authenticators.footer":
    "You can use any OTP compatible app to enable the MFA.",
  "security.authenticators.title": "Featured authenticators",
  "security.description":
    "Manage authentication methods and account recovery options for your account.",
  "security.header": "Authentication settings",
  "security.manage.description":
    "Multi-factor authentication (MFA) provides additional security for your account. With MFA enabled, you log in with a verification code in addition to your username and password.",
  "security.manage.disable": "Disable MFA",
  "security.manage.header": "Multi-factor authentication",
  "security.manage.modal.cancel": "Cancel",
  "security.manage.modal.confirm": "Yes, remove",
  "security.manage.modal.text":
    "Are you sure you wish to remove Multi Factor Authentication?",
  "security.manage.modal.title": "Remove MFA",
  "security.manage.setup": "Set up MFA",
  "security.recovery.description":
    "Pre-generated, one-time-use codes you can use to access your account if other authentication methods are unavailable.",
  "security.recovery.header": "Recovery codes",
  "security.recovery.reset": "Get new recovery codes",
  "security.setup.header": "Install authentication code application",
  "security.setup.heading": "MFA application setup ",
  "security.setup.help":
    "Enter this code into your two-factor authentication app or scan the QR code below.",
  "security.setup.qr_code": "QR Code",
  "security.setup.reset": "Cancel",
  "security.setup.submit": "Verify & Save",
  "security.setup.textcode": "Authenticator text code",
  "security.setup.verificationcode": "Verification Code",
  "security.setup.verificationcode.placeholder": "Enter code here",
  security_contact: "Security contact",
  "security_contact.placeholder": "Email Address",
  see_our_documentation: "See our documentation to learn more.",
  select: "Select",
  select_branch: "Select branch",
  select_company_type: "Select company type",
  select_connect:
    "select the service that you would like to connect to your account.",
  select_continue: "select & continue",
  select_country: "Select country",
  select_environment: "Select environment",
  "select_environment.pre_label": "Environment",
  select_operation: "Select operation",
  select_org_info_dialog:
    "Select an organization for managing your project’s billing and users’ permissions.<br></br><br></br>If you need to create a new organization go <a>here</a>.",
  select_organization: "Select organization",
  select_profession: "Select profession",
  select_project: "select the project to connect with",
  select_region: "select region",
  select_runtime: "Select a runtime",
  select_services: "Select service/s",
  senior_engineers: "senior engineers",
  sepa_disclaimer_shorter: "Authorize {appName} to debit your account.",
  sepa_disclamer:
    "By providing your IBAN and confirming this payment, you are authorizing [DEV] {appName} Accounts and Stripe (our payment service provider) to send instructions to your bank to debit your account and your bank to debit your account in accordance with those instructions. You are entited to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.",
  sepa_disclamer_short:
    "By choosing to pay via your bank account you authorize {appName} to debit your account.",
  september: "September",
  served_by: "served by",
  service: "service",
  service_built: "Services built-in, no add-ons required",
  service_not_supported: "Not yet supported",
  service_not_supported_description:
    "Application support is being added as quickly as possible. Check back later to see if your application is supported.",
  services: "services",
  "services.crons.activity": "Crons activity",
  "services.crons.frequency": "Frequency (UTC)",
  "services.crons.history": "History (UTC{offset})",
  "services.crons.none": "You do not currently have any crons to display.",
  "services.display.empty": "There are no connected apps or services yet.",
  "services.display.empty.description":
    "Add services through your <code>services.yaml</code> file in your <code>{appConfigFolder}</code>. {br} Learn more about adding a database, cache or search engine in our <a>documentation</a>.",
  "services.display.empty.title": "No services",
  "services.display.error":
    "Your services could not be displayed. Contact support if this problem persists.",
  "services.display.error.description":
    "Your services could not be displayed.<br></br><a>Contact support</a> if this problem persists.",
  "services.display.error.title": "No Services to display",
  "services.display.no_deployment.first":
    "Your apps and services will appear here after the first successful deployment.",
  "services.display.no_deployment.next":
    "Your apps and services will appear here after the next successful deployment.",
  "services.display.no_services":
    "This environment does not have any application or service.",
  "services.keys.composable": "Composable image",
  "services.keys.external": "External OCI image",
  "services.metrics.cpu": "CPU",
  "services.metrics.disk": "Disk",
  "services.metrics.error": "Metrics collection was not able to load",
  "services.metrics.gb": "GB",
  "services.metrics.ram": "RAM",
  "services.metrics.replica": "Replica",
  "services.metrics.replicas": "Replicas",
  "services.metrics.title": "Metrics",
  "services.metrics.worker": "Worker",
  "services.noconfiguration":
    "Console does not currently output the content of <code>{appConfigFile}</code> files if they are stored in subdirectories of the repository. To see your complete app configuration in Console, move the content of your <code>{appConfigFile}</code> files to <code>{appApplicationFilePath}</code>.",
  "services.process.colum.children": "Children",
  "services.process.colum.cpu": "% CPU",
  "services.process.colum.id": "ID",
  "services.process.colum.mem": "MEM",
  "services.process.colum.name": "Name",
  "services.process.colum.parent": "Parent",
  "services.process.colum.run": "Run time",
  "services.process.colum.run_tooltip": "Started {date}",
  "services.process.colum.start": "Start",
  "services.process.colum.stat": "STAT",
  "services.process.colum.user": "User",
  "services.process.filters.search": "Search",
  "services.process.options.advanced_signals": "Advanced signals",
  "services.process.options.copy": "Copy PID",
  "services.process.options.dialog.more_information":
    "For more information about advanced signals,",
  "services.process.options.dialog.title": "Select a common signal to run",
  "services.process.options.dialog.view_documentation":
    " view our documentation.",
  "services.process.options.force_kill": "Force Kill",
  "services.process.options.modal.continue": "Continue",
  "services.process.options.modal.description":
    "Are you sure you want to run {signalName} on process {process}? This action cannot be undone.",
  "services.process.options.modal.not_available": "Not available for {appName}",
  "services.process.options.modal.title": "Run {signalName}",
  "services.process.options.terminate_process": "Terminate process",
  "services.process.refresh.button": "Refresh",
  "services.process.refresh.total": "{count} Total",
  "services.process.title": "Processes",
  "services.relationships.none":
    "You do not currently have any relationships to display.",
  "services.relationships.title": "Relationships <b>({count})</b>",
  "services.workers.none": "You do not currently have any workers to display.",
  "services.workers.title": "Workers <b>({count})</b>",
  services_profiling_error: "We encountered an error",
  services_profiling_error_info_description:
    "We've encountered an error while attempting to retrieve information about this service. Please contact If this issue persists",
  services_profiling_error_info_title: "Application Service Loading Error",
  services_profiling_not_supported: "Services not supported",
  services_profiling_not_supported_description:
    "Services do not currently support profiling.",
  set_new_password: "Set new password",
  set_password: "Let’s get your account set up. Create your password to begin.",
  settings: "Settings",
  "settings.backupSchedules.backup.environment": "Environment type",
  "settings.backupSchedules.backup.frequency": "Frequency",
  "settings.backupSchedules.backup.total": "Total Backups",
  "settings.backupSchedules.description":
    "Configure your backup schedules for each environment type for this project.",
  "settings.backupSchedules.manage_link": "Manage",
  "settings.backupSchedules.more_info":
    "Learn more about Backup schedules in our",
  "settings.backupSchedules.title": "Backup schedules",
  "settings.backupSchedules.tooltip.description":
    "The total of all schedules plus the maximum manual backups possible for each environment of  this type.",
  "settings.backupSchedules.tooltip.title": "Total backups",
  "settings.buildResources.cpu.input.label": "CPU",
  "settings.buildResources.description":
    "Configure the resources for the build container. 2.5 CPU hours and 5 RAM hours are included with each project for free.",
  "settings.buildResources.note":
    "Note: Changing build container sizes will impact your monthly project cost. <link>View pricing</link>",
  "settings.buildResources.ram.input.MB": "MB",
  "settings.buildResources.ram.input.label": "RAM",
  "settings.buildResources.title": "Build resources",
  "settings.certificates.modal.body": "Yes, delete the certificate",
  "settings.certificates.modal.delete": " for the domains",
  "settings.deployKey.help.a": "Learn more about Deploy Keys in our",
  "settings.deployKey.help.b": "documentation",
  "settings.details": "Details",
  "settings.details.informations":
    "Your organization's path is a unique identifier that you can change anytime. Once a path is taken, it can't be reused.",
  "settings.documenttitle": "Account",
  "settings.domains.add.body":
    "By default, your environment has a <i>.platformsh.site</i> URL. If you want to change the web address, you need to add a custom domain, such as <i>example.com.</i>.",
  "settings.domains.add.button": "Add domain",
  "settings.domains.add.domain.learn_more":
    "https://docs.upsun.com/anchors/fixed/domains/custom/preview-environments/",
  "settings.domains.add.new.title": "Add domain",
  "settings.domains.add.staging.body":
    "By default, your environment has a <i>.platformsh.site</i> URL. If you want to change the web address, you need to add a custom domain, such as <i>staging.example.com.</i>",
  "settings.domains.add.title": "Add a default domain",
  "settings.domains.button.add_production_domain": "Add production domain",
  "settings.domains.button.dedicated": "Submit support ticket",
  "settings.domains.cname": "CNAME record",
  "settings.domains.cname.description":
    "Before adding a domain, copy the target below and add it to your DNS provider as a CNAME record.",
  "settings.domains.cname.target": "CNAME target",
  "settings.domains.config.line_1":
    "Add the CNAME record below to your DNS provider. Check out <a>how-to set the CNAME record for your DNS provider</a>.",
  "settings.domains.config.line_2":
    "If you want to use the same domain in several projects, point a <a>TXT record</a> to the platformsh.site URL below.",
  "settings.domains.config.title": "Configure your domain",
  "settings.domains.configuration.description":
    "Before adding a domain, copy the target below and add it to your DNS provider as a CNAME record. <link>Learn more</link>",
  "settings.domains.contact_support":
    "If you are an Enterprise or Elite customer, please <link>contact support</link> to enable custom domains.",
  "settings.domains.custom.add.new.title": "Add custom domain",
  "settings.domains.date": "Created at",
  "settings.domains.default": "Default",
  "settings.domains.delete": "delete domain",
  "settings.domains.delete.domain":
    "Are you sure you want to delete the domain {domainName}?",
  "settings.domains.empty.upgrade.body":
    "Upgrade to Enterprise to unlock custom domains on preview environments.",
  "settings.domains.empty.upgrade.title": "Upgrade for custom domains",
  "settings.domains.info":
    "You can only add custom domains to your production environment from this page. To add a custom domain to a preview environment, go to your environment settings.",
  "settings.domains.info.enter.domain": "Enter the domain or sub-domain.",
  "settings.domains.learn_more":
    "Learn more about Domains in our <link>documentation</link>",
  "settings.domains.learn_more.add_domain":
    "Learn more about domains in our <link>how-to-guide</link>.",
  "settings.domains.make_default": "Make default domain",
  "settings.domains.modal.delete.body":
    "Are you sure you want to delete the domain <b>{domain}</b>? Please note that this will redeploy your environment.",
  "settings.domains.modal.delete.body.attached_domains":
    "You must delete those attached preview environment domain before you can delete  <b>{domain}</b>",
  "settings.domains.modal.delete.body.custom_domains":
    "If this domain has preview environment domains attached to it, they will also be deleted. Preview environments will not be automatically redeployed. Consider redeploying these environments so that routes are updated correctly.",
  "settings.domains.modal.delete.body.default.select":
    "Are you sure you want to delete the default domain <b>{domain}</b>? Please note, a new default domain is selected in the field below.",
  "settings.domains.modal.delete.body.default.switch":
    "Are you sure you want to delete the default domain <b>{domain}</b>? Please note, <b>{otherDomain}</b> will be a new default domain for your project.",
  "settings.domains.modal.delete.confirm": "Yes, delete",
  "settings.domains.modal.delete.select": "Default domain",
  "settings.domains.modal.delete.subtitle.attached_domains":
    "Your domain <b>{domain}</b> is attached to preview environment domain: ",
  "settings.domains.modal.delete.title": "Delete domain",
  "settings.domains.name": "Domain",
  "settings.domains.placeholder": "yourdomain.com",
  "settings.domains.prompt_support":
    "To add a custom domain please open a support ticket.",
  "settings.domains.prompt_upgrade":
    "Ask the organization owner to upgrade the plan to add a custom domain.",
  "settings.domains.prompt_upgrade.plan_owner":
    "Upgrade to a production plan to add a custom domain.",
  "settings.domains.save.button": "Add domain",
  "settings.domains.sticker.hidden_from_search_engines":
    "Your site is currently hidden from search engines. To make it publicly indexable, clear the Hide from search engines checkbox.<button>Update</button>",
  "settings.domains.sticker.is_dg2":
    "Custom domain feature is not supported for Dedicated Gen 2 project. To add a custom domain to a dedicated environment, please <link>contact support</link>.",
  "settings.domains.sticker.no_capability":
    "An unexpected error has occurred, please open a Support Ticket",
  "settings.domains.sticker.no_permissions":
    "Ask your project admin to add a custom domain.",
  "settings.domains.sticker.no_permissions_prod_domain":
    "Ask your project admin to add a domain.",
  "settings.domains.sticker.no_production_domain":
    "You need to add a production domain first before adding a preview environment domain.",
  "settings.domains.sticker.no_production_plan":
    "Upgrade to a production plan to add a custom domain.",
  "settings.domains.title": "Domains",
  "settings.domains.traffic":
    "Traffic from additional domains will be redirected to this default domain.{br}Do not add www. if your routes.yaml file already specifies it.{br}If you have multiple subdomains defined in your routes.yaml file, just enter the part you want to map to '{default}'.",
  "settings.domains.upgrade_plan": "Upgrade plan",
  "settings.environment.variable.notification.create.manual.success.description":
    "Your environment variable was added. The change will be applied when you deploy your environment.",
  "settings.environment.variable.notification.create.manual.success.title":
    "Variable saved",
  "settings.environment.variable.notification.create.success.description":
    "Your environment variable has been added, and your environment is now redeploying to apply the change.",
  "settings.environment.variable.notification.delete.manual.success.description":
    "Your environment variable was deleted. The change will be applied when you manually deploy your environment.",
  "settings.environment.variable.notification.delete.manual.success.title":
    "Variable deleted",
  "settings.environment.variable.notification.delete.success.description":
    "Your environment variable has been deleted.",
  "settings.environment.variable.notification.update.manual.success.description":
    "Your environment variable was updated. The change will be applied when you redeploy your environment.",
  "settings.environment.variable.notification.update.success.description":
    "Your environment variable has been updated, and your environment is now redeploying to apply the change.",
  "settings.environment.variables.all_apps": "All apps",
  "settings.environment.variables.back_to": "Back to environment variables",
  "settings.environment.variables.create": "Create environment variable",
  "settings.environment.variables.description":
    "Environment variables are available for this environment and its children if made inheritable. Child environments must be redeployed for the variable to be available.",
  "settings.environment.variables.list.empty":
    "No {type} variables to display, <link>add a variable</link> to get started",
  "settings.environment.variables.list.environment":
    "{title} variables {count}",
  "settings.environment.variables.list.project": "Project variables {count}",
  "settings.environment.variables.warning":
    "Changes to parent variables are applied to all child environments unless overridden. This will automatically trigger a redeploy to apply your changes.",
  "settings.environment.variables.warning.child":
    "Editing a variable will override it on this environment and its future children.",
  "settings.environment.variables.warning.manual":
    "Changes to parent variables are applied to all child environments unless overridden. You must manually deploy your environment to apply the changes.",
  "settings.menu.access": "Access",
  "settings.menu.backup_schedules": "Backup schedules",
  "settings.menu.certificates": "Certificates",
  "settings.menu.deploy_key": "Deploy Key",
  "settings.menu.domains": "Domains",
  "settings.menu.environment_settings": "Environments",
  "settings.menu.general": "General",
  "settings.menu.integrations": "Integrations",
  "settings.menu.maintenance_window": "Maintenance window",
  "settings.menu.project_settings": "Project settings",
  "settings.menu.resources": "Resources",
  "settings.menu.variables": "Variables",
  "settings.organization_settings": "Organization settings",
  "settings.organization_settings.description":
    "Your organization is now the owner of your projects and is used for billing, support and user management.  Your new streamlined user management interface allows you to invite and edit permissions all from the one place.",
  "settings.plan.banner.button": "Add billing details",
  "settings.plan.banner.trial":
    "To upgrade your plan you need to add a payment method to your billing details.",
  "settings.plan.manage_project_plan": "Manage project plan",
  "settings.plan.project.default.domain":
    "You must remove the default domain before deleting this project.",
  "settings.plan.project.delete.admin_only":
    "Only project administrators can delete this project.",
  "settings.plan.project.delete.button": "Delete project",
  "settings.plan.project.delete.confirm":
    "Are you sure you want to delete your project <strong>{projectTitle}</strong>?{br} Please review the details of your project before deleting and type your project name to confirm this action.",
  "settings.plan.project.delete.warning":
    "Please note: Deleting your project is permanent. All data associated with it, including backups, will be removed. You will still be billed at the end of the month for any remaining project costs.",
  "settings.plan.project.modal.title": "Delete project",
  "settings.plan.project.view.domains": "View domains",
  "settings.project.variable.notification.create.success.description":
    "Your project variable has been added, please redeploy your environments to apply it to them.",
  "settings.project.variable.notification.delete.success.description":
    "Your project variable has been deleted.",
  "settings.project.variable.notification.update.success.description":
    "Your project variable has been updated, please redeploy your environments to apply it to them.",
  "settings.project.variables.back_to": "Back to Project variables",
  "settings.project.variables.create": "Create project variable",
  "settings.project.variables.description":
    "Project variables are available for all environments of the project. For the changes to take effect, the environments need to be redeployed.",
  "settings.project.variables.list.empty":
    "No project variables to display, <link>add a variable</link> to get started",
  "settings.project.variables.note":
    "Learn more about variables in our <link>documentation</link>.",
  "settings.project.variables.note.manual_deployment":
    "<link>Enable manual deployments</link> to batch your changes and deploy when you’re ready, avoiding a separate deployment for each variable.",
  "settings.project.variables.sort.app": "App",
  "settings.project.variables.sort.name": "Variable",
  "settings.project.variables.sort.type": "Type",
  "settings.project.variables.sort.value": "Value",
  "settings.resources.title": "Resources",
  "settings.variable.notification.create.rejected.title":
    "An error occurred, variable not saved",
  "settings.variable.notification.create.success.title": "Variable saved",
  "settings.variable.notification.delete.success.title": "Variable deleted",
  "settings.variables.add.button": "Create variable",
  "settings.variables.add.title": "Add variable",
  "settings.variables.description":
    "Project variables are available for all project environments and during the build process.",
  "settings.variables.details":
    "Variables beginning with <code>env:</code> will be exposed as Unix environment variables{br} Variables beginning with <code>php:</code> will be interpreted as <code>php.ini</code> directives.{br} All other variables will be part of the environment <code>{appEnvironmentVariableName}</code> variable",
  "settings.variables.disabled": "Disabled",
  "settings.variables.during_build":
    "<b>Available during buildtime:</b> Make this variable available during the build hook step of your <code>{appConfigFile}</code>",
  "settings.variables.during_build.more":
    "Build time variables change the result of your build. Use them when your framework or application requires variable changes between environments.",
  "settings.variables.during_run":
    "<b>Available during runtime:</b> Make this variable available during the runtime of this project",
  "settings.variables.during_run.more":
    "Runtime variables are available to your application while it's running and/or deploying.",
  "settings.variables.edit_name":
    "Variable names can not be edited once created. To adjust one, you’ll need to create another and delete the one you’re replacing",
  "settings.variables.empty":
    "No variables to display, add a variable to get started",
  "settings.variables.enabled": "Enabled",
  "settings.variables.inactive": "Inactive",
  "settings.variables.inactive.details":
    "An environment variable is overriding this variable",
  "settings.variables.inheritable":
    "<b>Make inheritable:</b> Make child environments inherit this variable",
  "settings.variables.inheritable.more":
    "When enabled all child environments of this environment will inherit this variable",
  "settings.variables.inherited": "Inherited",
  "settings.variables.inherited.details": "Inherited from a parent environment",
  "settings.variables.inherited_from": "Inherited from: {from}",
  "settings.variables.is_json":
    "<b>JSON value:</b> Interpret as a JSON-serialized value instead of a simple string",
  "settings.variables.is_json.more":
    "To learn more about the JSON variable setting read our documentation.",
  "settings.variables.labels.inherited": "Inherited",
  "settings.variables.labels.is_inheritable": "Inheritable",
  "settings.variables.labels.is_json": "Json",
  "settings.variables.labels.is_sensitive": "Sensitive",
  "settings.variables.labels.visible_build": "Build",
  "settings.variables.labels.visible_runtime": "Runtime",
  "settings.variables.manual_deployment_info.description":
    "Changes to code, variables, domains, and settings are queued until you manually trigger a deployment.{br}Applies to production and staging environments.",
  "settings.variables.manual_deployment_info.title": "Manual deployments",
  "settings.variables.modal.body": "Yes, delete the variable ",
  "settings.variables.modal.title": "Are you sure you want to delete this?",
  "settings.variables.name": "Variable name",
  "settings.variables.note":
    "<dt>Note</dt><dd>Variables beginning with <code>env:</code> will be exposed as Unix environment variables.</dd><dd>Variables beginning with <code>php:</code> will be interpreted as <code>php.ini</code> directives.</dd><dd>All other variables will be part of <code>$PLATFORM_VARIABLES</code> variable.</dd>",
  "settings.variables.notes.detail_adding":
    "Adding or updating an environment level variable will trigger a redeploy.",
  "settings.variables.notes.detail_beginning":
    "Variables beginning with <code>env:</code> will be exposed as Unix environment variables.",
  "settings.variables.notes.detail_different":
    "Variables with a different prefix and unprefixed variables will be part of the {appEnvironmentVariableName} environment variable. <link>Learn more</link>.",
  "settings.variables.notes.title": "Note:",
  "settings.variables.override": "Save and override",
  "settings.variables.overriding": "Overriding",
  "settings.variables.overriding.details.environment":
    "Overriding the parent environment's variable",
  "settings.variables.overriding.details.project":
    "Overriding the project-level variable",
  "settings.variables.overriding_from.environment": "Overriding: {from}",
  "settings.variables.overriding_from.project": "Overriding: project variable",
  "settings.variables.restricted.bulk.selectedApps":
    "{count} {count, plural, one{app} other{apps}} selected",
  "settings.variables.restricted.environment":
    "<b>Restricted to app:</b> Define the variable at application level",
  "settings.variables.restricted.environment.more":
    "By default, variables are available to all the applications deployed on your project. Use this option to restrict this environment variable to specific application(s).",
  "settings.variables.restricted.environment.note.description":
    "By selecting app, you define the variable at application level, when you make changes, it will only trigger a redeployment of that app.",
  "settings.variables.restricted.environment.note.title": "Note:",
  "settings.variables.restricted.project":
    "<b>Restricted to app:</b> Make this variable only available to specific application(s)",
  "settings.variables.restricted.project.more":
    "By default, variables are available to all the applications deployed on your project. Use this option to restrict this variable to specific application(s).",
  "settings.variables.restricted.select.environment.label": "Apps",
  "settings.variables.restricted.select.placeholder":
    "Type to search or select app",
  "settings.variables.restricted.select.project.label":
    "Restrict to specific apps",
  "settings.variables.sensitive":
    "<b>Sensitive variable:</b> Do not display this variable in the user interface",
  "settings.variables.sensitive.more":
    "Sensitive variables are not displayed in the console interface but are still readable from within the application.",
  "settings.variables.value_error":
    "The format of your variable is not valid JSON.",
  "settings.variables.variables": "Variables",
  "settings.variables.warning":
    "When you edit a project variable your changes are applied to every environment.",
  "setup.breadcrumb.steps.building": "Build",
  "setup.breadcrumb.steps.configure": "Configure",
  "setup.breadcrumb.steps.info": "Details",
  "setup.breadcrumb.steps.template": "Template",
  "setup.breadcrumb.steps.type": "Type",
  "setup.building.description":
    "We won’t be long, but if you like you can close this window at any time to continue working.",
  "setup.building.errors":
    "We're sorry, but the following {count, plural, one {error} other {errors}} occurred while attempting to create your project. Please <link>contact support</link>.",
  "setup.building.provisioning_error":
    "There was an issue creating your project",
  "setup.building.title": "Your new project is building!",
  "setup.cli.install.unix.code": "brew install upsun/tap/platformsh-cli",
  "setup.cli.install.unix.label": "OSX or Linux Installer",
  "setup.cli.install.windows.code":
    "scoop bucket add upsun https://github.com/upsun/homebrew-tap.git && scoop install platform",
  "setup.cli.install.windows.label": "Windows Installer",
  "setup.details.footer_note":
    "After the trial, if you subscribe to Upsun, your project will be billed by hourly prorated usage each month.",
  "setup.info.title": "Your project details",
  "setup.overview.free_trial.card.description":
    "Your free trial will automatically end in 14 days or as soon as usage reaches $100, whichever event occurs first.",
  "setup.overview.free_trial.card.subtitle":
    "14 days with $100 to spend across your organization",
  "setup.overview.free_trial.card.title": "You’re starting on our Free trial",
  "setup.overview.free_trial.footer.link":
    "To learn more about our pricing visit our <link>pricing page</link>.",
  "setup.overview.free_trial.footer.note":
    "Note: Any modifications to your account may impact your monthly charges, which are calculated on an hourly, prorated basis throughout the month.",
  "setup.overview.free_trial.note":
    "Your new project will be created with the minimum resources required to run your selected apps and services effectively.",
  "setup.overview.free_trial.title": "Project overview",
  "setup.overview.paying.estimation.application": "Application 1 CPU, 1GB Ram",
  "setup.overview.paying.estimation.application.value": "$35 USD",
  "setup.overview.paying.estimation.fee": "Project fee",
  "setup.overview.paying.estimation.fee.value": "$9 USD",
  "setup.overview.paying.estimation.sercvice": "Service 1 CPU, 1GB Ram",
  "setup.overview.paying.estimation.sercvice.value": "$52 USD",
  "setup.overview.paying.estimation.storage": "Storage 1GB",
  "setup.overview.paying.estimation.storage.value": "$366 USD",
  "setup.overview.paying.estimation.subtitle":
    "Based on monthly usage of 732 hours",
  "setup.overview.paying.estimation.title": "Estimated monthly project cost",
  "setup.overview.paying.estimation.total": "Total monthly estimate",
  "setup.overview.paying.estimation.total.value": "$811 USD",
  "setup.overview.paying.estimation.user": "User",
  "setup.overview.paying.estimation.user.value": "$19 USD",
  "setup.overview.paying.footer.link":
    "To learn more about our pricing, see our <link>pricing page</link>.",
  "setup.overview.paying.footer.note":
    "Note: These costs are estimates only and based on what you choose to use each month.<br></br>Any modifications to your account may impact your monthly charges, which are calculated on an hourly, prorated basis throughout the month.",
  "setup.overview.paying.note":
    "Your new project will be created with the minimum resources required to run your selected apps and services effectively. ",
  "setup.sticker.deploy": "Congrats! Your first project has been created",
  "setup.sticker.details":
    "Almost there! Name your free trial project and select a region ({daysRemaining} days remaining).",
  "setup.template.title": "Select your template",
  "setup.type.description":
    "Use your own code, migrate a project or use a project template to get started.",
  "setup.type.empty.description":
    "Bring your own code or migrate an existing project to {appName}",
  "setup.type.empty.title": "Create from scratch",
  "setup.type.template.description":
    "Choose from one of our pre-existing code base templates to start your project.",
  "setup.type.template.details": "Details",
  "setup.type.template.title": "Use a template",
  "setup.type.title": "Select project type",
  "setup.type.trial.title":
    "Create your first project to start your free trial",
  "setup.verify.description":
    "To help fight abuse, please provide a valid credit card.",
  "setup.verify.select_country": "Select country",
  "setup.verify.sticker":
    "You won’t be charged unless you choose to upgrade to {app_name} at the end of your trial.",
  "setup.verify.title": "Verify your identity",
  setup_fastly_origin_restriction: "setup fastly origin restriction",
  show: "Show",
  show_all: "Show all",
  show_all_instances: "show all",
  show_all_instances_info:
    "...(showing {shown_instances} of {all_instances_number} instances)",
  show_deployments: "Show deployments",
  showing: "showing",
  sign_in: "Sign in",
  sign_up: "Sign up",
  sign_up_linked_account: "sign up with an account",
  signin_tac: "by signing in you agree to our",
  signin_with_linked_account: "Sign in with your account",
  signup_link_expired: "Sorry but it looks like your link has expired.",
  signup_tac: "By signing up you agree to the",
  signup_try: "Sign up to try {app_name} for free",
  "simplemenu.default": "Project Title",
  "simplemenu.live_message":
    "project menu updated to show results that contain {searchTitle}. {listCount} results found.",
  "simplemenu.no-result": "No results.",
  "simplemenu.placeholder": "Search projects",
  size: "Size",
  skip: "Skip",
  "sla.support": "support",
  small_description: "single & light-resource app",
  snapshot: "Snapshot",
  something_went_wrong: "Something went wrong...",
  sorry_link_expired: "Sorry but it looks like your link has expired.",
  source_code: "source code",
  source_operation: "Source Operation",
  source_operation_executed: "executed source operation",
  source_operation_on_env: "on environment",
  "source_ops.configure.learnmore":
    "Learn how to configure yours in our <link>documentation.</link>",
  "source_ops.configure.message":
    "You’ve not yet configured your environment to run a Source operation.",
  "source_ops.configure.pro.learnmore": "Learn more in our ",
  "source_ops.configure.pro.upgrade":
    "If you want to run source operations instead, you must upgrade to our Enterprise tier. Contact our <linkSalesTeam>sales team</linkSalesTeam> or check our <linkPricingPage>Pricing page</linkPricingPage>",
  "source_ops.configure.title": "Configure your source operation",
  "source_ops.configure_env.learnmore":
    "Learn how to configure your environment to run Source Operations in our <link>documentation </link>.",
  "source_ops.define_variables_info":
    "Define the variables used by your operation, or override an existing environment variable. The variables will be automatically prefixed with ('env:').",
  "source_ops.run": "Run source operation{operation}",
  "source_ops.runnable":
    "You can run the source operation {operation} on this environment.",
  "source_ops.runtime.configure.message":
    "You’ve not yet configured your environment to run a Runtime operation.",
  "source_ops.runtime.configure.title": "Configure your runtime operation",
  "source_ops.runtime.configure_env.learnmore":
    "Learn how to configure your environment to run Runtime Operations in our <link>documentation </link>.",
  "source_ops.runtime.run": "Run runtime operation{operation}",
  "source_ops.runtime.runnable":
    "The runtime operation {operation} will be run in the environment {environment}.",
  "source_ops.runtime.select_operation_many":
    "Select a runtime operation to run in the environment {environment}.",
  "source_ops.runtime.worker":
    "Choose an application or worker to run this operation during runtime.",
  "source_ops.select_operation_many":
    "Select a source operation to run in the environment {environment}.",
  "source_ops.upgrade.message":
    "If you want to run source operations, you must upgrade to our Enterprise tier.{br}Contact our sales team or check our Pricing page.",
  "source_ops.upgrade.runtime.message":
    "If you want to run runtime operations, you must upgrade to our Enterprise tier.{br}Contact our sales team or check our Pricing page.",
  "source_ops.upgrade.runtime.title": "Upgrade to run your runtime operations",
  "source_ops.upgrade.title": "Upgrade to run your source operations",
  "source_ops.variable.name": "Variable name",
  "source_ops.variable.name.placeholder": "Variable Name",
  "source_ops.variable.value": "Value",
  "source_ops.variable.value.placeholder": "Enter Value",
  source_repository_tooltip:
    "Merge is disabled as this project uses external version control. Please merge directly in your source repository and wait for the sync.",
  ssh: "SSH",
  "ssh.add.info.description":
    "Add your SSH Keys to your account below to use Git and command shells with any {appName} environment that your user account is authorized to work with.",
  "ssh.add.info.learnmore": "Learn more",
  "ssh.add.info.learnmore.description":
    "Learn more about configuring your SSH Keys",
  "ssh.confirm.body":
    "Are you sure you want to delete the SSH Key for {key}? This action can not be undone.",
  "ssh.confirm.title": "Delete SSH Key",
  "ssh.confirm.yes": "Yes, delete",
  "ssh.disabled": "You need to be a contributor or admin to access SSH",
  "ssh.duplicatedkey.message":
    "The SSH Key you tried adding, below, is a duplicate of an existing one. You can not have duplicate keys connected to your account.",
  "ssh.duplicatedkey.title": "SSH Key can not be duplicated",
  "ssh.key.inactive": "Inactive",
  "ssh.view.title": "Title",
  ssh_access: "SSH access",
  ssh_deploy_key: "SSH Deploy Key",
  ssh_documentation: "Documentation",
  ssh_key_autofilled: "Your existing SSH Key has been autofilled.",
  ssh_keys: "SSH keys",
  "sshkey.form_error_duplicate":
    "A public key with this fingerprint is already in use.",
  "sshkey.form_input_key": "Key",
  "sshkey.form_input_title": "Title",
  ssi: "Server Side Includes",
  ssi_acronym: "ssi",
  ssi_description: "Leverage caching and serve dynamic content.",
  ssl_chain: "Intermediate SSL certificates",
  staged_to: "staged to",
  start_free_trial: "Start a free trial",
  start_trial: "Start your 14-day free trial",
  start_trial2: "The fastest way to build digital products",
  state: "State",
  state_province_region: "State / Province / Region",
  "state_province_region.placeholder": "State",
  status: "status",
  "status.dialog.edit":
    "To edit the status of this environment, review your general settings.",
  status_activate_description:
    "While the Git branch is available, activating will sync data from the parent environment and redeploy.",
  "status_active.description":
    "This environment is deployed like normal on each Git push.",
  "status_active.title": "Status is <b>Active</b>",
  "status_active_delete.description":
    "You must deactivate your environment before you can delete the branch.",
  "status_active_delete.title": "Delete environment",
  status_active_delete_bullet_1:
    "This environment will be in an inactive state, will not be deployed, and access through web URLs or SSH will not work.",
  status_active_delete_bullet_2:
    "You can activate this environment at a later time if the Git branch is still available.",
  status_active_delete_bullet_3:
    " Reactivating will sync data from the parent environment and redeploy.",
  status_active_delete_bullets_title: "Please note:",
  status_active_delete_description:
    "This environment is inactive, and a Git branch is still associated to it. You can delete it from your project here or via the CLI.",
  "status_active_delete_description.integration":
    "We see that you’re connected to {integration}. To delete this environment, run the following command within your CLI:",
  status_active_delete_verify:
    "I understand that all data will be permanently deleted and that web URLs and SSH access will no longer work for this environment.",
  status_active_delete_warning:
    "De-activating your environment will destroy all data and services running on this environment, leaving only the code in the Git branch and environment variables.",
  status_active_description:
    "Each git push to this environment triggers a new deployment.",
  "status_building.title": "Environment is <b>Building</b>",
  "status_deactivating.title": "Environment is <b>Deactivating</b>",
  "status_inactive.title": "Status is <b>Inactive</b>",
  status_inactive_description:
    "This environment is not deployed on each Git push. It has no data of its own and no running services. <link>Learn more</link>",
  "status_reactivating.title": "Environment is <b>Reactivating</b>",
  step_x_of_n: "Step {currentStep} of {totalStep}",
  storage: "storage",
  storage_description: "{price} a month per 5GB x environments",
  storage_per_environment: "5 GB of storage per environment",
  strict_transport_security: "strict_transport_security",
  stripe_sepa_debit: "Bank account",
  submit: "Submit",
  "submit_an_idea.message":
    "What’s your idea? What problem are you trying to solve?",
  "submit_an_idea.subject": "I have a feature idea",
  "subscribe.billingDetails.estimatedInvoice": "Estimated invoice",
  "subscribe.billingDetails.subscribe": "Subscribe",
  "subscribe.billingDetails.thanks.description":
    "You’ll be redirected to your projects page shortly - <a>click here</a> if that doesn’t work.",
  "subscribe.billingDetails.thanks.title": "Thanks for subscribing!",
  "subscribe.billingDetails.title": "Billing details",
  "subscribe.billingDetails.upcomingInvoice": "Upcoming invoice",
  "subscribe.review.addBillingDetails": "Add billing details",
  "subscribe.review.cancel": "Cancel",
  "subscribe.review.descriptionActive":
    "Please upgrade your account to keep using {app_name}, including on-demand preview environments and resource auto-scaling. Manage your billing anytime in your Billing settings. Charges are estimated based on usage.",
  "subscribe.review.descriptionExpired":
    "Please upgrade your account to keep using {app_name}, including on-demand preview environments and resource auto-scaling. Manage your billing anytime in your Billing settings. Charges are estimated based on usage.",
  "subscribe.review.free": "Free",
  "subscribe.review.integrations": "Integrations",
  "subscribe.review.integrations.log_forwarding":
    "Logs forwarding: Outbound payload",
  "subscribe.review.integrations.remove": "Remove",
  "subscribe.review.monthly": "/month ²",
  "subscribe.review.monthlyEstimate": "Monthly total estimate²",
  "subscribe.review.organization": "Organization",
  "subscribe.review.organization_addons": "Organization add-ons",
  "subscribe.review.organization_addons.remove": "Remove",
  "subscribe.review.organization_addons.user_management": "User management",
  "subscribe.review.projects": "Project",
  "subscribe.review.quantity": "Quantity",
  "subscribe.review.support": "Standard Support",
  "subscribe.review.terms.note_1":
    "Note ¹ : The discount provided is based on prorated periods with existing active projects and excludes VAT. If the discount applied to your total bill exceeds the amount of your bill, you won’t be entitled to receive the difference in cash or credit. If you abuse this offer in any way, it will be rescinded immediately. By participating in this offer, you agree to be bound by the current terms and conditions as well as any future amendments. Upsun reserves the right to change or amend the terms of this offer at any time without prior notice. All changes will be effective immediately upon posting on our website or through direct communication.",
  "subscribe.review.terms.note_2":
    "Note ² : These costs are estimates only and are based on the services currently activated on your account and do not include taxes. Any modifications to your account may impact your monthly charges. You can view and manage your project billing in your Organization billing page. Learn more by visiting our <link>pricing page</link>.",
  "subscribe.review.title": "Remove trial limits",
  "subscribe.review.unitPrice": "Unit price",
  "subscribe.review.userLicenses": "User licenses",
  "subscribe.review.userLicenses.manage": "Manage",
  "subscribe.review.userViewers": "Viewers",
  "subscribe.review.users": "Users",
  "subscribe.review.usersWithCount":
    "{count} {count, plural, one{user} other{users}}",
  "subscribe.stepper.billingDetails": "Billing details",
  "subscribe.stepper.review": "Review",
  "subscription.button.delete": "Yes, Delete Project",
  "subscription.delete.caution":
    "Please note that deleting your project is irreversible and all data associated with this project will be deleted, including backups. Furthermore, at the end of the month you will be charged for any remaining project costs.",
  "subscription.input.delete.confirm-name-label": "Enter project name",
  subtotal: "Subtotal",
  success: "Success",
  super_user: "super user",
  support: "Support",
  "support.sla.elite.text":
    "Normal SLA : 8 hours, 24/7{br}High SLA : 4 hours, 24/7{br}Urgent SLA : 45 minutes, 24/7",
  "support.sla.enterprise.text":
    "Normal SLA : 24 regular support hours{br}High SLA : 8 regular support hours{br}Urgent SLA : 1 hour, 24/7",
  "support.sla.premier.text":
    "Normal SLA : 72 hours{br}High SLA : 48 hours{br}Urgent SLA : 4 hours",
  "support.sla.professional.text":
    "Professional support does not include an SLA",
  support_php: "Support for PHP, Java, Node.js, Python and more",
  support_sla_explanation:
    "Contact our sales team to get access to better SLA support. Those support tiers are available to Elite and Enterprise organizations.",
  support_sla_link_text_contact: "Contact sales",
  support_sla_link_text_learn: "Learn more",
  support_sla_plan: "{plan} support",
  support_ticket: "support ticket",
  suspended: "Suspended",
  sync: "Sync",
  "sync.button": "sync",
  "sync.cli": "CLI",
  "sync.cli.sizing_api_enabled": "CLI command",
  "sync.code": "Git merge {parentEnvironment} to {currentEnvironment}",
  "sync.data":
    "Replace the data (e.g. databases, uploaded files) of {currentEnvironment} with that from {parentEnvironment}",
  "sync.data.dialog":
    "Replacing data will also sync the disk size if {currentEnvironment} has a lower disk size. This will ensure enough disk to complete the sync.",
  "sync.data.sizing_api_enabled": "Replace data (databases, uploaded files)",
  "sync.description":
    "What would you like to sync from your {parentEnvironment} environment to your {currentEnvironment} environment?",
  "sync.dialog.cli.description":
    "You can also use this terminal command to sync from {parentEnvironment} to {currentEnvironment}",
  "sync.dialog.cli.requirement": "To sync an env need to have a parent",
  "sync.replace_data": "Replace data",
  "sync.resources":
    "Sync resources from {parentEnvironment} into {currentEnvironment}",
  "sync.resources.dialog":
    "You can additionally sync the CPU and RAM from this environment. The disk size is synced by default to ensure that the sync is successful.",
  "sync.select": "Please make a selection",
  "sync.sync_resources": "Sync resources",
  "sync.title": "Sync from {parentEnvironment} to {currentEnvironment}",
  sync_child_from_parent: "sync {child} from {parent}",
  synced: "synced",
  syncing: "syncing",
  system: "System",
  system_status: "system status",
  "system_status.activities": "Current activity",
  "system_status.anchor": "View status",
  "system_status.link": "Visit status page",
  "system_status.title": "System status",
  tab_connect: "connect",
  tab_connect_sub: "to hosted repository",
  tab_push: "Create blank project",
  tab_push_sub: "Push from local repository",
  tab_template: "select a template",
  tab_template_sub: "from our collection",
  "tabs.access": "access",
  "tabs.access_control": "access control",
  "tabs.accounts": "Connected accounts",
  "tabs.activities": "activities",
  "tabs.activity": "activity",
  "tabs.all_activity": "activity",
  "tabs.backups": "backups",
  "tabs.backups_history": "History",
  "tabs.backups_stored": "Stored",
  "tabs.basics": "General",
  "tabs.billing": "billing",
  "tabs.billing_address": "billing address",
  "tabs.billing_history": "history",
  "tabs.carbon_emissions": "Emissions",
  "tabs.certificates": "certificates",
  "tabs.commitment": "Commitment",
  "tabs.configuration": "YAML",
  "tabs.connected_accounts": "Connected accounts",
  "tabs.containers": "Containers",
  "tabs.credit_card": "credit card",
  "tabs.crons": "Crons",
  "tabs.dashboard": "dashboard",
  "tabs.deploy_key": "deploy key",
  "tabs.details": "Billing Details",
  "tabs.domains": "domains",
  "tabs.edit_plan": "Edit plan",
  "tabs.environment_types": "environment types",
  "tabs.general": "General",
  "tabs.history": "Invoices",
  "tabs.http_traffic": "HTTP Traffic",
  "tabs.integrations": "integrations",
  "tabs.invitations": "invitations",
  "tabs.logs": "Logs",
  "tabs.members": "members",
  "tabs.metrics": "metrics",
  "tabs.organization_billing": "Overview",
  "tabs.organization_security": "Security",
  "tabs.organizations": "organizations",
  "tabs.overview": "overview",
  "tabs.payment_details": "Payment details",
  "tabs.plan": "Plans",
  "tabs.processes": "Processes",
  "tabs.profile": "my profile",
  "tabs.profiling": "profiling",
  "tabs.project": "project",
  "tabs.project_billing_details": "Billing details",
  "tabs.projects": "projects",
  "tabs.routes": "routes",
  "tabs.security": "Authentication Settings",
  "tabs.sepa": "bank account",
  "tabs.settings": "settings",
  "tabs.ssh-keys": "SSH Keys",
  "tabs.ssh_keys": "SSH keys",
  "tabs.teams": "teams",
  "tabs.tokens": "API Tokens",
  "tabs.users": "Users",
  "tabs.variables": "variables",
  "tabs.vouchers": "Vouchers",
  "tabs.yaml": "YAML",
  tac: "Terms & Conditions",
  task: "Task",
  "task_containers.column.last_run": "Latest",
  "task_containers.column.name": "Name",
  "task_containers.column.status": "Status",
  "task_containers.detail.allocation": "Allocation",
  "task_containers.detail.cpu": "CPU",
  "task_containers.detail.cpu_value": "{count} CPU",
  "task_containers.detail.last_run": "Last run: {time}",
  "task_containers.detail.profile": "Profile",
  "task_containers.detail.ram": "RAM",
  "task_containers.detail.relationships": "Relationships",
  "task_containers.detail.run_from_failed_activity":
    "Run this agent from the latest failed deployment activity.",
  "task_containers.detail.run_from_logs_page":
    "Run this agent from the <logsLink>Logs</logsLink> page.",
  "task_containers.detail.run_task": "Run task",
  "task_containers.detail.running": "Running...",
  "task_containers.detail.type": "Task",
  "task_containers.detail.version": "Version {version}",
  "task_containers.doc_url": "https://docs.upsun.com/create-apps/tasks.html",
  "task_containers.empty.body":
    "Task containers scale to zero when idle and only consume resources while running.",
  "task_containers.empty.dismiss": "Dismiss",
  "task_containers.empty.learn_more": "Learn how to add task containers.",
  "task_containers.info.body":
    "Task containers scale to zero when idle and only consume resources while running.",
  "task_containers.info.learn_more": "Learn more",
  "task_containers.last_run.never": "Never run",
  "task_containers.last_run.now": "Now",
  "task_containers.row.aria_label": "View {name} task details",
  "task_containers.run_modal.agent_engine.customize": "Customize for this run",
  "task_containers.run_modal.agent_engine.customize_hint":
    "These values apply to this run only and will not change defaults.",
  "task_containers.run_modal.agent_engine.model.helper":
    "Ensure that <code>{keyName}</code> is set as a runtime variable in your <link>project variables</link>.",
  "task_containers.run_modal.agent_engine.model.helper.anthropic_workspace":
    "Upsun only works with keys scoped to a single Anthropic workspace.",
  "task_containers.run_modal.agent_engine.provider.label": "Model provider",
  "task_containers.run_modal.agent_engine.provider.title": "AI engine",
  "task_containers.run_modal.cancel": "Cancel",
  "task_containers.run_modal.description":
    "Trigger an on-demand execution of this task. Resources will be consumed strictly for the duration of the run, and the container will scale to zero upon completion.",
  "task_containers.run_modal.error":
    "The task could not be run. Please try again.",
  "task_containers.run_modal.log_analyzer_agent.description":
    "The analyzer starts with the logs that match these filters. It may also read other logs from this environment for context.",
  "task_containers.run_modal.log_analyzer_agent.error.query_too_long":
    "The filters are too long - together they can include up to 4,096 characters.",
  "task_containers.run_modal.log_analyzer_agent.error.too_many_values":
    "Too many values in {filter} - each filter can include up to 45 values.",
  "task_containers.run_modal.log_analyzer_agent.error.value_too_long":
    "A value in {filter} is too long - each value can include up to 256 characters.",
  "task_containers.run_modal.log_analyzer_agent.error.window_invalid":
    "The time window is empty - the end time must come after the start time.",
  "task_containers.run_modal.log_analyzer_agent.error.window_too_long":
    "The time window is too long - it can cover up to 45 days.",
  "task_containers.run_modal.log_analyzer_agent.no_logs.body":
    "You can still run the analysis. The analyzer starts from these filters and time window, then widens its search to find related logs.",
  "task_containers.run_modal.log_analyzer_agent.no_logs.title":
    "No logs match these filters",
  "task_containers.run_modal.log_analyzer_agent.privacy_note":
    "Note: <link>Learn how agent data is scoped and handled</link> for privacy.",
  "task_containers.run_modal.log_analyzer_agent.run": "Analyze logs",
  "task_containers.run_modal.log_analyzer_agent.scope.excluding":
    "Excluding {values}",
  "task_containers.run_modal.log_analyzer_agent.scope.more":
    "{values}, +{count} more",
  "task_containers.run_modal.log_analyzer_agent.scope.time_window":
    "Time window:",
  "task_containers.run_modal.log_analyzer_agent.title":
    "Analyze logs on {environmentName}",
  "task_containers.run_modal.performance_agent.analysis_scope":
    "Analysis scope",
  "task_containers.run_modal.performance_agent.analyze_past.custom_helper":
    "Maximum analysis period is 7 days.",
  "task_containers.run_modal.performance_agent.analyze_past.custom_unit_label":
    "Time unit",
  "task_containers.run_modal.performance_agent.analyze_past.error_invalid":
    "Enter a whole number.",
  "task_containers.run_modal.performance_agent.analyze_past.error_out_of_range":
    "Choose between 15 minutes and 7 days.",
  "task_containers.run_modal.performance_agent.analyze_past.helper_free":
    "Your plan covers 15 minutes. For more, <link>upgrade continuous profiling</link>.",
  "task_containers.run_modal.performance_agent.analyze_past.label":
    "Analyze past",
  "task_containers.run_modal.performance_agent.analyze_past.locked_hint":
    "requires continuous profiling",
  "task_containers.run_modal.performance_agent.analyze_past.preset.15m":
    "15 min",
  "task_containers.run_modal.performance_agent.analyze_past.preset.1h": "1 hr",
  "task_containers.run_modal.performance_agent.analyze_past.preset.24h":
    "24 hr",
  "task_containers.run_modal.performance_agent.analyze_past.preset.7d":
    "7 days",
  "task_containers.run_modal.performance_agent.analyze_past.preset.custom":
    "Custom...",
  "task_containers.run_modal.performance_agent.application.label":
    "Select the application or worker",
  "task_containers.run_modal.performance_agent.applications": "Applications",
  "task_containers.run_modal.performance_agent.description":
    "Analyze recent performance for the selected application over the chosen time period.",
  "task_containers.run_modal.performance_agent.engine.customize":
    "Customize for this run",
  "task_containers.run_modal.performance_agent.engine.customize_hint":
    "These values apply to this run only and will not change defaults.",
  "task_containers.run_modal.performance_agent.engine.summary.model":
    "{provider}",
  "task_containers.run_modal.performance_agent.engine.title": "AI engine",
  "task_containers.run_modal.performance_agent.model.helper":
    "Ensure that <code>{keyName}</code> is set as a runtime variable in your <link>project variables</link>.",
  "task_containers.run_modal.performance_agent.model.helper.anthropic_workspace":
    "Upsun only works with keys scoped to a single Anthropic workspace.",
  "task_containers.run_modal.performance_agent.model.label": "Model provider",
  "task_containers.run_modal.performance_agent.workers": "Workers",
  "task_containers.run_modal.run_task": "Run",
  "task_containers.run_modal.title": "Run {taskName} task on {environmentName}",
  "task_containers.run_modal.troubleshooting_agent.api_key_hint":
    "Ensure that <code>{keyName}</code> is set in your <link>project variables</link>.",
  "task_containers.run_modal.troubleshooting_agent.description":
    "Troubleshooting Agent will review the activity log to help analyze the cause of the deployment failure.",
  "task_containers.run_modal.troubleshooting_agent.engine.customize":
    "Customize for this run",
  "task_containers.run_modal.troubleshooting_agent.engine.customize_hint":
    "These values apply to this run only and will not change defaults.",
  "task_containers.run_modal.troubleshooting_agent.engine.summary.model":
    "{provider}",
  "task_containers.run_modal.troubleshooting_agent.engine.title": "AI engine",
  "task_containers.run_modal.troubleshooting_agent.learn_more":
    "Learn more about the Troubleshooting Agent",
  "task_containers.run_modal.troubleshooting_agent.model.label":
    "Model provider",
  "task_containers.run_modal.variables.error":
    "Invalid JSON syntax, the format should be a valid flat key/value JSON.",
  "task_containers.run_modal.variables.helper":
    "Pass environment variables to this single run using a flat JSON object.",
  "task_containers.run_modal.variables.label": "Runtime variables (optional)",
  "task_containers.show_all": "Show all tasks (+{count})",
  "task_containers.show_less": "Show less",
  "task_containers.status.idle": "Idle",
  "task_containers.status.running": "Running",
  "task_containers.status.running_count": "{count} Running",
  "task_containers.tag.running": "{count} Running",
  "task_containers.title": "Tasks",
  tasks: "Tasks",
  "tasks.last_run": "Last run",
  "tasks.resources.title": "Resources",
  "tasks.yaml.empty": "No configuration found for this task.",
  "tasks.yaml.error":
    "The task configuration could not be loaded. Reload the page to try again.",
  tax_information: "Tax information",
  team_name: "team name",
  teams: "teams",
  "teams.add_users.button": "Add users",
  "teams.add_users.title": "Add users to {teamname}",
  "teams.create.form.cancel": "Cancel",
  "teams.create.form.environmenttypepermissions": "Environment type roles",
  "teams.create.form.projectadmin": "Project admin",
  "teams.create.form.projectpermissions": "Project roles",
  "teams.create.form.submit": "Create team",
  "teams.create.form.teamname.error": "This field is required.",
  "teams.create.form.teamname.label": "Team name",
  "teams.create.form.teamname.placeholder": "Enter new team name",
  "teams.create.success.description":
    "Team <b>{label}</b> has been successfully created.",
  "teams.create.success.title": "Team created",
  "teams.cta.check.it.out": "Check it out",
  "teams.cta.upgrade.plan":
    "Upgrade to Enterprise or Elite to add Teams to your organization, so you can manage groups of users more easily.",
  "teams.delete.fail.description": "{team} could not be removed.",
  "teams.delete.success.description": "{team} has successfully been deleted.",
  "teams.edit.error.description": "Couldn't update team <b>{label}</b>.",
  "teams.edit.error.title": "Unable to update team",
  "teams.edit.form.cancel": "Cancel",
  "teams.edit.form.delete": "Delete team",
  "teams.edit.form.submit": "Save",
  "teams.edit.success.title": "Team updated",
  "teams.feature.bulk.add.users": "Bulk add users to teams",
  "teams.feature.group.users": "Group users with the same permissions",
  "teams.feature.multiple.users.permissions":
    "Manage project permissions for multiple users at once",
  "teams.feature.project.access":
    "Gain easier project access control all from one place",
  "teams.list.projects.count":
    "{count} {count, plural, one{Project} other{Projects}}",
  "teams.list.row.adduser": "Add user",
  "teams.list.row.delete": "Delete team",
  "teams.list.row.edit": "Edit team",
  "teams.list.table.header.name": "Name",
  "teams.list.table.header.permissions": "Project roles",
  "teams.list.table.header.users": "Users",
  "teams.list.title": "Manage teams",
  "teams.manage.access.banner":
    "Manage user access on all projects at once in the new centralized Users page. {checkItOut}",
  "teams.member.bulk.selectedMembers":
    "{count} {count, plural, one{user} other{users}} selected",
  "teams.member.delete.modal.confirmation.description":
    "User <b>{username}</b> removed from the team <b>{teamname}</b>.",
  "teams.member.delete.modal.confirmation.title": "User removed",
  "teams.member.delete.modal.description":
    "Are you sure you want to remove <b>{username}</b> from the team <b>{teamname}</b>? ",
  "teams.member.delete.modal.title": "Remove user",
  "teams.member.permissions": "Permissions",
  "teams.members.row.delete": "Remove user",
  "teams.members.row.edit": "Edit user",
  "teams.members.table.header.email": "Email",
  "teams.members.table.header.name": "Name",
  "teams.modal.delete.message":
    "Are you sure you want to delete <b>{teamName}</b> from the organization <b>{organizationName}</b>? This will remove this team from all projects and users within this organization.",
  "teams.modal.delete.title": "Delete team",
  "teams.new.feature.tag": "New feature",
  "teams.org.cta.description":
    "Enterprise and elite plans now have access to teams. ",
  "teams.org.cta.title": "Add teams to your organization",
  "teams.projects.add.button": "Add projects",
  "teams.projects.add.button.access": "Add teams",
  "teams.projects.add.button.disabled.project": "No projects available to add",
  "teams.projects.add.button.disabled.team":
    "You need to create a team before you can add projects.",
  "teams.projects.add.card.access": "Add this project to your teams",
  "teams.projects.add.modal.confirmation.title": "Project access added",
  "teams.projects.add.title": "Add projects to your team",
  "teams.projects.delete.modal.confirmation.description":
    "Project <b>{projectname}</b> removed from the team <b>{teamname}</b>.",
  "teams.projects.delete.modal.confirmation.title": "Project access removed",
  "teams.projects.delete.modal.description":
    "Are you sure you want to remove the project <b>{projecttitle}</b> from the team <b>{teamname}</b>? ",
  "teams.projects.delete.modal.title": "Remove project",
  "teams.projects.row.delete": "Remove project",
  "teams.projects.row.edit": "Edit project access",
  "teams.projects.row.view": "View project",
  "teams.projects.table.header.id": "Project id",
  "teams.projects.table.header.name": "Name",
  "teams.users.add.button": "Add users",
  "teams.users.add.button.disabled":
    "You need to create a team before you can add users.",
  "teams.users.add.title": "Add users to your team",
  teams_org: "Organizations",
  "template.modal.cancel": "Cancel",
  "template.modal.overview": "Overview",
  "template.modal.save.blank": "Create blank project",
  "template.modal.save.template": "Select template",
  "template.modal.title.blank": "Create a blank project",
  template_filter_all_language: "All languages",
  template_filter_all_tag: "All types",
  terms_and_acceptance_checkbox:
    "I accept the <TermsLink>Terms of Service</TermsLink>, the <AUPLink>AUP</AUPLink> and <PrivacyLink>Privacy Policy</PrivacyLink>",
  terms_conditions: "Terms of Service",
  test_ideas: "{app_name} is the end-to-end web platform",
  "test_mode.active_label": "Active",
  "test_mode.description":
    "Apply test settings to change the appearance, free trial status or system status of console. These will remain until cleared manually.",
  "test_mode.page_refresh":
    "A page refresh is required to clear all settings as they're saved to your session.",
  "test_mode.system_status.select_status": "Status",
  "test_mode.system_status.title": "System status",
  "test_mode.theming.select_mode": "Mode",
  "test_mode.theming.title": "Theming",
  "test_mode.title": "Staff test mode",
  "test_mode.trial_modes.expiration_date": "Expiration date",
  "test_mode.trial_modes.select_status": "Status",
  "test_mode.trial_modes.start_date": "Start date",
  "test_mode.trial_modes.title": "Trial modes",
  tether_your_service_data: "Tether your service data using ",
  "textarea.placeholder.default": "Enter {label} here...",
  tfa: "Two-Factor Authentication",
  tfa_description:
    "Verify your account with the credentials from your two-factor authentication app.",
  theme: "Theme",
  "then.wait": "Wait at least",
  this_user_not_exist: "This user does not exist",
  three_dev_env: "3 Development environments",
  three_trial: "3 free development environments for 30 days",
  "ticket.general_support.enterprise_elite":
    "Enterprise and Elite SLAs only apply to Project support tickets, not to General support tickets.",
  "tickets.comments.add": "Add a comment",
  "tickets.comments.comment.placeholder": "Add a comment",
  "tickets.comments.header": "Comments",
  "tickets.comments.recent": "Recent comments",
  "tickets.comments.send": "Send",
  "tickets.comments.support_tag": "Support",
  "tickets.create": "Create a ticket",
  "tickets.documenttitle": "Support",
  "tickets.filter": "Filter tickets",
  "tickets.filterBy": "Filter by",
  "tickets.general.support": "General support",
  "tickets.list.community.explore": "Explore the forum",
  "tickets.list.community.header": "Community Forum",
  "tickets.list.community.paragraph":
    "Get help from our community on a wide range of topics, make feature requests and more!",
  "tickets.list.community.visit": "Visit our community forum",
  "tickets.list.header": "Support tickets",
  "tickets.list.morehelp": "Still need more help?",
  "tickets.list.quicklinks.announcements": "Announcements",
  "tickets.list.quicklinks.featureroadmap": "Feature roadmap",
  "tickets.list.quicklinks.gettingstarted": "Getting started",
  "tickets.list.quicklinks.header": "Quick Links",
  "tickets.list.quicklinks.live": "Going live",
  "tickets.list.quicklinks.paragraph":
    "Can’t find what you’re looking for? Try our quick links below to learn more or connect with your {appName} peers in the community forum.",
  "tickets.list.quicklinks.qa": "Q&A",
  "tickets.list.quicklinks.reference": "Reference & APIs",
  "tickets.list.quicklinks.requestfeature": "Request a feature",
  "tickets.list.quicklinks.tutorials": "Tutorials",
  "tickets.list.table.priority": "Priority",
  "tickets.list.table.status": "Status",
  "tickets.list.table.subject": "Subject",
  "tickets.list.table.subscription": "Project",
  "tickets.list.table.ticket_id": "#",
  "tickets.list.table.updated": "Updated",
  "tickets.more": "Show more",
  "tickets.new": "New ticket",
  "tickets.new.mobile": "New",
  "tickets.notickets": "No tickets",
  "tickets.notickets.description.community.forum":
    "You can also check out our <a>community forum</a> for more support and help.",
  "tickets.notickets.description.issues":
    "If you’re having any issues please <a>create a support ticket</a> and we’ll take a look at it for you.",
  "tickets.open.attach": "Attach file",
  "tickets.open.attach.fieldLimit": "Exceeds 50MB field limit",
  "tickets.open.attach.fileLimit": "Exceeds 20MB/file limit",
  "tickets.open.attachments": "Attachments",
  "tickets.open.bundle_size": "{MB}MB/{limit}MB total",
  "tickets.open.category": "Select category",
  "tickets.open.category.placeholder": "Select category",
  "tickets.open.description": "Description",
  "tickets.open.description.placeholder":
    "Describe the issue in as much detail as possible",
  "tickets.open.environment": "Environment",
  "tickets.open.environment.placeholder": "Select environment",
  "tickets.open.general.question": "General question (not project related)",
  "tickets.open.invalidurl": "The format of the affected URL is not valid",
  "tickets.open.priority": "Select priority",
  "tickets.open.priority.placeholder": "Select priority",
  "tickets.open.priorityDialog.link": "documentation",
  "tickets.open.priorityDialog.text":
    "Not sure which level of urgency your ticket requires? Take a look at our",
  "tickets.open.project": "Project",
  "tickets.open.project.placeholder": "Select project",
  "tickets.open.subject": "Ticket subject",
  "tickets.open.url": "Affected URL",
  "tickets.open.url.placeholder": "Enter URL",
  "tickets.priority.contact.sales": "Contact sales to upgrade",
  "tickets.priority.high.description":
    "Severe failures or high-impact issues affecting a production site.",
  "tickets.priority.high.elite": "SLA 4 hours, 24x7",
  "tickets.priority.high.enterprise": "SLA 8 regular support hours",
  "tickets.priority.high.label": "High",
  "tickets.priority.high.premier": "SLA 48 hours",
  "tickets.priority.low.description":
    "Does not significantly impact a production site or the use of non-production environments.",
  "tickets.priority.low.elite": "No SLA",
  "tickets.priority.low.enterprise": "No SLA",
  "tickets.priority.low.label": "Low",
  "tickets.priority.low.premier": "SLA 72 hours",
  "tickets.priority.normal.description":
    "Minor effect on a production site or blocking development of non-production environments.",
  "tickets.priority.normal.elite": "SLA 8 hours, 24x7",
  "tickets.priority.normal.enterprise": "SLA 24 regular support hours",
  "tickets.priority.normal.label": "Normal",
  "tickets.priority.normal.premier": "SLA 72 hours",
  "tickets.priority.professional.contact":
    "Upgrade to Enterprise for SLA Support",
  "tickets.priority.sticker.high.elite": "4 hours, 24x7",
  "tickets.priority.sticker.high.enterprise": "8 regular support hours",
  "tickets.priority.sticker.high.premier": "48 hours",
  "tickets.priority.sticker.low.premier": "72 hours",
  "tickets.priority.sticker.normal.elite": "8 hours, 24x7",
  "tickets.priority.sticker.normal.enterprise": "24 regular support hours",
  "tickets.priority.sticker.normal.premier": "72 hours",
  "tickets.priority.sticker.urgent.elite": "45 minutes, 24x7",
  "tickets.priority.sticker.urgent.enterprise": "1 hour, 24x7",
  "tickets.priority.sticker.urgent.premier": "4 hours",
  "tickets.priority.urgent.description":
    "Total failure or unavailability of a production site - page a support engineer.",
  "tickets.priority.urgent.elite": "SLA 45 minutes, 24x7",
  "tickets.priority.urgent.enterprise": "SLA 1 hour, 24x7",
  "tickets.priority.urgent.label": "Urgent",
  "tickets.priority.urgent.premier": "SLA 4 hours",
  "tickets.project.support": "Project support",
  "tickets.show": "Show",
  "tickets.sort": "Sort by",
  "tickets.sortby.created.label": "Date created",
  "tickets.sortby.priority.label": "Priority",
  "tickets.sortby.project.label": "Project id",
  "tickets.sortby.status.label": "Status",
  "tickets.sortby.subject.label": "Alphabetically A-Z",
  "tickets.sortby.ticket_id.label": "#",
  "tickets.sortby.updated.label": "Last updated",
  "tickets.status.closed.label": "Closed",
  "tickets.status.deleted.label": "Deleted",
  "tickets.status.hold.label": "On-hold",
  "tickets.status.new.label": "New",
  "tickets.status.open.label": "Open",
  "tickets.status.pending.label": "Awaits reply",
  "tickets.status.solved.label": "Solved",
  "tickets.sticker": " {priority} priority SLA : ",
  "tickets.sticker.low": " Tickets with low priority do not include an SLA. ",
  "tickets.sticker.professional.support": "{supportTier} support.",
  "tickets.support_addon.advanced": "Advanced",
  "tickets.support_addon.current_tier": "Current tier",
  "tickets.support_addon.explanation":
    "Your organization's support tier determines your response times.",
  "tickets.support_addon.explanation_upgrade":
    " Upgrade to receive faster assistance.",
  "tickets.support_addon.get_faster_support_times": "Get faster support times",
  "tickets.support_addon.high": "High",
  "tickets.support_addon.learn_more": "Learn more",
  "tickets.support_addon.normal": "Normal",
  "tickets.support_addon.premium": "Premium",
  "tickets.support_addon.response_time.high-advanced": "6 business hours",
  "tickets.support_addon.response_time.high-premium": "3 hours, 24x7",
  "tickets.support_addon.response_time.high-standard": "24 business hours",
  "tickets.support_addon.response_time.normal-advanced": "12 business hours",
  "tickets.support_addon.response_time.normal-premium": "8 hours, 24x7",
  "tickets.support_addon.response_time.normal-standard": "48 business hours",
  "tickets.support_addon.response_time.urgent-advanced": "1 hour, 24x7",
  "tickets.support_addon.response_time.urgent-premium": "30 minutes, 24x7",
  "tickets.support_addon.response_time.urgent-standard": "4 hours, 24x7",
  "tickets.support_addon.select_a_project":
    "Select a project to see your current support tier.",
  "tickets.support_addon.standard": "Standard",
  "tickets.support_addon.support_tier_response_times":
    "Support tier response times",
  "tickets.support_addon.upgrade": "Upgrade",
  "tickets.support_addon.upgrade_request":
    "Ask your organization admin to upgrade",
  "tickets.support_addon.urgent": "Urgent",
  "tickets.view.description": "Description",
  "tickets.view.followup": "Create follow-up",
  "tickets.view.info.environment": "Environment",
  "tickets.view.info.header": "Ticket #{ticketId}",
  "tickets.view.info.priority": "Priority",
  "tickets.view.info.projectId": "Project ID",
  "tickets.view.info.region": "Region",
  "tickets.view.markedas": "Ticket marked <status></status> on {date}.",
  "tickets.view.reopen": "Re-open ticket",
  "tickets.view.solve": "Solve ticket",
  time_input_tip: "Enter time in 24-hour (23:59) format",
  timezone: "timezone",
  title: "Title",
  tls_min_version: "TLS min version",
  to: "to",
  to_be: "to be",
  to_configure_app: "to configure your app",
  to_define_urls: "to define how incoming URLs are processed",
  to_receive_new_link:
    "To receive a new link via email you’ll need to reset your password again.",
  to_reset_your_password:
    "To reset your password click the link in the confirmation email we just sent you.",
  to_set_up_services: "to set up databases, caches, and other services",
  toggle_details: "Toggle details",
  "tooltip.dunning.deleted.description":
    "<p>We are unable to process your payment after multiple attempts, so your organization has been suspended. While your organization is suspended, your projects are not running. Also, you will not be able to:</p><ul><li>Edit or delete your organization</li><li>Invite, edit, or delete organization members</li><li>Create, edit, or delete projects and project resources</li></ul><p>Update your <linkBilling>billing details</linkBilling> to regain full control of your organization.</p>",
  "tooltip.dunning.deleted.title": "Your organization is suspended",
  "tooltip.dunning.restricted.description":
    "<p>Your payment failed, so your organization is restricted. While your organization is restricted, your projects are still running. However, you will not be able to:</p><ul><li>Edit or delete your organization</li><li>Invite, edit, or delete organization members</li><li>Create, edit, or delete projects and project resources</li></ul><p>Update your <linkBilling>billing details</linkBilling> to regain full control of your organization.</p>",
  "tooltip.dunning.restricted.title": "Your organization is restricted",
  "tooltip.dunning.suspended.description":
    "<p>We are unable to process your payment after multiple attempts, so your organization has been suspended. While your organization is suspended, your projects are not running. Also, you will not be able to:</p><ul><li>Edit or delete your organization</li><li>Invite, edit, or delete organization members</li><li>Create, edit, or delete projects and project resources</li></ul><p>Update your <linkBilling>billing details</linkBilling> to regain full control of your organization.</p>",
  "tooltip.dunning.suspended.title": "Your organization is suspended",
  "tooltip.projectCreation.connectionLost.message":
    "We lost contact with the provisioning service. Refresh the page to reconnect.",
  "tooltip.projectCreation.connectionLost.title": "Connection lost",
  "tooltip.projectCreation.error":
    "{projectName} could not be created. Please try again.",
  "tooltip.projectCreation.error.short": "Failed",
  total: "Total",
  total_allocation: "Total Allocation",
  total_bandwidth: "Total bandwidth",
  total_monthly_cost: "Total monthly cost",
  total_monthly_payment: "total monthly payment",
  total_usage: "Usage summary",
  "traffic.modal.alert.error.description":
    "There was a problem saving your alert, please try again later.",
  "traffic.modal.alert.error.title": "Traffic alert has NOT been updated",
  "traffic.modal.alert.success.description":
    "The changes to your traffic alert has been saved successfully.",
  "traffic.modal.alert.success.title": "Traffic alert has been updated",
  "traffic.modal.description":
    "Create an alert to monitor the <strong>traffic bandwidth and requests</strong> for {projectTitle}. Users with a <tag>Manage billing</tag> permission will receive an email when your traffic resources reach one of the threshold specified below.",
  "traffic.modal.label.cdn-bandwidth-threshold": "CDN bandwidth threshold",
  "traffic.modal.label.cdn-requests-threshold": "CDN requests threshold",
  "traffic.modal.label.enable-cdn-bandwidth-alert":
    "Enable CDN bandwidth alert",
  "traffic.modal.label.enable-cdn-requests-alert": "Enable CDN requests alert",
  "traffic.modal.label.enable-origin-bandwidth-alert":
    "Enable origin bandwidth alert",
  "traffic.modal.label.enable-origin-requests-alert":
    "Enable origin requests alert",
  "traffic.modal.label.origin-bandwidth-threshold":
    "Origin bandwidth threshold",
  "traffic.modal.label.origin-requests-threshold": "Origin requests threshold",
  "traffic.modal.label.unit.m": "M requests",
  "traffic.modal.label.unit.tb": "TB",
  "traffic.modal.save": "Save alerts",
  "traffic.modal.title": "Set traffic alert",
  "trial-remaining.button": "Upgrade now",
  "trial-remaining.credit.label": "Free trial credit",
  "trial-remaining.credit.value": "{credit} of free trial credit remaining",
  "trial-remaining.expiration.label": "Expires",
  "trial-remaining.plan.name": "Free trial",
  "trial.modal.welcome.text":
    "Creating your first project starts your free trial, where you can spend up to {amount} in the next {duration, plural, one {day} other {{duration} days}}. At the end of your trial you'll be prompted to add your billing details to keep your projects running.",
  "trial.modal.welcome.title": "Free trial starting",
  "trial.modal.welcome.voucher":
    "<b>Have a voucher?</b> <link>Redeem now</link> to get even more benefits.",
  "trial_dialog.consumption": "Resource consumption",
  "trial_dialog.create_project":
    "Create a project to get the most out of your free trial.",
  "trial_dialog.more_time": "Need more time? Reach out to <a>support</a>",
  "trial_dialog.project_being_created": "Project being created",
  "trial_dialog.remaining_days":
    "{count, plural, =0 {# Day} one {# Day} other {# Days}} left",
  "trial_dialog.remaining_environments": "{used}/{limit} environment used",
  "trial_dialog.resources_limit":
    "Your free trial includes {projects, plural, =0 {} one {# project, } other {# projects, }}{environments, plural, =0 {} one {# environement, } other {# environments, }}{cpu} CPU, {memory}GB RAM and {storage}GB Disk.",
  "trial_dialog.sellables":
    "<linkContinuousProfiling>Continuous profiling</linkContinuousProfiling> is free during your free trial",
  "trial_state.free_trial": "Free trial",
  "trial_state.suspended": "Suspended",
  "trial_state.trial_ending": "Trial expires soon",
  tried_running_cron: "tried to run cron",
  tried_running_task: "tried to run task",
  "troubleshooting_agent.cta": "Troubleshoot",
  "troubleshooting_agent.cta.running": "Troubleshooting...",
  "troubleshooting_agent.panel.collapse": "Collapse panel",
  "troubleshooting_agent.panel.preview_note":
    "This preview closes with this window. You can view it again anytime inside the new activity.",
  "troubleshooting_agent.panel.preview_tag": "Preview",
  "troubleshooting_agent.panel.running":
    "Troubleshooting Agent activity running...",
  "troubleshooting_agent.panel.title": "Run Troubleshooting Agent",
  "troubleshooting_agent.panel.title_running":
    "Run Troubleshooting Agent on {environmentName}",
  "troubleshooting_agent.panel.view_activity": "View new activity",
  "troubleshooting_agent.toast.completed.description":
    "{environmentName} has a new report on the failed deployment.",
  "troubleshooting_agent.toast.completed.link": "View the report",
  "troubleshooting_agent.toast.completed.title":
    "Troubleshooting report has completed!",
  "troubleshooting_agent.toast.started.description":
    "Follow your report progress in the environment activity stream.",
  "troubleshooting_agent.toast.started.link": "Open activity",
  "troubleshooting_agent.toast.started.title":
    "Troubleshooting Agent has started",
  "trustcenter.content":
    "Have a security, privacy, legal, or other compliance-related question? Check out our Trust Center for detailed information.",
  "trustcenter.link": "Visit trust center",
  "trustcenter.title": "Trust center",
  try_for_free: "try for free",
  try_platform: "try {app_name} today with no strings attached!",
  try_today: "try our free trial today",
  try_us_for_free: "try us for free",
  tunnel: "tunnel",
  type: "type",
  ui_color_scheme_help_text:
    "Apply your accessibility display settings to the console. <cta>{verb}</cta> about our accessibility features and ratings.",
  unknown: "unknown",
  unknown_activity: "unknown activity",
  unlimited_traffic: "Unlimited web traffic",
  upcoming_invoice: "Upcoming invoice",
  update: "Update",
  update_bank_account: "Update bank account",
  update_billing: "update billing",
  update_credit_card: "Update credit card",
  updated: "updated",
  updated_HTTP_Access_settings_on_environment:
    "updated HTTP Access settings on environment",
  updated_SMTP_settings_on_environment: "updated SMTP settings on environment",
  updated_domain: "updated domain",
  updated_environment_variable: "updated environment variable",
  updated_moment: "Updated {moment}",
  updated_project_variable: "updated project variable",
  "updated_the_robots.txt_settings_on_environment":
    "updated the robots.txt settings on environment",
  upgrade: "Upgrade",
  upgrade_guide: "Upgrade guide",
  upgrade_to_observability_suite_description:
    "Unlock Continuous Profiling, longer timeframes for infrastructure metrics, Blackfire APM & Profiler, and logs forwarding",
  upgrade_to_observability_suite_title: "Upgrade to Observability Suite",
  upgrade_to_standard_add_on: "upgrade to our Advanced add-on.",
  upgrade_to_version: "upgrade to version",
  upgraded_to_version: "upgraded to version",
  upload: "upload",
  upload_image: "upload image",
  upstream: "Upstream",
  url: "URL",
  urls: "URLs",
  usage: "usage",
  use_recovery_code: "use your recovery code",
  use_tfa: "Use my TFA verification code",
  use_your_email: "Sign up using your email",
  user: "user",
  user_details: "User details",
  user_email: "user email",
  user_name: "User name",
  user_settings: "User settings",
  username: "Username",
  username_characters: "Only lowercase letters, numbers, hyphens are allowed",
  username_error_message:
    "The username must be between 3-39 characters long and can only contain lowercase alphanumerical characters, and non-consecutive dashes.",
  username_guidelines:
    "Your username cannot include spaces or special characters. This will be displayed as your URL. e.g.",
  username_length: "Must be between 3-32 characters",
  username_notice: "Your username will also become your unique {app_name} URL",
  usernames: "usernames",
  users: "users",
  users_description: "{price} per user per month",
  value: "Value",
  "variable.restricted_apps.tooltip": "Restricted, but no application selected",
  variables: "variables",
  variables_info:
    "Variables are optional, depending on how your operation is configured.",
  vat_number: "VAT number",
  verification_code: "Verification code",
  verify: "Verify",
  verify_account:
    "verify your account by clicking the link in the confirmation email we just sent you.",
  version: "version",
  view: "view",
  view_all: "View all",
  view_all_blog: "View all blog",
  view_all_projects: "View all projects",
  view_all_status: "View all status",
  view_billing: "View billing",
  view_billing_details: "View billing details",
  view_details: "View details",
  view_documentation: "View documentation",
  view_invoices: "View invoices",
  view_metrics: "View graphs",
  view_pricing: "View Pricing",
  view_profiling: "View profiling",
  view_settings: "View settings",
  view_team: "View team",
  visible: "visible",
  "visually_hidden.link_opens_in_new_window": "Opens a new window.",
  "voucher.balance": "Balance <b>{balance}</b>",
  "voucher.credit": "Credit <b>{credit}</b>",
  "voucher.empty.intro":
    "Redeem your voucher to get even more benefits from {appName}.{br}Your voucher credit will be deducted from your upcoming invoice.",
  "voucher.empty.title": "Have a voucher?",
  "voucher.end_date": "End date:",
  "voucher.form.code": "Voucher code",
  "voucher.form.submit": "Redeem",
  "voucher.form.title": "Redeem your voucher",
  "voucher.invoice.credit": "Credit used to date",
  "voucher.invoice.date": "Invoice date",
  "voucher.invoice.number": "Invoice number",
  "voucher.invoice.status": "Invoice status",
  "voucher.list.headers.balance": "Balance",
  "voucher.list.headers.code": "Code",
  "voucher.list.headers.credit": "Credit",
  "voucher.list.headers.status": "Status",
  "voucher.list.status.completed": "Completed",
  "voucher.list.status.expired": "Expired",
  "voucher.list.status.in_use": "In use",
  "voucher.list.status.scheduled": "Scheduled",
  "voucher.order.credit": "Credit used to date",
  "voucher.order.date": "Order date",
  "voucher.order.number": "Order number",
  "voucher.order.status": "Order status",
  "voucher.start_date": "Start date:",
  voucher_credit: "Voucher credit",
  vouchers: "Vouchers",
  "vouchers.add": "Redeem voucher",
  "vouchers.intro":
    "Redeem your voucher to get even more benefits from {appName}. Your voucher credit will be deducted from your upcoming invoice.",
  wait_i_remember: "wait, I remember my password",
  web_platform: "web platform",
  website: "website URL",
  welcome: "welcome to {app_name}",
  "welcome.description":
    "Let’s get your account set up. Tell us where you are, and create your password to begin.",
  "welcome.select_country": "Select country",
  "welcome.title": "Welcome to {app_name}",
  "when.instances": "When",
  when_ready:
    "When you’re ready to launch, get multicloud production hosting and 24/7 support – for 1 site or 1,000",
  white_label: "white label",
  with: "with",
  with_profile: "with profile",
  with_psh_you_can: "With {app_name} you can",
  "wizard.finish": "Finish",
  "wizard.intro.sentence":
    "To get your project set up and running, step through our wizard or jump to the steps you need.",
  "wizard.intro.start": "Start",
  "wizard.intro.title":
    "Congrats! Your new project {name} has just been created.",
  "wizard.list.steps.finish": "Setup steps",
  "wizard.list.steps.optional": "(Opt)",
  "wizard.list.steps.start": "What to expect",
  "wizard.outro.sentence":
    "You’re good to go! Check out our documentation for common next steps like adding a service and adding users to your project. When you’re ready to go live{plan, select, development { you'll need to upgrade to a production plan} other {, <a>add a domain</a>}}.",
  "wizard.outro.title": "Awesome sauce!{br}{name}'s now initialized on {app}",
  "wizard.outro.title.first_line": "Awesome sauce!",
  "wizard.outro.title.second_line": "{name}'s",
  "wizard.outro.title.third_line": "now initialized on {app}",
  "wizard.outro.view_doc": "View documentation",
  "wizard.project.provisioning.adobe.credentials":
    "Adobe Commerce Cloud requires that you have proper credentials to download the base package. Please get your credentials at <link>magento.com</link> and paste them here. Those will automatically be added to your <code>auth.json</code> file in your Git repository. ",
  "wizard.project.provisioning.blank": "Create a blank site from a template",
  "wizard.project.provisioning.call.project":
    "What do you want to call your project ?",
  "wizard.project.provisioning.continue": "Continue Later",
  "wizard.project.provisioning.enter.credentials":
    "Enter authentication credentials",
  "wizard.project.provisioning.existing.code": "Import your existing code",
  "wizard.project.provisioning.further":
    "Before we go further, you should push some code to your Git repository.",
  "wizard.project.provisioning.importing": "Importing your code.",
  "wizard.project.provisioning.link.support":
    "https://experienceleague.adobe.com/docs/commerce-cloud-service/user-guide/overview.html",
  "wizard.project.provisioning.link.support.url":
    "https://www.magentocommerce.com/magento-connect/customerdata/accessKeys/list/",
  "wizard.project.provisioning.moreinfo":
    "More information can be found in our",
  "wizard.project.provisioning.moreinfo.url":
    "https://experienceleague.adobe.com/docs/commerce.html",
  "wizard.project.provisioning.password": "Password (private repo key)",
  "wizard.project.provisioning.push": "git push -u magento-cloud master",
  "wizard.project.provisioning.push.repository":
    "Push an <strong>existing repository</strong> in command line",
  "wizard.project.provisioning.remote": "git remote add magento-cloud {url}",
  "wizard.project.provisioning.repository": "Your Git repository is",
  "wizard.project.provisioning.services":
    "Remember to add a <em>.magento.app.yaml</em> to configure your app, <em>.magento/services.yaml</em> to set up services (databases, caches, search engines ...), and <em>.magento/routes.yaml</em> to define how an incoming URL is processed.",
  "wizard.project.provisioning.setting.project": "Setting up your project",
  "wizard.project.provisioning.start": "Where do you want to start ?",
  "wizard.project.provisioning.supports":
    "Magento Cloud supports PHP, NodeJS, Ruby (beta) and Python (beta) applications. To deploy an existing application you need to upload your code, database and files, and add some configuration files which define your infrastructure. Please check our detailed documentation at <link>https://experienceleague.adobe.com/docs/commerce-cloud-service/user-guide/overview.html</link> to get started.",
  "wizard.project.provisioning.template":
    "We can automatically generate and setup for you a website based on some preconfigured settings and templates.",
  "wizard.project.provisioning.username": "Username (public repo key)",
  "wizard.ssh.saved": "SSH Key has been added",
  "wizard.step.optional": "(Optional)",
  "wizard.steps.dropdown": "{current} of {total}",
  worker: "Worker",
  workers: "workers",
  x_commit_ahead:
    "{commit, number} {commit, plural, one {commit} other {commits}} ahead",
  xlarge_description: "high-traffic complex applications",
  xxlarge_description: "high-traffic, resource intensive complex apps",
  yaml_app_default: "# Select a runtime to begin",
  yaml_app_description:
    "# The name of this app. Must be unique within a project.\nname: app\n\n",
  yaml_disk_description:
    "\n\n# The size of the persistent disk of the application (in MB).\ndisk: ",
  yaml_mount_description:
    "\n\n# The following block defines a single writable directory, 'web/uploads'\n# The 'source' specifies where the writable mount is. The 'local' source\n# indicates that the mount point will point to a local directory on the\n# application container. The 'source_path' specifies the subdirectory\n# from within the source that the mount should point at. \nmounts:\n  'web/uploads':\n    source: local\n    source_path: uploads",
  yaml_relationship_description:
    "\n\n# The relationships of the application with services or other applications.\n#\n# The left-hand side is the name of the relationship as it will be exposed\n# to the application in the PLATFORM_RELATIONSHIPS variable. The right-hand\n# side is in the form '<service name>:<endpoint name>'.\nrelationships:\n",
  yaml_routes_description:
    "# Each route describes how an incoming URL is going to be processed by {appName}.",
  yaml_service_default: "# Select a service to begin",
  yes: "Yes",
  yes_authorize: "Yes, authorize",
  you_can_connect_external_provider:
    "You can connect your account with these external providers.",
  your_activity: "Your activity",
  your_app: "your app",
  your_can_now_use_new_password: "You can now use your new password to log in.",
  your_password_reset: "Your password was successfully reset!",
  your_projects: "Your projects",
  your_regions: "your regions",
  zip: "ZIP code",
  zip_postal_code: "ZIP / Postal code",
  "zip_postal_code.placeholder": "ZIP"
};

export default en;
